{
  "madsrdf": "http://www.loc.gov/mads/rdf/v1#",
  "bflc": "http://id.loc.gov/ontologies/bflc/",
  "foaf": "http://xmlns.com/foaf/0.1/",
  "rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  "dbo": "http://dbpedia.org/ontology/",
  "rdfs": "http://www.w3.org/2000/01/rdf-schema#",
  "yago": "http://yago-knowledge.org/resource/",
  "dc": "http://purl.org/dc/elements/1.1/",
  "dbp": "http://dbpedia.org/property/",
  "owl": "http://www.w3.org/2002/07/owl#",
  "skos": "http://www.w3.org/2004/02/skos/core#",
  "gr": "http://purl.org/goodrelations/v1#",
  "geo": "http://www.opengis.net/ont/geosparql#",
  "spacerel": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "xsd": "http://www.w3.org/2001/XMLSchema#",
  "ex": "http://example.org/",
  "dcat": "http://www.w3.org/ns/dcat#",
  "org": "http://www.w3.org/ns/org#",
  "dct": "http://purl.org/dc/terms/",
  "dcterms": "http://purl.org/dc/terms/",
  "qb": "http://purl.org/linked-data/cube#",
  "prov": "http://www.w3.org/ns/prov#",
  "sioc": "http://rdfs.org/sioc/ns#",
  "xtypes": "http://purl.org/xtypes/",
  "dbpedia": "http://dbpedia.org/resource/",
  "void": "http://rdfs.org/ns/void#",
  "ont": "http://purl.org/net/ns/ontology-annot#",
  "onto": "http://www.ontotext.com/",
  "sio": "http://semanticscience.org/resource/",
  "obo": "http://purl.obolibrary.org/obo/",
  "dcterm": "http://purl.org/dc/terms/",
  "schema": "http://schema.org/",
  "bf": "http://id.loc.gov/ontologies/bibframe/",
  "search": "http://sindice.com/vocab/search#",
  "sd": "http://www.w3.org/ns/sparql-service-description#",
  "frbr": "http://purl.org/vocab/frbr/core#",
  "stat": "http://www.w3.org/ns/posix/stat#",
  "vcard": "http://www.w3.org/2006/vcard/ns#",
  "commerce": "http://purl.org/commerce#",
  "dbr": "http://dbpedia.org/resource/",
  "bibo": "http://purl.org/ontology/bibo/",
  "pto": "http://www.productontology.org/id/",
  "rss": "http://purl.org/rss/1.0/",
  "oo": "http://purl.org/openorg/",
  "gldp": "http://www.w3.org/ns/people#",
  "geonames": "http://www.geonames.org/ontology#",
  "content": "http://purl.org/rss/1.0/modules/content/",
  "fb": "http://rdf.freebase.com/ns/",
  "vann": "http://purl.org/vocab/vann/",
  "event": "http://purl.org/NET/c4dm/event.owl#",
  "wd": "http://www.wikidata.org/entity/",
  "gen": "http://purl.org/gen/0.1#",
  "dcmit": "http://purl.org/dc/dcmitype/",
  "cc": "http://creativecommons.org/ns#",
  "http": "http://www.w3.org/2011/http#",
  "dbpprop": "http://dbpedia.org/property/",
  "doap": "http://usefulinc.com/ns/doap#",
  "tag": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "rr": "http://www.w3.org/ns/r2rml#",
  "swrc": "http://swrc.ontoware.org/ontology#",
  "nie": "http://www.semanticdesktop.org/ontologies/2007/01/19/nie#",
  "leaks": "https://cuzin.com/",
  "sc": "https://schema.org/",
  "md": "http://www.w3.org/ns/md#",
  "drugbank": "http://www4.wiwiss.fu-berlin.de/drugbank/resource/drugbank/",
  "as": "https://www.w3.org/ns/activitystreams#",
  "fn": "http://www.w3.org/2005/xpath-functions#",
  "cv": "http://rdfs.org/resume-rdf/",
  "prog": "http://purl.org/prog/",
  "wot": "http://xmlns.com/wot/0.1/",
  "aiiso": "http://purl.org/vocab/aiiso/schema#",
  "ma": "http://www.w3.org/ns/ma-ont#",
  "uniprot": "http://purl.uniprot.org/uniprot/",
  "tl": "http://purl.org/NET/c4dm/timeline.owl#",
  "akt": "http://www.aktors.org/ontology/portal#",
  "daia": "http://purl.org/ontology/daia/",
  "swc": "http://data.semanticweb.org/ns/swc/ontology#",
  "ical": "http://www.w3.org/2002/12/cal/ical#",
  "xhtml": "http://www.w3.org/1999/xhtml#",
  "crm": "http://www.cidoc-crm.org/cidoc-crm/",
  "rel": "http://purl.org/vocab/relationship/",
  "bio": "http://purl.org/vocab/bio/0.1/",
  "earl": "http://www.w3.org/ns/earl#",
  "unit": "http://qudt.org/vocab/unit/",
  "mo": "http://purl.org/ontology/mo/",
  "dv": "http://rdf.data-vocabulary.org/#",
  "ov": "http://open.vocab.org/terms/",
  "marcrel": "http://id.loc.gov/vocabulary/relators/",
  "rdfg": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "xhv": "http://www.w3.org/1999/xhtml/vocab#",
  "cs": "http://purl.org/vocab/changeset/schema#",
  "afn": "http://jena.apache.org/ARQ/function#",
  "ad": "http://schemas.talis.com/2005/address/schema#",
  "vs": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "co": "http://purl.org/ontology/co/core#",
  "dc11": "http://purl.org/dc/elements/1.1/",
  "og": "http://opengraphprotocol.org/schema/",
  "air": "http://dig.csail.mit.edu/TAMI/2007/amord/air#",
  "xs": "http://www.w3.org/2001/XMLSchema#",
  "mu": "http://mu.semte.ch/vocabularies/core/",
  "bill": "http://www.rdfabout.com/rdf/schema/usbill/",
  "test2": "http://this.invalid/test2#",
  "book": "http://purl.org/NET/book/vocab#",
  "musim": "http://purl.org/ontology/similarity/",
  "log": "http://www.w3.org/2000/10/swap/log#",
  "xfn": "http://gmpg.org/xfn/11#",
  "factbook": "http://wifo5-04.informatik.uni-mannheim.de/factbook/ns#",
  "media": "http://search.yahoo.com/searchmonkey/media/",
  "dcq": "http://purl.org/dc/qualifiers/1.0/",
  "ome": "http://purl.org/ontomedia/core/expression#",
  "xf": "http://www.w3.org/2002/xforms/",
  "prop": "http://dbpedia.org/property/",
  "cld": "http://purl.org/cld/terms/",
  "d2rq": "http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#",
  "qudt": "http://qudt.org/schema/qudt/",
  "ir": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "cal": "http://www.w3.org/2002/12/cal/ical#",
  "biblio": "http://purl.org/net/biblio#",
  "reco": "http://purl.org/reco#",
  "ttp": "http://eample.com/test#",
  "rev": "http://purl.org/stuff/rev#",
  "sism": "http://purl.oclc.org/NET/sism/0.1/",
  "dbowl": "http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#",
  "days": "http://ontologi.es/days#",
  "osag": "http://www.ordnancesurvey.co.uk/ontology/AdministrativeGeography/v2.0/AdministrativeGeography.rdf#",
  "botany": "http://purl.org/NET/biol/botany#",
  "af": "http://purl.org/ontology/af/",
  "rif": "http://www.w3.org/2007/rif#",
  "dir": "http://schemas.talis.com/2005/dir/schema#",
  "ctag": "http://commontag.org/ns#",
  "ok": "http://okkam.org/terms#",
  "tzont": "http://www.w3.org/2006/timezone#",
  "cmp": "http://www.ontologydesignpatterns.org/cp/owl/componency.owl#",
  "sr": "http://www.openrdf.org/config/repository/sail#",
  "pc": "http://purl.org/procurement/public-contracts#",
  "math": "http://www.w3.org/2000/10/swap/math#",
  "admin": "http://webns.net/mvcb/",
  "myspace": "http://purl.org/ontology/myspace#",
  "memo": "http://ontologies.smile.deri.ie/2009/02/27/memo#",
  "giving": "http://ontologi.es/giving#",
  "sdmx": "http://purl.org/linked-data/sdmx#",
  "xmp": "http://ns.adobe.com/xap/1.0/",
  "cfp": "http://sw.deri.org/2005/08/conf/cfp.owl#",
  "dcn": "http://www.w3.org/2007/uwa/context/deliverycontext.owl#",
  "lomvoc": "http://ltsc.ieee.org/rdf/lomv1p0/vocabulary#",
  "swanq": "http://purl.org/swan/1.2/qualifiers/",
  "time": "http://www.w3.org/2006/time#",
  "jdbc": "http://d2rq.org/terms/jdbc/",
  "lyou": "http://purl.org/linkingyou/",
  "owlim": "http://www.ontotext.com/trree/owlim#",
  "omn": "http://open-multinet.info/ontology/omn#",
  "dcam": "http://purl.org/dc/dcam/",
  "swande": "http://purl.org/swan/1.2/discourse-elements/",
  "gn": "http://www.geonames.org/ontology#",
  "nif": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#",
  "skosxl": "http://www.w3.org/2008/05/skos-xl#",
  "con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "cyc": "http://sw.opencyc.org/concept/",
  "adms": "http://www.w3.org/ns/adms#",
  "oa": "http://www.w3.org/ns/oa#",
  "cdm": "http://publications.europa.eu/ontology/cdm#",
  "gvp": "http://vocab.getty.edu/ontology#",
  "openlinks": "http://www.openlinksw.com/schemas/virtrdf#",
  "ontology": "http://dbpedia.org/ontology/",
  "sdmxdim": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "db": "http://dbpedia.org/",
  "sh": "http://www.w3.org/ns/shacl#",
  "type": "http://teste.com/teste/",
  "om": "http://opendata.caceres.es/def/ontomunicipio#",
  "isbd": "http://iflastandards.info/ns/isbd/elements/",
  "lemon": "http://lemon-model.net/lemon#",
  "photoshop": "http://ns.adobe.com/photoshop/1.0/",
  "aat": "http://vocab.getty.edu/aat/",
  "eat": "http://www.eat.rl.ac.uk/#",
  "wfs": "http://schemas.opengis.net/wfs/",
  "room": "http://vocab.deri.ie/rooms#",
  "wdt": "http://www.wikidata.org/prop/direct/",
  "exif": "http://www.w3.org/2003/12/exif/ns#",
  "tgn": "http://vocab.getty.edu/tgn/",
  "ac": "http://umbel.org/umbel/ac/",
  "fabio": "http://purl.org/spar/fabio/",
  "ulan": "http://vocab.getty.edu/ulan/",
  "test": "https://test4.example.com/",
  "ore": "http://www.openarchives.org/ore/terms/",
  "xsi": "http://www.w3.org/2001/XMLSchema-instance#",
  "sdmxa": "http://purl.org/linked-data/sdmx/2009/attribute#",
  "cert": "http://www.w3.org/ns/auth/cert#",
  "prism": "http://prismstandard.org/namespaces/basic/2.0/",
  "itsrdf": "http://www.w3.org/2005/11/its/rdf#",
  "cnt": "http://www.w3.org/2011/content#",
  "fise": "http://fise.iks-project.eu/ontology/",
  "nsogi": "http://prefix.cc/nsogi:",
  "core": "http://vivoweb.org/ontology/core#",
  "sf": "http://www.opengis.net/ont/sf#",
  "dul": "http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#",
  "voaf": "http://purl.org/vocommons/voaf#",
  "edm": "http://www.europeana.eu/schemas/edm/",
  "swrl": "http://www.w3.org/2003/11/swrl#",
  "swrcfe": "http://www.morelab.deusto.es/ontologies/swrcfe#",
  "lv": "http://purl.org/lobid/lv#",
  "eg": "http://www.example.org/",
  "gndo": "http://d-nb.info/standards/elementset/gnd#",
  "gtfs": "http://vocab.gtfs.org/terms#",
  "urn": "http://fliqz.com/",
  "dbc": "http://dbpedia.org/resource/Category:",
  "ro": "http://purl.org/wf4ever/ro#",
  "nfo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#",
  "swrlb": "http://www.w3.org/2003/11/swrlb#",
  "xml": "http://www.w3.org/XML/1998/namespace/",
  "ssn": "http://www.w3.org/ns/ssn/",
  "movie": "http://data.linkedmdb.org/resource/movie/",
  "music": "http://musicontology.com/",
  "bif": "http://www.openlinksw.com/schemas/bif#",
  "wikidata": "http://www.wikidata.org/entity/",
  "dbprop": "http://dbpedia.org/property/",
  "go": "http://purl.obolibrary.org/obo/GO_",
  "leak": "http://maco.com/",
  "wp": "http://vocabularies.wikipathways.org/",
  "pat": "http://purl.org/hpi/patchr#",
  "ceo": "https://linkeddata.cultureelerfgoed.nl/def/ceo#",
  "cco": "http://www.ontologyrepository.com/CommonCoreOntologies/",
  "ping": "https://namso-gen.com/",
  "loc": "http://id.loc.gov/",
  "penn": "http://purl.org/olia/penn.owl#",
  "dbkwik": "http://dbkwik.webdatacommons.org/",
  "sp": "http://spinrdf.org/sp#",
  "lexinfo": "http://www.lexinfo.net/ontology/3.0/lexinfo#",
  "am": "http://vocab.deri.ie/am#",
  "dblp": "http://dblp.uni-trier.de/rdf/schema-2015-01-26#",
  "ldp": "http://www.w3.org/ns/ldp#",
  "mods": "http://www.loc.gov/mods/v3#",
  "nmo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nmo#",
  "st": "http://ns.inria.fr/sparql-template/",
  "bd": "http://www.bigdata.com/rdf#",
  "sec": "https://w3id.org/security#",
  "geoes": "http://geo.linkeddata.es/ontology/",
  "product": "http://purl.org/commerce/product#",
  "dce": "http://purl.org/dc/elements/1.1/",
  "chebi": "http://purl.obolibrary.org/obo/CHEBI_",
  "nao": "http://www.semanticdesktop.org/ontologies/2007/08/15/nao#",
  "sdo": "https://schema.org/",
  "example": "http://www.example.org/rdf#",
  "sioct": "http://rdfs.org/sioc/types#",
  "imm": "http://schemas.microsoft.com/imm/",
  "sparql": "http://www.w3.org/ns/sparql#",
  "siocserv": "http://rdfs.org/sioc/services#",
  "gnd": "http://d-nb.info/gnd/",
  "up": "http://purl.uniprot.org/core/",
  "cerif": "http://spi-fm.uca.es/neologism/cerif#",
  "rec": "http://purl.org/ontology/rec/core#",
  "coref": "http://www.rkbexplorer.com/ontologies/coref#",
  "list": "http://www.w3.org/2000/10/swap/list#",
  "scovo": "http://purl.org/NET/scovo#",
  "ptr": "http://www.w3.org/2009/pointers#",
  "gd": "http://rdf.data-vocabulary.org/#",
  "mf": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "whois": "http://www.kanzaki.com/ns/whois#",
  "acc": "http://purl.org/NET/acc#",
  "spin": "http://spinrdf.org/spin#",
  "java": "http://www.w3.org/2007/uwa/context/java.owl#",
  "doc": "http://www.w3.org/2000/10/swap/pim/doc#",
  "wiki": "http://en.wikipedia.org/wiki/",
  "sirext": "http://t.me/sirextt/247:",
  "space": "http://www.w3.org/ns/pim/space#",
  "ms": "http://purl.org/obo/owl/MS#",
  "cube": "https://cube.link/",
  "gold": "http://purl.org/linguistics/gold/",
  "olia": "http://purl.org/olia/olia.owl#",
  "opm": "https://w3id.org/opm#",
  "pmlj": "http://inference-web.org/2.0/pml-justification.owl#",
  "meta": "https://krr.triply.cc/krr/sameas-meta/def/",
  "geof": "http://www.opengis.net/def/function/geosparql/",
  "xlink": "https://es.scribd.com/doc/79794476/05-Ejercicios-Resueltos-Caja-Negra-y-Recapitulacion/",
  "ti": "http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#",
  "euvoc": "http://publications.europa.eu/ontology/euvoc#",
  "dbnary": "http://kaiko.getalp.org/dbnary#",
  "cro": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "lgd": "http://linkedgeodata.org/triplify/",
  "pext": "http://www.ontotext.com/proton/protonext#",
  "rdfsharp": "https://rdfsharp.codeplex.com/",
  "vivo": "http://vivoweb.org/ontology/core#",
  "rsa": "http://www.w3.org/ns/auth/rsa#",
  "iot": "http://iotschema.org/",
  "sim": "http://www.w3id.org/simulation/ontology/",
  "nco": "http://www.semanticdesktop.org/ontologies/2007/03/22/nco#",
  "hg": "http://rdf.histograph.io/",
  "bp": "http://www.biopax.org/release/biopax-level3.owl#",
  "bing": "http://bing.com/schema/media/",
  "akts": "http://www.aktors.org/ontology/support#",
  "po": "http://purl.org/ontology/po/",
  "georss": "http://www.georss.org/georss/",
  "api": "http://purl.org/linked-data/api/vocab#",
  "kb": "http://deductions.sf.net/ontology/knowledge_base.owl#",
  "acl": "http://www.w3.org/ns/auth/acl#",
  "nt": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "geosparql": "http://www.opengis.net/ont/geosparql#",
  "pim": "http://www.w3.org/ns/pim/space#",
  "cito": "http://purl.org/spar/cito/",
  "cgov": "http://reference.data.gov.uk/def/central-government/",
  "resource": "http://dbpedia.org/resource/",
  "lu": "http://www.ontologydesignpatterns.org/ont/framenet/abox/lu/",
  "video": "http://purl.org/ontology/video#",
  "xl": "http://langegger.at/xlwrap/vocab#",
  "wgs": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "seas": "https://w3id.org/seas/",
  "dbpediaowl": "http://dbpedia.org/owl/",
  "pr": "http://purl.org/ontology/prv/core#",
  "wikipedia": "https://en.wikipedia.org/wiki/",
  "name": "http://example.org/name#",
  "gist": "https://ontologies.semanticarts.com/o/gistCore#",
  "cidoc": "http://www.cidoc-crm.org/cidoc-crm/",
  "ean": "http://openean.kaufkauf.net/id/",
  "postcode": "http://data.ordnancesurvey.co.uk/id/postcodeunit/",
  "web": "http://www.w3.org/2007/uwa/context/web.owl#",
  "bag": "https://bag2.basisregistraties.overheid.nl/bag/def/",
  "acm": "http://www.rkbexplorer.com/ontologies/acm#",
  "role": "https://w3id.org/role/",
  "exterms": "http://www.example.org/terms/",
  "eu": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "httph": "http://www.w3.org/2007/ont/httph#",
  "ontolex": "http://www.w3.org/ns/lemon/ontolex#",
  "pav": "http://purl.org/pav/",
  "sosa": "http://www.w3.org/ns/sosa/",
  "dco": "http://info.deepcarbon.net/schema#",
  "stanford": "http://purl.org/olia/stanford.owl#",
  "wn": "http://xmlns.com/wordnet/1.6/",
  "prv": "http://purl.org/net/provenance/ns#",
  "dcm": "http://purl.org/dc/dcmitype/",
  "pgterms": "http://www.gutenberg.org/2009/pgterms/",
  "purl": "http://purl.org/dc/terms/",
  "ps": "https://w3id.org/payswarm#",
  "iso": "http://purl.org/iso25964/skos-thes#",
  "overheid": "http://standaarden.overheid.nl/owms/",
  "formats": "http://www.w3.org/ns/formats/",
  "dcatapit": "http://dati.gov.it/onto/dcatapit#",
  "wo": "http://purl.org/ontology/wo/",
  "inno": "http://purl.org/innovation/ns#",
  "service": "http://purl.org/ontology/service#",
  "ass": "http://uptheasset.org/ontology#",
  "ero": "http://purl.obolibrary.org/obo/",
  "ocd": "http://dati.camera.it/ocd/",
  "lime": "http://www.w3.org/ns/lemon/lime#",
  "admingeo": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "greg": "http://kasei.us/about/foaf.xrdf#",
  "sider": "http://www4.wiwiss.fu-berlin.de/sider/resource/sider/",
  "rdfdf": "http://www.openlinksw.com/virtrdf-data-formats#",
  "wdrs": "http://www.w3.org/2007/05/powder-s#",
  "atom": "http://www.w3.org/2005/Atom/",
  "wn20schema": "http://www.w3.org/2006/03/wn/wn20/schema/",
  "bmo": "http://collection.britishmuseum.org/id/ontology/",
  "smf": "http://topbraid.org/sparqlmotionfunctions#",
  "abc": "http://www.metadata.net/harmony/ABCSchemaV5Commented.rdf#",
  "ndl": "http://schemas.ogf.org/nml/2013/05/base#",
  "daml": "http://www.daml.org/2001/03/daml+oil#",
  "es": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "zoology": "http://purl.org/NET/biol/zoology#",
  "iao": "http://purl.obolibrary.org/obo/IAO_",
  "premis": "http://www.loc.gov/premis/rdf/v3/",
  "mm": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/function#",
  "lode": "http://linkedevents.org/ontology/",
  "cpa": "http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#",
  "saref": "https://saref.etsi.org/core/",
  "gsp": "http://www.opengis.net/ont/geosparql#",
  "res": "http://dbpedia.org/resource/",
  "edam": "http://edamontology.org/",
  "xkos": "http://rdf-vocabulary.ddialliance.org/xkos#",
  "won": "https://w3id.org/won/core#",
  "myspo": "http://purl.org/ontology/myspace#",
  "hydra": "http://www.w3.org/ns/hydra/core#",
  "swid": "http://semanticweb.org/id/",
  "irw": "http://www.ontologydesignpatterns.org/ont/web/irw.owl#",
  "agg": "http://purl.org/twc/health/vocab/aggregate/",
  "dt": "http://w3id.org/dt#",
  "hp": "http://pictogram.tokyo/vocabulary#",
  "so": "http://schema.org/",
  "blt": "http://www.bl.uk/schemas/bibliographic/blterms#",
  "cheminf": "http://www.semanticweb.org/ontologies/cheminf.owl#",
  "resist": "http://www.rkbexplorer.com/ontologies/resist#",
  "spl": "http://spinrdf.org/spl#",
  "scot": "http://rdfs.org/scot/ns#",
  "label": "http://purl.org/net/vocab/2004/03/label#",
  "bfo": "http://purl.obolibrary.org/obo/",
  "omt": "http://purl.org/ontomedia/ext/common/trait#",
  "sdl": "http://purl.org/vocab/riro/sdl#",
  "omp": "http://purl.org/ontomedia/ext/common/profession#",
  "pmt": "http://tipsy.googlecode.com/svn/trunk/vocab/pmt#",
  "tmo": "http://www.semanticdesktop.org/ontologies/2008/05/20/tmo#",
  "fed": "http://www.openrdf.org/config/sail/federation#",
  "site": "http://ns.ontowiki.net/SysOnt/Site/",
  "ignf": "http://data.ign.fr/def/ignf#",
  "faldo": "http://biohackathon.org/resource/faldo#",
  "rov": "http://www.w3.org/ns/regorg#",
  "orges": "http://datos.gob.es/def/sector-publico/organizacion#",
  "ecs": "http://rdf.ecs.soton.ac.uk/ontology/ecs#",
  "bibframe": "http://id.loc.gov/ontologies/bibframe/",
  "isothes": "http://purl.org/iso25964/skos-thes#",
  "ref": "http://purl.org/vocab/relationship/",
  "cpm": "http://catalogus-professorum.org/cpm/2/",
  "user": "http://schemas.talis.com/2005/user/schema#",
  "eco": "http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#",
  "ses": "http://lod.taxonconcept.org/ses/",
  "sml": "https://w3id.org/sml/def#",
  "oad": "http://lod.xdams.org/reload/oad/",
  "ya": "http://blogs.yandex.ru/schema/foaf/",
  "food": "http://purl.org/foodontology#",
  "rdau": "http://rdaregistry.info/Elements/u/",
  "act": "http://www.w3.org/2007/rif-builtin-action#",
  "link": "http://www.w3.org/2007/ont/link#",
  "library": "http://purl.org/library/",
  "wordnet": "http://wordnet-rdf.princeton.edu/ontology#",
  "airport": "http://www.daml.org/2001/10/html/airport-ont#",
  "cordis": "http://cordis.europa.eu/projects/",
  "prj": "http://purl.org/stuff/project/",
  "ub": "http://www.lehigh.edu/~zhp2/2004/0401/univ-bench.owl#",
  "phil": "http://philosurfical.open.ac.uk/ontology/philosurfical.owl#",
  "rnews": "http://iptc.org/std/rNews/2011-10-07#",
  "awol": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "audio": "http://purl.org/media/audio#",
  "sit": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "swp": "http://www.w3.org/2004/03/trix/swp-2/",
  "fresnel": "http://www.w3.org/2004/09/fresnel#",
  "opensearch": "http://a9.com/-/spec/opensearch/1.1/",
  "sesame": "http://www.openrdf.org/schema/sesame#",
  "ludo": "http://ns.inria.fr/ludo/v1#",
  "biocore": "http://bio2rdf.org/core#",
  "sport": "http://purl.org/ontology/sport/",
  "granatum": "http://chem.deri.ie/granatum/",
  "npg": "http://ns.nature.com/terms/",
  "taxon": "http://purl.uniprot.org/taxonomy/",
  "city": "http://datos.localidata.com/def/City#",
  "rs": "http://rightsstatements.org/vocab/",
  "efo": "http://www.ebi.ac.uk/efo/",
  "organism": "http://eulersharp.sourceforge.net/2003/03swap/organism#",
  "net": "http://www.w3.org/2007/uwa/context/network.owl#",
  "linkedmdb": "http://data.linkedmdb.org/",
  "xhe": "http://buzzword.org.uk/rdf/xhtml-elements#",
  "meteo": "http://purl.org/ns/meteo#",
  "wv": "http://vocab.org/waiver/terms/",
  "asn": "http://purl.org/ASN/schema/core/",
  "umbelrc": "http://umbel.org/umbel/rc/",
  "os": "http://www.w3.org/2000/10/swap/os#",
  "acco": "http://purl.org/acco/ns#",
  "taxo": "http://purl.org/rss/1.0/modules/taxonomy/",
  "bio2rdf": "http://bio2rdf.org/",
  "conv": "http://purl.org/twc/vocab/conversion/",
  "disco": "http://rdf-vocabulary.ddialliance.org/discovery#",
  "lom": "http://ltsc.ieee.org/rdf/lomv1p0/lom#",
  "vra": "http://purl.org/vra/",
  "fbgeo": "http://rdf.freebase.com/ns/location/geocode/",
  "dctype": "http://purl.org/dc/dcmitype/",
  "conversion": "http://purl.org/twc/vocab/conversion/",
  "uco": "http://purl.org/uco/ns#",
  "cmo": "http://purl.org/twc/ontologies/cmo.owl#",
  "mime": "https://www.iana.org/assignments/media-types/",
  "doac": "http://ramonantonio.net/doac/0.1/#",
  "tdb": "http://jena.hpl.hp.com/2008/tdb#",
  "rail": "http://ontologi.es/rail/vocab#",
  "arg": "http://spinrdf.org/arg#",
  "rep": "http://www.openrdf.org/config/repository#",
  "ao": "http://purl.org/ontology/ao/core#",
  "txn": "http://lod.taxonconcept.org/ontology/txn.owl#",
  "spc": "http://purl.org/ontomedia/core/space#",
  "omb": "http://purl.org/ontomedia/ext/common/being#",
  "oc": "http://opencoinage.org/rdf/",
  "frame": "http://www.ontologydesignpatterns.org/ont/framenet/abox/frame/",
  "fe": "http://www.ontologydesignpatterns.org/ont/framenet/abox/fe/",
  "compass": "http://purl.org/net/compass#",
  "cdt": "https://w3id.org/cdt/",
  "bne": "http://datos.bne.es/resource/",
  "lgdo": "http://linkedgeodata.org/ontology/",
  "vocab": "http://rdf.ontology2.com/vocab#",
  "pbo": "http://purl.org/ontology/pbo/core#",
  "money": "http://purl.org/net/rdf-money/",
  "custom": "http://www.openrdf.org/config/sail/custom#",
  "umbel": "http://umbel.org/umbel#",
  "code": "http://telegraphis.net/ontology/measurement/code#",
  "protege": "http://protege.stanford.edu/system#",
  "bl": "https://w3id.org/biolink/vocab/",
  "wgs84": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "crypto": "http://www.w3.org/2000/10/swap/crypto#",
  "ct": "http://data.linkedct.org/resource/linkedct/",
  "lfm": "http://purl.org/ontology/last-fm/",
  "dwc": "http://rs.tdwg.org/dwc/terms/",
  "lx": "http://purl.org/NET/lx#",
  "powder": "http://www.w3.org/2007/05/powder#",
  "frir": "http://purl.org/twc/ontology/frir.owl#",
  "nrl": "http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#",
  "affy": "http://www.affymetrix.com/community/publications/affymetrix/tmsplice#",
  "rdrel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "sco": "http://purl.org/ontology/sco#",
  "ic": "http://imi.go.jp/ns/core/rdf#",
  "lang": "http://ontologi.es/lang/core#",
  "ire": "http://www.ontologydesignpatterns.org/cpont/ire.owl#",
  "atomix": "http://buzzword.org.uk/rdf/atomix#",
  "omm": "http://purl.org/ontomedia/core/media#",
  "obj": "http://www.openrdf.org/rdf/2009/object#",
  "bibtex": "http://purl.org/net/nknouf/ns/bibtex#",
  "pom": "http://maven.apache.org/POM/4.0.0#",
  "fec": "http://www.rdfabout.com/rdf/schema/usfec/",
  "muto": "http://purl.org/muto/core#",
  "ddc": "http://purl.org/NET/decimalised#",
  "coo": "http://purl.org/coo/ns#",
  "pay": "http://reference.data.gov.uk/def/payment#",
  "arch": "http://purl.org/archival/vocab/arch#",
  "bbc": "http://www.bbc.co.uk/ontologies/news/",
  "pro": "http://purl.org/hpi/patchr#",
  "rei": "http://www.w3.org/2004/06/rei#",
  "isq": "http://purl.org/ontology/is/quality/",
  "biol": "http://purl.org/NET/biol/ns#",
  "mit": "http://purl.org/ontology/mo/mit#",
  "soc": "http://purl.org/net/hdlipcores/ontology/soc#",
  "contact": "http://www.w3.org/2000/10/swap/pim/contact#",
  "yoda": "http://purl.org/NET/yoda#",
  "vsr": "http://purl.org/twc/vocab/vsr#",
  "interval": "http://reference.data.gov.uk/def/intervals/",
  "worldbank": "http://worldbank.270a.info/dataset/",
  "person": "http://www.w3.org/ns/person#",
  "mp": "http://jicamaro.info/mp#",
  "swh": "http://plugin.org.uk/swh-plugins/",
  "aos": "http://rdf.muninn-project.org/ontologies/appearances#",
  "deo": "http://purl.org/spar/deo/",
  "apivc": "http://purl.org/linked-data/api/vocab#",
  "xds": "http://www.w3.org/2001/XMLSchema#",
  "locn": "http://www.w3.org/ns/locn#",
  "gml": "http://www.opengis.net/ont/gml#",
  "mysql": "http://web-semantics.org/ns/mysql/",
  "gso": "http://www.w3.org/2006/gen/ont#",
  "rdac": "http://rdaregistry.info/Elements/c/",
  "gpt": "http://purl.org/vocab/riro/gpt#",
  "r2rml": "http://www.w3.org/ns/r2rml#",
  "ppo": "http://vocab.deri.ie/ppo#",
  "ngeo": "http://geovocab.org/geometry#",
  "hard": "http://www.w3.org/2007/uwa/context/hardware.owl#",
  "freebase": "http://rdf.freebase.com/ns/",
  "bib": "http://zeitkunst.org/bibtex/0.1/bibtex.owl#",
  "rlog": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#",
  "zem": "http://s.zemanta.com/ns#",
  "pmlr": "http://inference-web.org/2.0/pml-relation.owl#",
  "usgov": "http://www.rdfabout.com/rdf/schema/usgovt/",
  "xro": "http://purl.org/xro/ns#",
  "courseware": "http://courseware.rkbexplorer.com/ontologies/courseware#",
  "climb": "http://climb.dataincubator.org/vocabs/climb/",
  "rv": "https://data.elsevier.com/research/schema/rv/",
  "eli": "http://data.europa.eu/eli/ontology#",
  "cpv": "http://purl.org/weso/cpv/",
  "is": "http://purl.org/ontology/is/core#",
  "nexif": "http://www.semanticdesktop.org/ontologies/2007/05/10/nexif#",
  "doclist": "http://www.junkwork.net/xml/DocumentList#",
  "aifb": "http://www.aifb.kit.edu/id/",
  "gob": "http://purl.org/ontology/last-fm/",
  "game": "http://data.totl.net/game/",
  "states": "http://www.w3.org/2005/07/aaa#",
  "payment": "http://reference.data.gov.uk/def/payment#",
  "vso": "http://purl.org/vso/ns#",
  "oac": "https://w3id.org/oac#",
  "sem": "http://semanticweb.cs.vu.nl/2009/11/sem/",
  "cycann": "http://sw.cyc.com/CycAnnotations_v1#",
  "pos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "meetup": "http://www.lotico.com/meetup/",
  "ui": "http://www.w3.org/ns/ui#",
  "bridge": "http://purl.org/vocommons/bridge#",
  "address": "http://schemas.talis.com/2005/address/schema#",
  "viaf": "http://viaf.org/viaf/",
  "kwijibo": "http://kwijibo.talis.com/",
  "xen": "http://buzzword.org.uk/rdf/xen#",
  "article": "http://ogp.me/ns/article#",
  "odrl": "http://www.w3.org/ns/odrl/2/",
  "bsb": "http://opacplus.bsb-muenchen.de/title/",
  "dso": "http://purl.org/ontology/dso#",
  "cdc": "https://w3id.org/cdc#",
  "dcmitype": "http://purl.org/dc/dcmitype/",
  "wnschema": "http://www.cogsci.princeton.edu/~wn/schema/",
  "pdo": "http://ontologies.smile.deri.ie/pdo#",
  "omc": "http://purl.org/ontomedia/ext/common/bestiary#",
  "teach": "http://linkedscience.org/teach/ns#",
  "nuts": "http://dd.eionet.europa.eu/vocabulary/common/nuts/",
  "sdm": "https://w3id.org/okn/o/sdm#",
  "dbpp": "http://dbpedia.org/property/",
  "cex": "http://purl.org/weso/ontology/computex#",
  "uri": "http://purl.org/NET/uri#",
  "soft": "http://www.w3.org/2007/uwa/context/software.owl#",
  "prot": "http://www.proteinontology.info/po.owl#",
  "chord": "http://purl.org/ontology/chord/",
  "xforms": "http://www.w3.org/2002/xforms/",
  "politico": "http://www.rdfabout.com/rdf/schema/politico/",
  "oboinowl": "http://www.geneontology.org/formats/oboInOwl#",
  "psys": "http://proton.semanticweb.org/protonsys#",
  "swanco": "http://purl.org/swan/1.2/swan-commons/",
  "vote": "http://www.rdfabout.com/rdf/schema/vote/",
  "wi": "http://purl.org/ontology/wi/core#",
  "agro": "http://purl.obolibrary.org/obo/agro.owl#",
  "oauth": "http://demiblog.org/vocab/oauth#",
  "muo": "http://purl.oclc.org/NET/muo/muo#",
  "rda": "http://www.rdaregistry.info/",
  "biopax": "http://www.biopax.org/release/biopax-level3.owl#",
  "coin": "http://purl.org/court/def/2009/coin#",
  "oboe": "http://ecoinformatics.org/oboe/oboe.1.0/oboe-core.owl#",
  "ttl": "http://www.w3.org/2008/turtle#",
  "recipe": "http://linkedrecipes.org/schema/",
  "conserv": "http://conserv.deri.ie/ontology#",
  "ebucore": "http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#",
  "rooms": "http://vocab.deri.ie/rooms#",
  "com": "http://purl.org/commerce#",
  "lp": "http://launchpad.net/rdf/launchpad#",
  "voag": "http://voag.linkedmodel.org/schema/voag#",
  "lfn": "http://www.dotnetrdf.org/leviathan#",
  "provone": "http://purl.org/provone#",
  "fea": "http://vocab.data.gov/def/fea#",
  "bsbm": "http://www4.wiwiss.fu-berlin.de/bizer/bsbm/v01/vocabulary/",
  "rdapo": "http://rdaregistry.info/Elements/p/object/",
  "string": "http://www.w3.org/2000/10/swap/string#",
  "eclap": "http://www.eclap.eu/schema/eclap/",
  "lifecycle": "http://purl.org/vocab/lifecycle/schema#",
  "vaem": "http://www.linkedmodel.org/schema/vaem#",
  "sv": "http://schemas.talis.com/2005/service/schema#",
  "vitro": "http://vitro.mannlib.cornell.edu/ns/vitro/public#",
  "swanqs": "http://purl.org/swan/1.2/qualifiers/",
  "fo": "http://www.w3.org/1999/XSL/Format#",
  "moat": "http://moat-project.org/ns#",
  "dailymed": "http://www4.wiwiss.fu-berlin.de/dailymed/resource/dailymed/",
  "scv": "http://purl.org/NET/scovo#",
  "dcr": "http://www.isocat.org/ns/dcr.rdf#",
  "puc": "http://purl.org/NET/puc#",
  "card": "http://www.ashutosh.com/test/",
  "oslc": "http://open-services.net/ns/core#",
  "mygrid": "http://www.mygrid.org.uk/ontology#",
  "wdr": "http://www.w3.org/2007/05/powder#",
  "isi": "http://purl.org/ontology/is/inst/",
  "opo": "http://online-presence.net/opo/ns#",
  "dnr": "http://www.dotnetrdf.org/configuration#",
  "push": "http://www.w3.org/2007/uwa/context/push.owl#",
  "meb": "http://rdf.myexperiment.org/ontologies/base/",
  "osn": "http://spatial.ucd.ie/lod/osn/",
  "cogs": "http://vocab.deri.ie/cogs#",
  "spatial": "http://geovocab.org/spatial#",
  "posh": "http://poshrdf.org/ns/posh/",
  "h5": "http://buzzword.org.uk/rdf/h5#",
  "dady": "http://purl.org/NET/dady#",
  "lastfm": "http://purl.org/ontology/last-fm/",
  "lotico": "http://www.lotico.com/resource/",
  "ldap": "http://purl.org/net/ldap/",
  "lex": "http://purl.org/lex#",
  "html": "http://www.w3.org/1999/xhtml/",
  "countries": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
  "toby": "http://tobyinkster.co.uk/#",
  "ext": "http://mu.semte.ch/vocabularies/ext/",
  "b2bo": "http://purl.org/b2bo#",
  "play": "http://uriplay.org/spec/ontology/#",
  "wlp": "http://weblab-project.org/core/model/property/processing/",
  "lvont": "http://lexvo.org/ontology#",
  "care": "http://eulersharp.sourceforge.net/2003/03swap/care#",
  "sail": "http://www.openrdf.org/config/sail#",
  "wgspos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "hospital": "http://www.agfa.com/w3c/2009/hospital#",
  "br": "http://vocab.deri.ie/br#",
  "enc": "http://www.w3.org/2001/04/xmlenc#",
  "csvw": "http://www.w3.org/ns/csvw#",
  "fls": "http://lukasblaho.sk/football_league_schema#",
  "resex": "http://resex.rkbexplorer.com/ontologies/resex#",
  "hlisting": "http://sindice.com/hlisting/0.1/",
  "bte": "http://purl.org/twc/vocab/between-the-edges/",
  "sede": "http://eventography.org/sede/0.1/",
  "pubmed": "http://bio2rdf.org/pubmed_vocabulary:",
  "fd": "http://foodable.co/ns/",
  "wbp": "http://worldbank.270a.info/property/",
  "geospecies": "http://rdf.geospecies.org/ont/geospecies#",
  "evset": "http://dsnotify.org/vocab/eventset/0.1/",
  "rdaa": "http://rdaregistry.info/Elements/a/",
  "swandr": "http://purl.org/swan/1.2/discourse-relationships/",
  "wai": "http://purl.org/wai#",
  "fno": "https://w3id.org/function/ontology#",
  "uni": "http://purl.org/weso/uni/uni.html#",
  "lingvoj": "http://www.lingvoj.org/ontology#",
  "lark1": "http://users.utcluj.ro/~raluca/ontology/Ontology1279614123500.owl#",
  "ist": "http://purl.org/ontology/is/types/",
  "marl": "http://www.gsi.dit.upm.es/ontologies/marl/ns#",
  "icaltzd": "http://www.w3.org/2002/12/cal/icaltzd#",
  "grddl": "http://www.w3.org/2003/g/data-view#",
  "okkam": "http://models.okkam.org/ENS-core-vocabulary#",
  "ncbitaxon": "http://purl.obolibrary.org/obo/NCBITaxon_",
  "tarot": "http://data.totl.net/tarot/card/",
  "irrl": "http://www.ontologydesignpatterns.org/cp/owl/informationobjectsandrepresentationlanguages.owl#",
  "cmd": "https://w3id.org/cmd#",
  "parl": "https://id.parliament.uk/schema/",
  "profiling": "http://ontologi.es/profiling#",
  "p3p": "http://www.w3.org/2002/01/p3prdfv1#",
  "anca": "http://users.utcluj.ro/~raluca/rdf_ontologies_ralu/ralu_modified_ontology_pizzas2_0#",
  "ops": "https://w3id.org/ops#",
  "hcterms": "http://purl.org/uF/hCard/terms/",
  "calli": "http://callimachusproject.org/rdf/2009/framework#",
  "cos": "http://www.inria.fr/acacia/corese#",
  "exo": "https://w3id.org/example#",
  "oat": "http://openlinksw.com/schemas/oat/",
  "ec": "http://eulergui.sourceforge.net/contacts.owl.n3#",
  "data": "http://data.odw.tw/",
  "like": "http://ontologi.es/like#",
  "foo": "http://filmontology.org/ontology/1.0/",
  "sioca": "http://rdfs.org/sioc/actions#",
  "pol": "http://escience.rpi.edu/ontology/semanteco/2/0/pollution.owl#",
  "places": "http://purl.org/ontology/places#",
  "archdesc": "http://archdesc.info/archEvent#",
  "pobo": "http://purl.obolibrary.org/obo/",
  "xmls": "http://www.w3.org/2001/XMLSchema#",
  "shv": "http://ns.aksw.org/spatialHierarchy/",
  "remus": "http://www.semanticweb.org/ontologies/2010/6/Ontology1279614123500.owl#",
  "algo": "http://securitytoolbox.appspot.com/securityAlgorithms#",
  "ann": "http://www.w3.org/2000/10/annotation-ns#",
  "rdfa": "http://www.w3.org/ns/rdfa#",
  "swivt": "http://semantic-mediawiki.org/swivt/1.0#",
  "cb": "http://cbasewrap.ontologycentral.com/vocab#",
  "tr": "http://www.thomsonreuters.com/",
  "ddl": "http://purl.org/vocab/riro/ddl#",
  "wsc": "http://www.openk.org/wscaim.owl#",
  "sawsdl": "http://www.w3.org/ns/sawsdl#",
  "td": "https://www.w3.org/2019/wot/td#",
  "identity": "http://purl.org/twc/ontologies/identity.owl#",
  "datafaqs": "http://purl.org/twc/vocab/datafaqs#",
  "infosys": "http://www.infosys.com/",
  "nex": "http://www.nexml.org/2009/",
  "httpvoc": "http://www.w3.org/2006/http#",
  "psh": "http://ns.inria.fr/probabilistic-shacl/",
  "psych": "http://purl.org/vocab/psychometric-profile/",
  "geom": "http://data.ign.fr/def/geometrie#",
  "tio": "http://purl.org/tio/ns#",
  "phss": "http://ns.poundhill.com/phss/1.0/",
  "gridworks": "http://purl.org/net/opmv/types/gridworks#",
  "esd": "http://def.esd.org.uk/",
  "scsv": "http://purl.org/NET/schema-org-csv#",
  "gs1": "https://ref.gs1.org/voc/",
  "osr": "http://dati.senato.it/osr/",
  "opwn": "http://www.ontologyportal.org/WordNet.owl#",
  "wl": "http://www.wsmo.org/ns/wsmo-lite#",
  "prissma": "http://ns.inria.fr/prissma/v1#",
  "common": "http://www.w3.org/2007/uwa/context/common.owl#",
  "copyright": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "esdir": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/direccion-postal#",
  "wisski": "http://wiss-ki.eu/",
  "imreg": "http://www.w3.org/2004/02/image-regions#",
  "dnb": "http://d-nb.info/gnd/",
  "tags": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "fab": "http://purl.org/fab/ns#",
  "geographis": "http://telegraphis.net/ontology/geography/geography#",
  "nsa": "http://multimedialab.elis.ugent.be/organon/ontologies/ninsuna#",
  "dita": "http://purl.org/dita/ns#",
  "ezcontext": "http://ontologies.ezweb.morfeo-project.org/ezcontext/ns#",
  "dbpedia2": "http://dbpedia.org/property/",
  "ogp": "http://ogp.me/ns#",
  "ple": "http://pleiades.stoa.org/places/",
  "pmlp": "http://inference-web.org/2.0/pml-provenance.owl#",
  "prf": "http://www.openmobilealliance.org/tech/profiles/UAPROF/ccppschema-20021212#",
  "status": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "drug": "http://www.agfa.com/w3c/2009/drugTherapy#",
  "san": "http://www.irit.fr/recherches/MELODI/ontologies/SAN#",
  "session": "http://redfoot.net/2005/session#",
  "span": "http://www.ifomis.org/bfo/1.1/span#",
  "ecc": "https://ns.eccenca.com/",
  "eprints": "http://eprints.org/ontology/",
  "provenir": "http://knoesis.wright.edu/provenir/provenir.owl#",
  "ecos": "http://purl.org/ecos#",
  "dbt": "http://dbpedia.org/resource/Template:",
  "pccz": "http://purl.org/procurement/public-contracts-czech#",
  "visit": "http://purl.org/net/vocab/2004/07/visit#",
  "xt": "http://purl.org/twc/vocab/cross-topix#",
  "pam": "http://prismstandard.org/namespaces/pam/2.0/",
  "wfm": "http://purl.org/net/wf-motifs#",
  "pml": "http://provenanceweb.org/ns/pml#",
  "admssw": "http://purl.org/adms/sw/",
  "lr": "http://linkedrecipes.org/schema/",
  "grel": "http://users.ugent.be/~bjdmeest/function/grel.ttl#",
  "rulz": "http://purl.org/NET/rulz#",
  "osoc": "http://web-semantics.org/ns/opensocial#",
  "elog": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "tp": "https://triplydb.com/Triply/tp/def/",
  "smiley": "http://www.smileyontology.com/ns#",
  "units": "http://eulersharp.sourceforge.net/2003/03swap/units#",
  "fowl": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/food#",
  "ecb": "http://ecb.270a.info/class/1.0/",
  "sl": "http://www.semanlink.net/2001/00/semanlink-schema#",
  "wbc": "http://worldbank.270a.info/classification/",
  "timeline": "http://purl.org/NET/c4dm/timeline.owl#",
  "quantity": "http://qudt.org/schema/quantity#",
  "agent": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
  "sindice": "http://vocab.sindice.net/",
  "visko": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
  "mesh": "http://id.nlm.nih.gov/mesh/",
  "human": "http://eulersharp.sourceforge.net/2003/03swap/human#",
  "pimo": "http://www.semanticdesktop.org/ontologies/2007/11/01/pimo#",
  "cao": "http://purl.org/makolab/caont/",
  "dsp": "http://purl.org/metainfo/terms/dsp#",
  "odp": "http://ontologydesignpatterns.org/",
  "vf": "https://w3id.org/valueflows/ont/vf#",
  "omv": "http://omv.ontoware.org/2005/05/ontology#",
  "ling": "http://purl.org/voc/ling/",
  "sysont": "http://ns.ontowiki.net/SysOnt/",
  "np": "http://www.nanopub.org/nschema#",
  "hxl": "http://hxl.humanitarianresponse.info/ns/#",
  "skip": "http://skipforward.net/skipforward/resource/",
  "iswc": "http://annotation.semanticweb.org/2004/iswc#",
  "xsl": "http://www.w3.org/1999/XSL/Transform#",
  "wordmap": "http://purl.org/net/ns/wordmap#",
  "eztag": "http://ontologies.ezweb.morfeo-project.org/eztag/ns#",
  "ibis": "http://purl.org/ibis#",
  "reve": "http://data.eurecom.fr/ontology/reve#",
  "nxp": "http://purl.org/nxp/schema/v1/",
  "sm": "http://topbraid.org/sparqlmotion#",
  "c4n": "http://vocab.deri.ie/c4n#",
  "dis": "http://stanbol.apache.org/ontology/disambiguation/disambiguation#",
  "doco": "http://purl.org/spar/doco/",
  "olo": "http://purl.org/ontology/olo/core#",
  "cl": "http://advene.org/ns/cinelab/",
  "soap": "http://www.w3.org/2003/05/soap-envelope/",
  "rdo": "http://purl.org/rdo/ns#",
  "un": "http://www.w3.org/2007/ont/unit#",
  "ncal": "http://www.semanticdesktop.org/ontologies/2007/04/02/ncal#",
  "ipad": "http://www.padinthecity.com/",
  "lt": "http://diplomski.nelakolundzija.org/LTontology.rdf#",
  "geofla": "http://data.ign.fr/ontologies/geofla#",
  "geop": "http://aims.fao.org/aos/geopolitical.owl#",
  "swanci": "http://purl.org/swan/1.2/citations/",
  "json": "https://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf#",
  "orca": "http://geni-orca.renci.org/owl/topology.owl#",
  "gv": "http://rdf.data-vocabulary.org/#",
  "zbwext": "http://zbw.eu/namespaces/zbw-extensions/",
  "pns": "http://data.press.net/ontology/stuff/",
  "carfo": "http://purl.org/carfo#",
  "out": "http://ontologies.hypios.com/out#",
  "gazetteer": "http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/",
  "mei": "http://www.music-encoding.org/ns/mei/",
  "osgb": "http://data.ordnancesurvey.co.uk/id/",
  "prvtypes": "http://purl.org/net/provenance/types#",
  "dossier": "https://data.omgeving.vlaanderen.be/ns/dossier#",
  "aapi": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
  "trackback": "http://madskills.com/public/xml/rss/module/trackback/",
  "nsl": "http://purl.org/ontology/storyline/",
  "func": "http://www.w3.org/2007/rif-builtin-function#",
  "arpfo": "http://vocab.ouls.ox.ac.uk/projectfunding#",
  "fl": "http://eulersharp.sourceforge.net/2003/03swap/fl-rules#",
  "ne": "http://umbel.org/umbel/ne/",
  "sql": "http://ns.inria.fr/ast/sql#",
  "ecpo": "http://purl.org/ontology/ecpo#",
  "luc": "http://www.ontotext.com/owlim/lucene#",
  "spif": "http://spinrdf.org/spif#",
  "myprefix": "http://myprefix.org/",
  "decl": "http://www.linkedmodel.org/1.0/schema/decl#",
  "dgfoaf": "http://west.uni-koblenz.de/ontologies/2010/07/dgfoaf.owl#",
  "life": "http://life.deri.ie/schema/",
  "aigp": "http://swat.cse.lehigh.edu/resources/onto/aigp.owl#",
  "swanpav": "http://purl.org/swan/1.2/pav/",
  "gelo": "http://krauthammerlab.med.yale.edu/ontologies/gelo#",
  "fcm": "http://eulersharp.sourceforge.net/2006/02swap/fcm#",
  "dtype": "http://www.linkedmodel.org/schema/dtype#",
  "nytimes": "http://data.nytimes.com/elements/",
  "set": "http://www.w3.org/2000/10/swap/set#",
  "dpd": "http://www.kanzaki.com/ns/dpd#",
  "opus": "http://lsdis.cs.uga.edu/projects/semdis/opus#",
  "gc": "http://www.oegov.org/core/owl/gc#",
  "agents": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
  "atomowl": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "enhancer": "http://stanbol.apache.org/ontology/enhancer/enhancer#",
  "muni": "http://vocab.linkeddata.es/urbanismo-infraestructuras/territorio#",
  "eye": "http://jena.hpl.hp.com/Eyeball#",
  "hgnc": "http://bio2rdf.org/hgnc:",
  "sor": "http://purl.org/net/soron/",
  "prolog": "http://eulersharp.sourceforge.net/2003/03swap/prolog#",
  "ls": "http://linkedspending.aksw.org/instance/",
  "govtrackus": "http://www.rdfabout.com/rdf/usgov/geo/us/",
  "wairole": "http://www.w3.org/2005/01/wai-rdf/GUIRoleTaxonomy#",
  "agrelon": "http://d-nb.info/standards/elementset/agrelon#",
  "rlno": "http://rdflivenews.aksw.org/ontology/",
  "evopat": "http://ns.aksw.org/Evolution/",
  "pne": "http://data.press.net/ontology/event/",
  "pmlt": "http://inference-web.org/2.0/pml-trust.owl#",
  "sw": "http://linkedwidgets.org/statisticalwidget/ontology/",
  "rdagr1": "http://rdvocab.info/Elements/",
  "oboro": "http://obofoundry.org/ro/ro.owl#",
  "cidoccrm": "http://purl.org/NET/cidoc-crm/core#",
  "bioskos": "http://eulersharp.sourceforge.net/2003/03swap/bioSKOSSchemes#",
  "xhtmlvocab": "http://www.w3.org/1999/xhtml/vocab/",
  "wf": "http://www.w3.org/2005/01/wf/flow#",
  "wikibase": "http://wikiba.se/ontology#",
  "rad": "http://www.w3.org/ns/rad#",
  "sdgp": "http://stats.data-gov.ie/property/",
  "comm": "http://vocab.resc.info/communication#",
  "organiz": "http://eulersharp.sourceforge.net/2003/03swap/organization#",
  "webtlab": "http://webtlab.it.uc3m.es/",
  "prefix": "http://prefix.cc/",
  "rkd": "http://data.rkd.nl/def#",
  "dummy": "http://hello.com/",
  "xbrli": "http://www.xbrl.org/2003/instance#",
  "semtweet": "http://semantictweet.com/",
  "nid3": "http://www.semanticdesktop.org/ontologies/2007/05/10/nid3#",
  "rdam": "http://rdaregistry.info/Elements/m/",
  "derecho": "http://purl.org/derecho#",
  "r2r": "http://www4.wiwiss.fu-berlin.de/bizer/r2r/",
  "commons": "http://commons.psi.enakting.org/def/",
  "pf": "http://jena.hpl.hp.com/ARQ/property#",
  "open": "http://open.vocab.org/terms/",
  "owltime": "http://www.w3.org/TR/owl-time#",
  "dqv": "http://www.w3.org/ns/dqv#",
  "ens": "http://models.okkam.org/ENS-core-vocabulary.owl#",
  "linkedct": "http://data.linkedct.org/vocab/",
  "w3p": "http://prov4j.org/w3p/",
  "vcardx": "http://buzzword.org.uk/rdf/vcardx#",
  "aneo": "http://akonadi-project.org/ontologies/aneo#",
  "req": "http://purl.org/req/",
  "steel": "https://w3id.org/steel/ProcessOntology/",
  "dgtwc": "http://data-gov.tw.rpi.edu/2009/data-gov-twc.rdf#",
  "wao": "http://webtlab.it.uc3m.es/2010/10/WebAppsOntology#",
  "plo": "http://purl.org/net/po#",
  "transit": "http://vocab.org/transit/terms/",
  "qa": "http://www.mit.jyu.fi/ai/TRUST_Ontologies/QA.owl#",
  "plink": "http://buzzword.org.uk/rdf/personal-link-types#",
  "rso": "http://www.researchspace.org/ontology/",
  "sad": "http://vocab.deri.ie/sad#",
  "ifc": "http://ifcowl.openbimstandards.org/IFC2X3_Final#",
  "opl": "http://openlinksw.com/schema/attribution#",
  "httpm": "http://www.w3.org/2011/http-methods#",
  "agetec": "http://www.agetec.org/",
  "tripfs": "http://purl.org/tripfs/2010/02#",
  "pna": "http://data.press.net/ontology/asset/",
  "ianarel": "https://www.w3.org/ns/iana/link-relations/relation#",
  "tvc": "http://www.essepuntato.it/2012/04/tvc/",
  "xesam": "http://freedesktop.org/standards/xesam/1.0/core#",
  "abs": "http://abs.270a.info/dataset/",
  "moby": "http://www.mygrid.org.uk/mygrid-moby-service#",
  "rdaw": "http://rdaregistry.info/Elements/w/",
  "qdoslf": "http://foaf.qdos.com/lastfm/schema/",
  "ospost": "http://data.ordnancesurvey.co.uk/ontology/postcode/",
  "gxa": "http://www.ebi.ac.uk/gxa/",
  "theatre": "http://purl.org/theatre#",
  "oax": "http://www.w3.org/ns/openannotation/extensions/",
  "frbre": "http://purl.org/vocab/frbr/extended#",
  "fc": "http://www.freeclass.eu/freeclass_v1#",
  "aersv": "http://aers.data2semantics.org/vocab/",
  "rml": "http://w3id.org/rml/",
  "htir": "http://www.w3.org/2011/http#",
  "nyt": "http://data.nytimes.com/",
  "owls": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
  "hemogram": "http://www.agfa.com/w3c/2009/hemogram#",
  "va": "http://code-research.eu/ontology/visual-analytics#",
  "frbrcore": "http://purl.org/vocab/frbr/core#",
  "dl": "http://ontology.ip.rm.cnr.it/ontologies/DOLCE-Lite#",
  "wapp": "http://ns.rww.io/wapp#",
  "dbpo": "http://dbpedia.org/ontology/",
  "oj": "http://ontojob.at/",
  "geodata": "http://sws.geonames.org/",
  "no": "http://km.aifb.kit.edu/projects/numbers/number#",
  "tcga": "http://purl.org/tcga/core#",
  "lindt": "http://purl.org/NET/lindt#",
  "italy": "http://data.kasabi.com/dataset/italy/schema/",
  "protons": "http://proton.semanticweb.org/2005/04/protons#",
  "swpo": "http://sw-portal.deri.org/ontologies/swportal#",
  "intervals": "http://reference.data.gov.uk/def/intervals/",
  "oecd": "http://oecd.270a.info/dataset/",
  "dctypes": "http://purl.org/dc/dcmitype/",
  "xfnv": "http://vocab.sindice.com/xfn#",
  "metalex": "http://www.metalex.eu/schema/1.0#",
  "emotion": "http://ns.inria.fr/emoca#",
  "aims": "http://aims.fao.org/aos/common/",
  "estrn": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/transporte#",
  "kw": "http://kwantu.net/kw/",
  "languages": "http://eulersharp.sourceforge.net/2003/03swap/languages#",
  "wfdesc": "http://purl.org/wf4ever/wfdesc#",
  "solid": "http://www.w3.org/ns/solid/terms#",
  "health": "http://purl.org/twc/health/vocab/",
  "quak": "http://dev.w3.org/cvsweb/2000/quacken/vocab#",
  "flow": "http://www.w3.org/2005/01/wf/flow#",
  "scowt": "http://purl.org/weso/ontologies/scowt#",
  "atlas": "http://rdf.ebi.ac.uk/resource/atlas/",
  "oboso": "http://purl.org/obo/owl/SO#",
  "sro": "http://salt.semanticauthoring.org/ontologies/sro#",
  "mmo": "http://purl.org/momayo/mmo/",
  "eseduc": "http://www.purl.org/ontologia/eseduc#",
  "rpubl": "http://rinfo.lagrummet.se/ns/2008/11/rinfo/publ#",
  "iron": "http://purl.org/ontology/iron#",
  "fct": "http://openlinksw.com/services/facets/1.0/",
  "c4o": "http://purl.org/spar/c4o/",
  "opmv": "http://purl.org/net/opmv/ns#",
  "npgd": "http://ns.nature.com/datasets/",
  "tripfs2": "http://purl.org/tripfs/2010/06#",
  "xch": "http://oanda2rdf.appspot.com/xch/",
  "ogorg": "http://opengraph.org/schema/",
  "oper": "http://sweet.jpl.nasa.gov/2.0/mathOperation.owl#",
  "swo": "http://www.ebi.ac.uk/swo/",
  "shex": "http://www.w3.org/ns/shex#",
  "crtv": "http://open-services.net/ns/crtv#",
  "swanag": "http://purl.org/swan/1.2/agents/",
  "transmed": "http://www.w3.org/2001/sw/hcls/ns/transmed/",
  "jita": "http://aims.fao.org/aos/jita/",
  "kdo": "http://kdo.render-project.eu/kdo#",
  "rich": "http://rdf.data-vocabulary.org/",
  "lgv": "http://linkedgeodata.org/ontology/",
  "qu": "http://purl.oclc.org/NET/ssnx/qu/qu#",
  "re": "http://www.w3.org/2000/10/swap/reason#",
  "crmdig": "http://www.ics.forth.gr/isl/CRMdig/",
  "gbv": "http://purl.org/ontology/gbv/",
  "opmw": "http://www.opmw.org/ontology/",
  "hartigprov": "http://purl.org/net/provenance/ns#",
  "bdd": "https://api.bloomberg.com/eap/catalogs/bbg/fields/",
  "rating": "http://www.tvblob.com/ratings/#",
  "govwild": "http://govwild.org/0.6/GWOntology.rdf/",
  "ncit": "http://purl.obolibrary.org/obo/NCIT_",
  "ldr": "http://purl.oclc.org/NET/ldr/ns#",
  "clineva": "http://www.agfa.com/w3c/2009/clinicalEvaluation#",
  "cf": "http://mmisw.org/ont/cf/parameter/",
  "fingal": "http://vocab.deri.ie/fingal#",
  "dssn": "http://purl.org/net/dssn/",
  "gfo": "http://www.onto-med.de/ontologies/gfo.owl#",
  "environ": "http://eulersharp.sourceforge.net/2003/03swap/environment#",
  "wm": "http://ns.inria.fr/webmarks#",
  "humanbody": "http://eulersharp.sourceforge.net/2003/03swap/humanBody#",
  "events": "http://eulersharp.sourceforge.net/2003/03swap/event#",
  "bm": "http://bio2rdf.org/",
  "ccard": "http://purl.org/commerce/creditcard#",
  "daq": "http://purl.org/eis/vocab/daq#",
  "ufmedia": "http://purl.org/microformat/hmedia/",
  "openskos": "http://openskos.org/xmlns#",
  "igeo": "http://rdf.insee.fr/def/geo#",
  "nndsr": "http://semanticdiet.com/schema/usda/nndsr/",
  "coeus": "http://bioinformatics.ua.pt/coeus/",
  "goef": "http://purl.org/twc/vocab/goef#",
  "sgv": "http://www.w3.org/TR/SVG/",
  "ru": "http://purl.org/imbi/ru-meta.owl#",
  "skiresort": "http://www.openlinksw.com/ski_resorts/schema#",
  "aair": "http://xmlns.notu.be/aair#",
  "kontakt": "http://richard.cyganiak.de/",
  "mohammad": "http://manesht.ir/",
  "emp": "http://purl.org/ctic/empleo/oferta#",
  "cdtype": "http://purl.org/cld/cdtype/",
  "osmsemnet": "http://spatial.ucd.ie/2012/08/osmsemnet/",
  "occult": "http://data.totl.net/occult/",
  "d2r": "http://sites.wiwiss.fu-berlin.de/suhl/bizer/d2r-server/config.rdf#",
  "telix": "http://purl.org/telix#",
  "sig": "http://purl.org/signature#",
  "bco": "http://purl.obolibrary.org/obo/bco.owl#",
  "bookmark": "http://www.w3.org/2002/01/bookmark#",
  "marshall": "http://sites.google.com/site/xgmaitc/",
  "loticoowl": "http://www.lotico.com/ontology/",
  "artstor": "http://simile.mit.edu/2003/10/ontologies/artstor#",
  "coun": "http://www.daml.org/2001/09/countries/iso-3166-ont#",
  "cold": "http://purl.org/configurationontology#",
  "dayta": "http://dayta.me/resource#",
  "npgg": "http://ns.nature.com/graphs/",
  "adr": "http://kg.artsdata.ca/resource/",
  "tmpl": "http://purl.org/restdesc/http-template#",
  "hcard": "http://purl.org/uF/hCard/terms/",
  "ccom": "http://purl.org/ontology/cco/mappings#",
  "date": "http://contextus.net/ontology/ontomedia/misc/date#",
  "daiaserv": "http://purl.org/ontology/daia/Service/",
  "wscaim": "http://www.openk.org/wscaim.owl#",
  "arecipe": "http://purl.org/amicroformat/arecipe/",
  "tei": "http://www.tei-c.org/ns/1.0/",
  "dive": "http://scubadive.networld.to/dive.rdf#",
  "ipo": "http://purl.org/ipo/core#",
  "frapo": "http://purl.org/cerif/frapo/",
  "prism21": "http://prismstandard.org/namespaces/basic/2.1/",
  "frad": "http://iflastandards.info/ns/fr/frad/",
  "rankrage": "https://rankrage.de/",
  "grs": "http://www.georss.org/georss/",
  "wro": "http://purl.org/net/wf4ever/ro#",
  "clinic": "http://example.com/clinic#",
  "ev": "http://www.w3.org/2001/xml-events/",
  "paia": "http://purl.org/ontology/paia#",
  "bcncon": "http://datos.bcn.cl/ontologies/bcn-congress#",
  "decision": "https://decision-ontology.googlecode.com/svn/trunk/decision.owl#",
  "dannet": "http://www.wordnet.dk/owl/instance/2009/03/instances/",
  "pso": "http://purl.org/spar/pso/",
  "kupkb": "http://www.e-lico.eu/data/kupkb/",
  "property": "http://fr.dbpedia.org/property/",
  "harrisons": "http://harrisons.cc/",
  "osukdt": "http://www.ordnancesurvey.co.uk/ontology/Datatypes.owl#",
  "protegedc": "http://protege.stanford.edu/plugins/owl/dc/protege-dc.owl#",
  "tao": "http://pubannotation.org/ontology/tao.owl#",
  "ost": "http://w3id.org/ost/ns#",
  "genab": "http://eulersharp.sourceforge.net/2003/03swap/genomeAbnormality#",
  "stac": "http://securitytoolbox.appspot.com/stac#",
  "p20": "http://zbw.eu/beta/p20/vocab/",
  "mte": "http://nl.ijs.si/ME/owl/",
  "bk": "http://www.provbook.org/ns/#",
  "diseasome": "http://www4.wiwiss.fu-berlin.de/diseasome/resource/diseasome/",
  "pco": "http://purl.org/procurement/public-contracts#",
  "csm": "http://purl.org/csm/1.0#",
  "s2s": "http://escience.rpi.edu/ontology/sesf/s2s/4/0/",
  "mod": "http://www.isibang.ac.in/ns/mod#",
  "l4a": "http://labels4all.info/ns/",
  "wno": "http://wordnet-rdf.princeton.edu/ontology#",
  "pizza": "http://www.co-ode.org/ontologies/pizza/pizza.owl#",
  "ends": "http://labs.mondeca.com/vocab/endpointStatus#",
  "penis": "http://penis.to/#",
  "curr": "https://w3id.org/cc#",
  "mads": "http://www.loc.gov/mads/rdf/v1#",
  "shacl": "http://www.w3.org/ns/shacl#",
  "lod2": "http://lod2.eu/schema/",
  "fma": "http://sig.uw.edu/fma#",
  "odo": "http://ocean-data.org/schema/",
  "kbp": "http://tackbp.org/2013/ontology#",
  "lso": "http://linkedspending.aksw.org/ontology/",
  "skos08": "http://www.w3.org/2008/05/skos#",
  "str": "http://nlp2rdf.lod2.eu/schema/string/",
  "wfprov": "http://purl.org/wf4ever/wfprov#",
  "verb": "https://w3id.org/verb/",
  "b2rpubchem": "http://bio2rdf.org/ns/ns/ns/pubchem#",
  "genea": "http://www.owl-ontologies.com/generations.owl#",
  "gesis": "http://lod.gesis.org/lodpilot/ALLBUS/vocab.rdf#",
  "rdacarrier": "http://rdvocab.info/termList/RDACarrierType/",
  "art": "http://w3id.org/art/terms/1.0/",
  "hasco": "http://hadatac.org/ont/hasco/",
  "ds": "http://purl.org/ctic/dcat#",
  "atomrdf": "http://atomowl.org/ontologies/atomrdf#",
  "sci": "http://data.scientology.org/ns/",
  "nocal": "http://vocab.deri.ie/nocal#",
  "poder": "http://poderopedia.com/vocab/",
  "wsl": "http://www.wsmo.org/ns/wsmo-lite#",
  "sbench": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
  "doas": "http://deductions.github.io/doas.owl.ttl#",
  "vgo": "http://purl.org/net/VideoGameOntology#",
  "scms": "http://ns.aksw.org/scms/annotations/",
  "oslo": "http://purl.org/oslo/ns/localgov#",
  "scor": "http://purl.org/eis/vocab/scor#",
  "dpl": "http://dbpedialite.org/things/",
  "opllic": "http://www.openlinksw.com/ontology/licenses#",
  "of": "http://owlrep.eu01.aws.af.cm/fridge#",
  "smg": "http://ns.cerise-project.nl/energy/def/cim-smartgrid#",
  "camelot": "http://vocab.ox.ac.uk/camelot#",
  "lio": "http://purl.org/net/lio#",
  "dpc": "http://hospee.org/ontologies/dpc/",
  "tac": "http://ns.bergnet.org/tac/0.1/triple-access-control#",
  "biordf": "http://purl.org/net/biordfmicroarray/ns#",
  "pod": "https://project-open-data.cio.gov/v1.1/schema/#",
  "prvr": "http://purl.org/ontology/prv/rules#",
  "sam": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling#",
  "cpsv": "http://purl.org/vocab/cpsv#",
  "omnlife": "http://open-multinet.info/ontology/omn-lifecycle#",
  "lc": "http://semweb.mmlab.be/ns/linkedconnections#",
  "itsmo": "http://ontology.it/itsmo/v1#",
  "prvt": "http://purl.org/net/provenance/types#",
  "insdc": "http://ddbj.nig.ac.jp/ontologies/sequence#",
  "latitude": "https://www.w3.org/2006/vcard/ns#",
  "dn": "http://purl.org/datanode/ns/",
  "bv": "http://purl.org/vocommons/bv#",
  "clinproc": "http://www.agfa.com/w3c/2009/clinicalProcedure#",
  "ptop": "http://www.ontotext.com/proton/protontop#",
  "jpo": "http://rdf.jpostdb.org/ontology/jpost.owl#",
  "opencyc": "http://sw.opencyc.org/concept/",
  "faq": "http://www.openlinksw.com/ontology/faq#",
  "healthcare": "http://www.agfa.com/w3c/2009/healthCare#",
  "shoah": "http://dati.cdec.it/lod/shoah/",
  "osp": "http://data.lirmm.fr/ontologies/osp#",
  "campsite": "http://www.openlinksw.com/campsites/schema#",
  "guo": "http://purl.org/hpi/guo#",
  "lh": "http://vocab.inf.ed.ac.uk/library/holdings#",
  "ssso": "http://purl.org/ontology/ssso#",
  "ql": "http://www.w3.org/2004/ql#",
  "sioctypes": "http://rdfs.org/sioc/types#",
  "aerols": "http://xmlns.com/aerols/0.1/",
  "cart": "http://purl.org/net/cartCoord#",
  "sso": "http://nlp2rdf.lod2.eu/schema/sso/",
  "mpeg7": "http://rhizomik.net/ontologies/2005/03/Mpeg7-2001.owl#",
  "tisc": "http://observedchange.com/tisc/ns#",
  "stream": "http://dbpedia.org/ontology/Stream/",
  "shw": "http://paul.staroch.name/thesis/SmartHomeWeather.owl#",
  "centrifuge": "http://purl.org/twc/vocab/centrifuge#",
  "dbyago": "http://dbpedia.org/class/yago/",
  "mmd": "http://musicbrainz.org/ns/mmd-1.0#",
  "iol": "http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl#",
  "ngeoi": "http://vocab.lenka.no/geo-deling#",
  "security": "http://securitytoolbox.appspot.com/securityMain#",
  "chembl": "http://rdf.ebi.ac.uk/terms/chembl#",
  "te": "http://www.w3.org/2006/time-entry#",
  "hifm": "http://purl.org/net/hifm/data#",
  "okg": "http://openknowledgegraph.org/ontology/",
  "sao": "http://salt.semanticauthoring.org/ontologies/sao#",
  "gov": "http://gov.genealogy.net/ontology.owl#",
  "dash": "http://datashapes.org/dash#",
  "ottr": "http://ns.ottr.xyz/templates#",
  "pronom": "http://reference.data.gov.uk/technical-registry/",
  "category": "http://dbpedia.org/resource/Category:",
  "refe": "http://orion.tw.rpi.edu/~xgmatwc/refe/",
  "thors": "http://resource.geosciml.org/ontology/timescale/thors#",
  "vsto": "http://escience.rpi.edu/ontology/vsto/2/0/vsto.owl#",
  "alchemy": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
  "ebu": "http://semantic.eurobau.com/eurobau-utility.owl#",
  "mtecore": "http://purl.org/olia/mte/multext-east.owl#",
  "ecrm": "http://erlangen-crm.org/current/",
  "qrl": "http://www.aifb.kit.edu/project/ld-retriever/qrl#",
  "saxon": "http://saxon.sf.net/",
  "rdamt": "http://rdaregistry.info/termList/RDAMediaType/",
  "twaapi": "http://purl.org/twc/vocab/aapi-schema#",
  "rec54": "http://www.w3.org/2001/02pd/rec54.rdf#",
  "dpv": "http://www.w3.org/ns/dpv#",
  "xlime": "http://xlime-project.org/vocab/",
  "oml": "http://def.seegrid.csiro.au/ontology/om/om-lite#",
  "trait": "http://contextus.net/ontology/ontomedia/ext/common/trait#",
  "tw": "http://tw.rpi.edu/schema/",
  "lctr": "http://data.linkedct.org/vocab/resource/",
  "onssprel": "http://www.ordnancesurvey.co.uk/ontology/SpatialRelations/v0.2/SpatialRelations.owl#",
  "cis": "http://purl.org/NET/cloudisus#",
  "malignneo": "http://www.agfa.com/w3c/2009/malignantNeoplasm#",
  "cpant": "http://purl.org/NET/cpan-uri/terms#",
  "oarj": "http://opendepot.org/reference/linked/1.0/",
  "odcs": "http://opendata.cz/infrastructure/odcleanstore/",
  "lsc": "http://linkedscience.org/lsc/ns#",
  "cosmo": "http://purl.org/ontology/cosmo#",
  "idemo": "http://rdf.insee.fr/def/demo#",
  "fao": "http://fao.270a.info/dataset/",
  "yo": "http://yovisto.com/",
  "msr": "http://www.telegraphis.net/ontology/measurement/measurement#",
  "w3con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "who": "http://www.who.int/vocab/ontology#",
  "bgdbp": "http://bg.dbpedia.org/property/",
  "bcnnorms": "http://datos.bcn.cl/ontologies/bcn-norms#",
  "obsm": "http://rdf.geospecies.org/methods/observationMethod#",
  "cts2": "http://schema.omg.org/spec/CTS2/1.0/",
  "germplasm": "http://purl.org/germplasm/terms#",
  "ekaw": "http://data.semanticweb.org/conference/ekaw/2012/complete/",
  "zoomaterms": "http://rdf.ebi.ac.uk/vocabulary/zooma/",
  "xrd": "http://docs.oasis-open.org/ns/xri/xrd-1.0#",
  "wlo": "http://purl.org/ontology/wo/",
  "bihap": "http://bihap.kb.gov.tr/ontology/",
  "osgeom": "http://data.ordnancesurvey.co.uk/ontology/geometry/",
  "hints2005": "http://purl.org/twc/cabig/model/HINTS2005-1.owl#",
  "raul": "http://vocab.deri.ie/raul#",
  "strdf": "http://strdf.di.uoa.gr/ontology#",
  "gf": "http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature#",
  "vin": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine#",
  "rdafr": "http://rdaregistry.info/termList/frequency/",
  "li": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage#",
  "pkmn": "http://pokedex.dataincubator.org/pkm/",
  "qud": "http://qudt.org/1.1/schema/qudt#",
  "pnt": "http://data.press.net/ontology/tag/",
  "goog": "http://schema.googleapis.com/",
  "vartrans": "http://www.w3.org/ns/lemon/vartrans#",
  "c4dm": "http://purl.org/NET/c4dm/event.owl#",
  "conf": "http://richard.cyganiak.de/2007/pubby/config.rdf#",
  "scoro": "http://purl.org/spar/scoro/",
  "crv": "http://purl.org/twc/vocab/datacarver#",
  "l4lod": "http://ns.inria.fr/l4lod/v2/",
  "brick": "https://brickschema.org/schema/Brick#",
  "ccrel": "http://creativecommons.org/ns#",
  "lsmap": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
  "geovocab": "http://geovocab.org/",
  "antenne": "https://data.zendantennes.omgeving.vlaanderen.be/ns/zendantenne#",
  "dr": "http://purl.org/swan/2.0/discourse-relationships/",
  "oae": "http://www.ics.forth.gr/isl/oae/core#",
  "ep": "http://eprints.org/ontology/",
  "tm": "http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal#",
  "rmo": "http://eatld.et.tu-dresden.de/rmo#",
  "part": "http://purl.org/vocab/participation/schema#",
  "rdarel2": "http://metadataregistry.org/uri/schema/RDARelationshipsGR2/",
  "mmf": "http://linkedmultimedia.org/sparql-mm/ns/1.0.0/function#",
  "dawgt": "http://www.w3.org/2001/sw/DataAccess/tests/test-dawg#",
  "op": "http://environment.data.gov.au/def/op#",
  "emtr": "http://purl.org/NET/ssnext/electricmeters#",
  "rdae": "http://rdaregistry.info/Elements/e/",
  "odrs": "http://schema.theodi.org/odrs#",
  "rdafnm": "http://rdaregistry.info/termList/FormNoteMus/",
  "bn": "http://babelnet.org/rdf/",
  "mico": "http://www.mico-project.eu/ns/platform/1.0/schema#",
  "puelia": "http://kwijibo.talis.com/vocabs/puelia#",
  "bgt": "https://bgt.basisregistraties.overheid.nl/bgt/def/",
  "semio": "http://www.lingvoj.org/semio#",
  "esco": "http://data.europa.eu/esco/model#",
  "pv": "https://piveau.eu/ns/voc#",
  "rdasoi": "http://rdaregistry.info/termList/statIdentification/",
  "sdmxd": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "oplcert": "http://www.openlinksw.com/schemas/cert#",
  "seq": "http://www.ontologydesignpatterns.org/cp/owl/sequence.owl#",
  "quantities": "http://eulersharp.sourceforge.net/2003/03swap/quantitiesExtension#",
  "s4ac": "http://ns.inria.fr/s4ac/v2#",
  "stories": "http://purl.org/ontology/stories/",
  "rssynd": "http://web.resource.org/rss/1.0/modules/syndication/",
  "crml": "http://semweb.mmlab.be/ns/rml/condition#",
  "lcy": "http://purl.org/vocab/lifecycle/schema#",
  "wb": "http://data.worldbank.org/",
  "namespaces": "https://vg.no/",
  "webbox": "http://webbox.ecs.soton.ac.uk/ns#",
  "activity": "https://www.w3.org/TR/activitystreams-vocabulary/",
  "dbcat": "http://dbpedia.org/resource/Category:",
  "omapi": "http://purl.org/omapi/0.2/#",
  "d2d": "http://rdfns.org/d2d/",
  "dcs": "http://ontologi.es/doap-changeset#",
  "kbv": "https://id.kb.se/vocab/",
  "ll": "http://lodlaundromat.org/resource/",
  "wikterms": "http://wiktionary.dbpedia.org/terms/",
  "vsso": "http://automotive.eurecom.fr/vsso#",
  "seokoeln": "http://rankrage.de/",
  "oan": "http://data.lirmm.fr/ontologies/oan/",
  "mb": "http://dbtune.org/musicbrainz/resource/instrument/",
  "bgn": "http://bibliograph.net/schemas/",
  "lsqv": "http://lsq.aksw.org/vocab#",
  "cbo": "http://comicmeta.org/cbo/",
  "kees": "http://linkeddata.center/kees/v1#",
  "fos": "http://futurios.org/fos/spec/",
  "mv": "http://schema.mobivoc.org/",
  "disease": "http://www.agfa.com/w3c/2009/humanDisorder#",
  "lodac": "http://lod.ac/ns/lodac#",
  "rdacontent": "http://rdvocab.info/termList/RDAContentType/",
  "holding": "http://purl.org/ontology/holding#",
  "cwrc": "http://sparql.cwrc.ca/ontology/cwrc#",
  "pingback": "http://purl.org/net/pingback/",
  "laposte": "http://data.lirmm.fr/ontologies/laposte#",
  "dcndl": "http://ndl.go.jp/dcndl/terms/",
  "tblcard": "http://www.w3.org/People/Berners-Lee/card#",
  "spt": "http://spitfire-project.eu/ontology/ns/",
  "wkd": "http://schema.wolterskluwer.de/",
  "mged": "http://mged.sourceforge.net/ontologies/MGEDOntology.owl#",
  "eui": "http://institutions.publicdata.eu/#",
  "mt": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "nidm": "http://nidm.nidash.org/",
  "my": "http://www.mobile.com/model/",
  "xapi": "https://w3id.org/xapi/ontology#",
  "sg": "http://name.scigraph.com/ontologies/core/",
  "rdamedia": "http://rdvocab.info/termList/RDAMediaType/",
  "cbase": "http://ontologycentral.com/2010/05/cb/vocab#",
  "im": "http://imgpedia.dcc.uchile.cl/resource/",
  "vsws": "http://verticalsearchworks.com/ontology/synset#",
  "pnc": "http://data.press.net/ontology/classification/",
  "gastro": "http://www.ebsemantics.net/gastro#",
  "tg": "https://triplydb.com/Triply/tg/def/",
  "gl": "http://schema.geolink.org/",
  "allot": "https://w3id.org/akn/ontology/allot#",
  "scip": "http://lod.taxonconcept.org/ontology/sci_people.owl#",
  "dqm": "http://purl.org/dqm-vocabulary/v1/dqm#",
  "ogc": "http://www.opengis.net/def/",
  "xcql": "http://docs.oasis-open.org/ns/search-ws/xcql#",
  "pattern": "http://www.essepuntato.it/2008/12/pattern#",
  "finlaw": "http://purl.org/finlex/schema/laki/",
  "deps": "http://ontologi.es/doap-deps#",
  "onyx": "http://www.gsi.dit.upm.es/ontologies/onyx/ns#",
  "pni": "http://data.press.net/ontology/identifier/",
  "prof": "http://www.w3.org/ns/dx/prof/",
  "rdacct": "http://rdaregistry.info/termList/CollTitle/",
  "quty": "http://www.telegraphis.net/ontology/measurement/quantity#",
  "dbpr": "http://dbpedia.org/resource/",
  "delta": "http://www.w3.org/2004/delta#",
  "c9d": "http://purl.org/twc/vocab/conversion/",
  "auto": "http://auto.schema.org/",
  "telmap": "http://purl.org/telmap/",
  "cvbase": "http://purl.org/captsolo/resume-rdf/0.2/base#",
  "doi": "https://doi.org/",
  "mrel": "http://id.loc.gov/vocabulary/relators/",
  "saws": "http://purl.org/saws/ontology#",
  "app": "http://jmvanel.free.fr/ontology/software_applications.n3#",
  "ox": "http://vocab.ox.ac.uk/projectfunding#",
  "gm": "http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry#",
  "moac": "http://observedchange.com/moac/ns#",
  "accom": "http://purl.org/acco/ns#",
  "fog": "https://w3id.org/fog#",
  "rvdata": "http://data.rvdata.us/",
  "lsweb": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
  "ostop": "http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl#",
  "rdatc": "http://rdaregistry.info/termList/trackConfig/",
  "snarm": "http://rdf.myexperiment.org/ontologies/snarm/",
  "lmo": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/ontology#",
  "lldr": "http://purl.oclc.org/NET/lldr/ns#",
  "rdagd": "http://rdaregistry.info/termList/gender/",
  "affymetrix": "http://bio2rdf.org/affymetrix_vocabulary:",
  "friends": "http://www.openarchives.org/OAI/2.0/friends/",
  "osspr": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "bcnbio": "http://datos.bcn.cl/ontologies/bcn-biographies#",
  "foam": "https://www.koerperfettwaage-test.de/",
  "stats": "http://purl.org/rdfstats/stats#",
  "orth": "http://purl.org/net/orth#",
  "tsioc": "http://rdfs.org/sioc/types#",
  "evident": "http://purl.org/net/evident#",
  "daisy": "http://www.daisy.org/z3998/2012/vocab/",
  "dbrc": "http://dbpedia.org/resource/Category:",
  "oss": "http://opendata.caceres.es/def/ontosemanasanta#",
  "bot": "https://w3id.org/bot#",
  "bgcat": "http://bg.dbpedia.org/resource/?????????:",
  "fam": "http://vocab.fusepool.info/fam#",
  "pair": "http://virtual-assembly.org/ontologies/pair#",
  "drm": "http://vocab.data.gov/def/drm#",
  "isocat": "http://www.isocat.org/datcat/",
  "od": "http://purl.org/twc/vocab/opendap#",
  "mvco": "http://purl.oclc.org/NET/mvco.owl#",
  "ftcontent": "http://www.ft.com/ontology/content/",
  "spfood": "http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl#",
  "dbptmpl": "http://dbpedia.org/resource/Template:",
  "fincaselaw": "http://purl.org/finlex/schema/oikeus/",
  "eumida": "http://data.kasabi.com/dataset/eumida/terms/",
  "origins": "http://origins.link/",
  "employee": "http://www.employee.com/data#",
  "ccp": "http://cookingbigdata.com/linkeddata/ccpricing#",
  "gcis": "http://data.globalchange.gov/gcis.owl#",
  "biro": "http://purl.org/spar/biro/",
  "dvia": "http://data.eurecom.fr/ontology/dvia#",
  "mil": "http://rdf.muninn-project.org/ontologies/military#",
  "swperson": "http://data.semanticweb.org/person/",
  "driver": "http://deductions.github.io/drivers.owl.ttl#",
  "graffle": "http://purl.org/twc/vocab/vsr/graffle#",
  "particip": "http://purl.org/vocab/participation/schema#",
  "ljkl": "http://teste.com/",
  "aers": "http://aers.data2semantics.org/resource/",
  "add": "https://mre.zcu.cz/ontology/stroke.owl#",
  "rdami": "http://rdaregistry.info/termList/modeIssue/",
  "mml": "http://www.w3.org/1998/Math/MathML/",
  "viso": "http://purl.org/viso/",
  "agls": "http://www.agls.gov.au/agls/terms/",
  "nerd": "http://nerd.eurecom.fr/ontology#",
  "radion": "http://www.w3.org/ns/radion#",
  "mtlo": "http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl#",
  "merge": "http://jazz.net/ns/lqe/merge/",
  "salad": "https://w3id.org/cwl/salad#",
  "turismo": "http://idi.fundacionctic.org/cruzar/turismo#",
  "company": "http://intellimind.io/ns/company#",
  "dao": "http://purl.org/dao#",
  "gpml": "http://vocabularies.wikipathways.org/gpml#",
  "rdagw": "http://rdaregistry.info/termList/grooveWidth/",
  "wn31": "http://wordnet-rdf.princeton.edu/wn31/",
  "esaloj": "http://vocab.linkeddata.es/datosabiertos/def/turismo/alojamiento#",
  "gawd": "http://gawd.atlantides.org/terms/",
  "pvcs": "http://purl.org/twc/vocab/pvcs#",
  "onc": "http://www.ics.forth.gr/isl/oncm/core#",
  "odpart": "http://www.ontologydesignpatterns.org/cp/owl/participation.owl#",
  "fcs": "http://clarin.eu/fcs/resource#",
  "sct": "http://snomed.info/id/",
  "pkm": "http://www.ontotext.com/proton/protonkm#",
  "call": "http://webofcode.org/wfn/call:",
  "oh": "http://semweb.mmlab.be/ns/oh#",
  "infor": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "lden": "http://www.linklion.org/lden/",
  "npgx": "http://ns.nature.com/extensions/",
  "rdarel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "dogont": "http://elite.polito.it/ontologies/dogont.owl#",
  "lsd": "http://linkedwidgets.org/statisticaldata/ontology/",
  "icane": "http://www.icane.es/opendata/vocab#",
  "pmd": "https://w3id.org/pmd/co/",
  "llo": "http://lodlaundromat.org/ontology/",
  "ctorg": "http://purl.org/ctic/infraestructuras/organizacion#",
  "cdao": "http://purl.obolibrary.org/obo/",
  "agr": "http://promsns.org/def/agr#",
  "ramon": "http://rdfdata.eionet.europa.eu/ramon/ontology/",
  "w3po": "http://purl.org/provenance/w3p/w3po#",
  "pic": "http://www.ipaw.info/ns/picaso#",
  "qb4o": "http://purl.org/olap#",
  "viskov": "http://trust.utep.edu/visko/ontology/visko-view-v3.owl#",
  "voidp": "http://www.enakting.org/provenance/voidp/",
  "hto": "http://project-haystack.org/hto#",
  "ontopic": "http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl#",
  "ws": "http://www.w3.org/ns/pim/space#",
  "ids": "https://w3id.org/idsa/core/",
  "olad": "http://openlad.org/vocab#",
  "odapp": "http://vocab.deri.ie/odapp#",
  "pato": "http://purl.obolibrary.org/obo/",
  "rdabm": "http://rdaregistry.info/termList/RDABaseMaterial/",
  "dcoid": "http://dx.deepcarbon.net/",
  "s3db": "http://www.s3db.org/core#",
  "language": "http://id.loc.gov/vocabulary/iso639-1/",
  "lexcz": "http://purl.org/lex/cz#",
  "bwb": "http://doc.metalex.eu/bwb/ontology/",
  "uc": "http://ucuenca.edu.ec/ontology#",
  "lexicon": "http://www.example.org/lexicon#",
  "ldt": "https://www.w3.org/ns/ldt#",
  "swpm": "http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0#",
  "lpeu": "http://purl.org/linkedpolitics/vocabulary/eu/plenary/",
  "esequip": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/equipamiento#",
  "being": "http://purl.org/ontomedia/ext/common/being#",
  "emoca": "http://ns.inria.fr/emoca#",
  "webservice": "http://www.openlinksw.com/ontology/webservices#",
  "dot": "https://w3id.org/dot#",
  "lmm1": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl#",
  "geojson": "https://purl.org/geojson/vocab#",
  "samfl": "http://def.seegrid.csiro.au/ontology/om/sam-lite#",
  "qvoc": "http://mlode.nlp2rdf.org/quranvocab#",
  "sylld": "http://www.semanticweb.org/syllabus/data/",
  "lw": "http://linkedwidgets.org/ontologies/",
  "lda": "http://purl.org/linked-data/api/vocab#",
  "eurostat": "http://dd.eionet.europa.eu/vocabulary/eurostat/",
  "wfn": "http://webofcode.org/wfn/",
  "imo": "http://imgpedia.dcc.uchile.cl/ontology#",
  "roevo": "http://purl.org/wf4ever/roevo#",
  "dcite": "http://purl.org/spar/datacite/",
  "ou": "https://opendata.unex.es/def/ontouniversidad#",
  "phdd": "http://rdf-vocabulary.ddialliance.org/phdd#",
  "geos": "http://www.telegraphis.net/ontology/geography/geography#",
  "bgdbr": "http://bg.dbpedia.org/resource/",
  "year": "http://www.w3.org/year/",
  "dcx": "http://dublincore.org/dcx/",
  "rdact": "http://rdaregistry.info/termList/RDACarrierType/",
  "cmdm": "http://infra.clarin.eu/cmd/",
  "bioc": "http://deductions.github.io/biological-collections.owl.ttl#",
  "agrd": "http://agrinepaldata.com/",
  "lmm2": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl#",
  "dbtont": "http://dbtropes.org/ont/",
  "d0": "http://ontologydesignpatterns.org/ont/wikipedia/d0.owl#",
  "pmc": "http://identifiers.org/pmc/",
  "zr": "http://explain.z3950.org/dtd/2.0/",
  "amalgame": "http://purl.org/vocabularies/amalgame#",
  "tddo": "http://databugger.aksw.org/ns/core#",
  "fire": "http://tldp.org/HOWTO/XML-RPC-HOWTO/xmlrpc-howto-java.html#",
  "hico": "http://purl.org/emmedi/hico/",
  "ppn": "http://parliament.uk/ontologies/person-name/",
  "rdl": "http://data.posccaesar.org/rdl/",
  "gnvc": "http://purl.org/gc/",
  "ns1": "http://www.w3.org/1999/xhtml/vocab#",
  "ceterms": "http://purl.org/ctdl/terms/",
  "situ": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "gt": "https://vocab.eccenca.com/geniustex/",
  "scufl2": "http://ns.taverna.org.uk/2010/scufl2#",
  "gadm": "http://gadm.geovocab.org/ontology#",
  "olac": "http://www.language-archives.org/OLAC/1.0/",
  "s4envi": "https://w3id.org/def/saref4envi#",
  "static": "http://vocab-ld.org/vocab/static-ld#",
  "pois": "http://purl.oclc.org/POIS/vcblr#",
  "bbcprov": "http://www.bbc.co.uk/ontologies/provenance/",
  "step": "http://purl.org/net/step#",
  "eunis": "http://eunis.eea.europa.eu/rdf/species-schema.rdf#",
  "kai": "http://kai.uni-kiel.de/",
  "wikim": "http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0#",
  "omnfed": "http://open-multinet.info/ontology/omn-federation#",
  "coll": "http://purl.org/co/",
  "vext": "http://ldf.fi/void-ext#",
  "galaksiya": "http://ontoloji.galaksiya.com/vocab/",
  "waarde": "https://lod.milieuinfo.be/ns/waarde#",
  "msm": "http://iserve.kmi.open.ac.uk/ns/msm#",
  "wf4ever": "http://purl.org/wf4ever/wf4ever#",
  "roar": "https://w3id.org/roar#",
  "elec": "http://purl.org/ctic/sector-publico/elecciones#",
  "gaf": "http://groundedannotationframework.org/",
  "dq": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality#",
  "graves": "http://rdf.muninn-project.org/ontologies/graves#",
  "jp1": "http://rdf.muninn-project.org/ontologies/jp1/",
  "jolux": "http://data.legilux.public.lu/resource/ontology/jolux#",
  "si": "https://si-digital-framework.org/SI#",
  "dio": "https://w3id.org/dio#",
  "puml": "http://plantuml.com/ontology#",
  "vsw": "http://verticalsearchworks.com/ontology/",
  "viskoo": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
  "locwd": "http://purl.org/locwd/schema#",
  "prviv": "http://purl.org/net/provenance/integrity#",
  "biotop": "http://purl.org/biotop/biotop.owl#",
  "rdafs": "http://rdaregistry.info/termList/fontSize/",
  "lmdb": "http://data.linkedmdb.org/",
  "vmm": "http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0#",
  "pcdt": "http://purl.org/procurement/public-contracts-datatypes#",
  "vvo": "http://purl.org/vvo/ns#",
  "omdoc": "http://omdoc.org/ontology/",
  "vag": "http://www.essepuntato.it/2013/10/vagueness/",
  "pid": "http://permid.org/ontology/organization/",
  "location": "http://sw.deri.org/2006/07/location/loc#",
  "trig": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "oplprod": "http://www.openlinksw.com/ontology/products#",
  "ldl": "https://w3id.org/ldpdl/ns#",
  "fcp": "http://www.newmedialab.at/fcp/",
  "vir": "http://w3id.org/vir#",
  "bnf": "http://www.w3.org/2000/10/swap/grammar/bnf#",
  "osadm": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "poste": "http://data.lirmm.fr/ontologies/poste#",
  "fred": "http://www.ontologydesignpatterns.org/ont/fred/domain.owl#",
  "vapour": "http://vapour.sourceforge.net/vocab.rdf#",
  "opengov": "http://www.w3.org/opengov#",
  "rut": "http://rdfunit.aksw.org/ns/core#",
  "rdai": "http://rdaregistry.info/Elements/i/",
  "ecglview": "http://schema.geolink.org/view/",
  "moo": "http://www.movieontology.org/2009/11/09/movieontology.owl#",
  "fuseki": "http://jena.apache.org/fuseki#",
  "rlnr": "http://rdflivenews.aksw.org/resource/",
  "airs": "https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#",
  "frb": "http://frb.270a.info/dataset/",
  "wn20": "http://www.w3.org/2006/03/wn/wn20/",
  "uis": "http://uis.270a.info/dataset/",
  "geosp": "http://rdf.geospecies.org/ont/geospecies#",
  "rdagrp": "http://rdaregistry.info/termList/groovePitch/",
  "opmo": "http://openprovenance.org/model/opmo#",
  "aws": "http://purl.oclc.org/NET/ssnx/meteo/aws#",
  "mammal": "http://lod.taxonconcept.org/ontology/p01/Mammalia/index.owl#",
  "owl2xml": "http://www.w3.org/2006/12/owl2-xml#",
  "led": "http://led.kmi.open.ac.uk/term/",
  "regorg": "http://www.w3.org/ns/regorg#",
  "incident": "http://vocab.resc.info/incident#",
  "geocontext": "http://www.geocontext.org/publ/2013/vocab#",
  "npdv": "http://sws.ifi.uio.no/vocab/npd#",
  "odbc": "http://www.openlinksw.com/ontology/odbc#",
  "fnabox": "http://www.ontologydesignpatterns.org/ont/framenet/abox/",
  "oecc": "http://www.oegov.org/core/owl/cc#",
  "llm": "http://lodlaundromat.org/metrics/ontology/",
  "crime": "http://purl.org/vocab/reloc/",
  "rvz": "http://rdfvizler.dyreriket.xyz/vocabulary/core#",
  "gci": "http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl#",
  "teamwork": "http://topbraid.org/teamwork#",
  "rdatr": "http://rdaregistry.info/termList/typeRec/",
  "dsn": "http://purl.org/dsnotify/vocab/eventset/",
  "bpo": "https://w3id.org/bpo#",
  "proms": "http://promsns.org/def/proms#",
  "lcdr": "http://ns.lucid-project.org/revision/",
  "aktivesa": "http://sa.aktivespace.org/ontologies/aktivesa#",
  "cpack": "http://cliopatria.swi-prolog.org/schema/cpack#",
  "pwo": "http://purl.org/spar/pwo/",
  "ontosec": "http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl#",
  "saif": "http://wwwiti.cs.uni-magdeburg.de/~srahman/",
  "obeu": "http://data.openbudgets.eu/ontology/",
  "topo": "http://data.ign.fr/def/topo#",
  "rdf123": "http://rdf123.umbc.edu/ns/",
  "acrt": "http://privatealpha.com/ontology/certification/1#",
  "owlse": "http://www.daml.org/services/owl-s/1.2/generic/Expression.owl#",
  "vrank": "http://purl.org/voc/vrank#",
  "cd": "http://citydata.wu.ac.at/ns#",
  "mocanal": "http://www.semanticweb.org/asow/ontologies/2013/9/untitled-ontology-36#",
  "beth": "http://www.google.com/",
  "eccauth": "https://vocab.eccenca.com/auth/",
  "lido": "http://www.lido-schema.org/",
  "jpost": "http://rdf.jpostdb.org/ontology/jpost.owl#",
  "rdacc": "http://rdaregistry.info/termList/RDAColourContent/",
  "genre": "http://sparql.cwrc.ca/ontologies/genre#",
  "mmoon": "http://mmoon.org/mmoon/",
  "pkgsrc": "http://pkgsrc.co/schema#",
  "frbrer": "http://iflastandards.info/ns/fr/frbr/frbrer/",
  "pdf": "http://ns.adobe.com/pdf/1.3/",
  "limo": "http://www.purl.org/limo-ontology/limo#",
  "text": "http://jena.apache.org/text#",
  "omg": "https://w3id.org/omg#",
  "ssno": "http://www.w3.org/ns/ssn/",
  "tis": "http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl#",
  "ln": "https://w3id.org/ln#",
  "odv": "http://reference.data.gov.uk/def/organogram/",
  "reegle": "http://reegle.info/schema#",
  "sx": "http://shex.io/ns/shex#",
  "ali": "http://www.niso.org/schemas/ali/1.0/",
  "locah": "http://data.archiveshub.ac.uk/def/",
  "limoo": "http://purl.org/LiMo/0.1/",
  "studiop": "http://purl.org/resource/pilatesstudio/",
  "bcngeo": "http://datos.bcn.cl/ontologies/bcn-geographics#",
  "bner": "http://datos.bne.es/resource/",
  "edgar": "http://edgarwrap.ontologycentral.com/vocab/edgar#",
  "rdarole": "http://rdvocab.info/roles/",
  "condition": "http://www.kinjal.com/condition:",
  "cwlprov": "https://w3id.org/cwl/prov#",
  "r3d": "http://www.re3data.org/schema/3-0#",
  "output": "http://volt-name.space/vocab/output#",
  "ldvm": "http://linked.opendata.cz/ontology/ldvm/",
  "roterms": "http://purl.org/wf4ever/roterms#",
  "rofch": "http://rdaregistry.info/termList/rofch/",
  "hlygt": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "oils": "http://lemon-model.net/oils#",
  "reg": "http://purl.org/linked-data/registry#",
  "afr": "http://purl.allotrope.org/ontologies/result#",
  "passim": "http://data.lirmm.fr/ontologies/passim#",
  "imf": "http://imf.270a.info/dataset/",
  "lexvo": "http://lexvo.org/ontology#",
  "plg": "http://parliament.uk/ontologies/legislation/",
  "defns": "http://www.openarchives.org/OAI/2.0/",
  "rdafmn": "http://rdaregistry.info/termList/MusNotation/",
  "muldicat": "http://iflastandards.info/ns/muldicat#",
  "nxs": "http://www.neclimateus.org/",
  "jjd": "http://www.joshuajeeson.com/",
  "frsad": "http://iflastandards.info/ns/fr/frsad/",
  "glview": "http://schema.geolink.org/dev/view/",
  "ecgl": "http://schema.geolink.org/",
  "sto": "https://w3id.org/i40/sto#",
  "babelnet": "http://babelnet.org/2.0/",
  "rdarm": "http://registry.info/termList/recMedium/",
  "csv": "http://vocab.sindice.net/csv/",
  "kegg": "http://bio2rdf.org/ns/kegg#",
  "sru": "http://www.loc.gov/zing/srw/",
  "tb": "https://w3id.org/timebank#",
  "gq": "http://genomequest.com/",
  "logies": "https://data.vlaanderen.be/ns/logies#",
  "sirene": "https://sireneld.io/vocab/sirene#",
  "laabs": "http://dbpedia.org/resource/",
  "csp": "http://vocab.deri.ie/csp#",
  "ordf": "http://purl.org/NET/ordf/",
  "caplibacl": "http://schemas.capita-libraries.co.uk/2015/acl/schema#",
  "orcid": "http://orcid.org/",
  "webac": "http://fedora.info/definitions/v4/webac#",
  "pproc": "http://contsem.unizar.es/def/sector-publico/pproc#",
  "tui": "http://data.ifs.tuwien.ac.at/study/resource/",
  "water": "http://escience.rpi.edu/ontology/semanteco/2/0/water.owl#",
  "afm": "http://purl.allotrope.org/ontologies/material/",
  "form": "http://deductions-software.com/ontologies/forms.owl.ttl#",
  "iana": "http://www.iana.org/assignments/relation/",
  "spdx": "http://spdx.org/rdf/terms#",
  "eem": "http://purl.org/eem#",
  "rdaterm": "http://rdaregistry.info/termList/RDATerms/",
  "citof": "http://www.essepuntato.it/2013/03/cito-functions#",
  "basic": "http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic#",
  "cocoon": "https://w3id.org/cocoon/v1.0#",
  "crowd": "http://purl.org/crowd/",
  "dicom": "http://purl.org/healthcarevocab/v1#",
  "ubiq": "http://server.ubiqore.com/ubiq/core#",
  "figigii": "http://www.omg.org/spec/FIGI/GlobalInstrumentIdentifiers/",
  "voc": "http://voc.odw.tw/",
  "lyon": "http://dbpedia.org/resource/Lyon/",
  "task": "http://deductions.github.io/task-management.owl.ttl#",
  "mdi": "http://w3id.org/multidimensional-interface/ontology#",
  "iati": "http://purl.org/collections/iati/",
  "eccrev": "https://vocab.eccenca.com/revision/",
  "infection": "http://www.agfa.com/w3c/2009/infectiousDisorder#",
  "eepsa": "https://w3id.org/eepsa#",
  "agrovoc": "http://aims.fao.org/aos/agrovoc/",
  "lofv": "http://purl.org/legal_form/vocab#",
  "lawd": "http://lawd.info/ontology/",
  "rdaco": "http://rdaregistry.info/termList/RDAContentType/",
  "rdaftn": "http://rdaregistry.info/termList/TacNotation/",
  "fntbox": "http://www.ontologydesignpatterns.org/ont/framenet/tbox/",
  "oxi": "http://omerxi.com/ontologies/core.owl.ttl#",
  "vdpp": "http://data.lirmm.fr/ontologies/vdpp#",
  "bbccms": "http://www.bbc.co.uk/ontologies/cms/",
  "lingvo": "http://www.lingvoj.org/ontology#",
  "gts": "http://resource.geosciml.org/ontology/timescale/gts#",
  "gdc": "https://portal.gdc.cancer.gov/cases/",
  "clirio": "http://clirio.kaerle.com/clirio.owl#",
  "conference": "https://w3id.org/scholarlydata/ontology/conference-ontology.owl#",
  "eurlex": "http://eur-lex.publicdata.eu/ontology/",
  "hva": "http://www.ebusiness-unibw.org/ontologies/hva/ontology#",
  "asgv": "http://aims.fao.org/aos/agrovoc/",
  "oplcb": "http://www.openlinksw.com/schemas/crunchbase#",
  "contsem": "http://contsem.unizar.es/def/sector-publico/contratacion#",
  "datacite": "http://purl.org/spar/datacite/",
  "rls": "https://w3id.org/lovcube/ns/relovstats#",
  "oprovo": "http://openprovenance.org/ontology#",
  "roadmap": "http://mappings.roadmap.org/",
  "swpatho": "http://swpatho.ag-nbi.de/context/meta.owl#",
  "oplecrm": "http://www.openlinksw.com/ontology/ecrm#",
  "cbim": "http://www.coinsweb.nl/cbim-2.0.rdf#",
  "bb": "http://www.snik.eu/ontology/bb/",
  "cim": "http://iec.ch/TC57/2013/CIM-schema-cim16#",
  "ruian": "https://data.cssz.cz/ontology/ruian/",
  "lswmo": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl#",
  "lswpm": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl#",
  "meeting": "http://www.w3.org/2002/07/meeting#",
  "owsom": "https://onlinesocialmeasures.wordpress.com/",
  "open311": "http://ontology.eil.utoronto.ca/open311#",
  "pep": "https://w3id.org/pep/",
  "customer": "http://www.valuelabs.com/",
  "umls": "http://bioportal.bioontology.org/ontologies/umls/",
  "yd": "https://yodata.io/",
  "sdmxcode": "http://purl.org/linked-data/sdmx/2009/code#",
  "rdalay": "http://rdaregistry.info/termList/layout/",
  "bsym": "http://bsym.bloomberg.com/sym/",
  "tree": "https://w3id.org/tree#",
  "county": "http://myexample.org/county#",
  "shui": "https://vocab.eccenca.com/shui/",
  "scco": "http://rdf.ebi.ac.uk/terms/surechembl#",
  "tsn": "http://purl.org/net/tsn#",
  "ha": "http://sensormeasurement.appspot.com/ont/home/homeActivity#",
  "nlon": "http://lod.nl.go.kr/ontology/",
  "voidext": "http://rdfs.org/ns/void-ext#",
  "bdc": "http://dbpedia.org/resource/Category:",
  "fr": "https://w3id.org/fr/def/core#",
  "volt": "http://volt-name.space/ontology/",
  "hr": "http://iserve.kmi.open.ac.uk/ns/hrests#",
  "videogame": "http://purl.org/net/vgo#",
  "essglobal": "http://purl.org/essglobal/vocab/v1.0/",
  "pfeepsa": "https://w3id.org/pfeepsa#",
  "sfd": "http://semantic-forms.cc:9112/ldp/",
  "rdarr": "http://rdaregistry.info/termList/RDAReductionRatio/",
  "mls": "http://www.w3.org/ns/mls#",
  "drk": "http://drakon.su/",
  "ago": "http://awesemantic-geo.link/ontology/",
  "qms": "http://data.europa.eu/esco/qms#",
  "dsv": "https://w3id.org/dsv#",
  "bevon": "http://rdfs.co/bevon/",
  "rdafrbr": "http://rdvocab.info/uri/schema/FRBRentitiesRDA/",
  "mexv": "http://mex.aksw.org/mex-algo#",
  "numbers": "http://km.aifb.kit.edu/projects/numbers/",
  "uom": "http://www.opengis.net/def/uom/OGC/1.0/",
  "fun": "http://w3id.org/sparql-generate/fn/",
  "organ": "http://www.univalle.edu.co/ontologies/Organ#",
  "adf": "http://purl.allotrope.org/ontologies/datapackage#",
  "mmt": "http://linkedmultimedia.org/sparql-mm/functions/temporal#",
  "kml": "http://www.opengis.net/kml/2.2#",
  "ja": "http://jena.hpl.hp.com/2005/11/Assembler#",
  "cmdi": "http://www.clarin.eu/cmd/",
  "rofer": "http://rdaregistry.info/termList/rofer/",
  "keys": "http://purl.org/NET/c4dm/keys.owl#",
  "crsw": "http://courseware.rkbexplorer.com/ontologies/courseware#",
  "ogbd": "http://www.ogbd.fr/2012/ontologie#",
  "sakthi": "http://infotech.nitk.ac.in/research-scholars/sakthi-murugan-r/",
  "wdtn": "http://www.wikidata.org/prop/direct-normalized/",
  "owms": "http://standaarden.overheid.nl/owms/terms/",
  "apf": "http://jena.apache.org/ARQ/property#",
  "cjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
  "trao": "http://linkeddata.finki.ukim.mk/lod/ontology/tao#",
  "rdag2": "http://rdvocab.info/ElementsGr2/",
  "diag": "http://www.loc.gov/zing/srw/diagnostic/",
  "demlab": "http://www.demcare.eu/ontologies/demlab.owl#",
  "fhir": "http://hl7.org/fhir/",
  "chear": "http://hadatac.org/ont/chear#",
  "opa": "https://w3id.org/laas-iot/adream#",
  "dpn": "http://purl.org/dpn#",
  "composer": "http://dbpedia.org/ontology/composer/",
  "bds": "http://www.bigdata.com/rdf/search#",
  "munc": "http://ns.inria.fr/munc#",
  "lmx": "http://www.w3.org/XML/1998/namespace/",
  "td5": "http://td5.org/#",
  "rofrr": "http://rdaregistry.info/termList/rofrr/",
  "pp": "http://peoplesplaces.de/ontology#",
  "itm": "http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0#",
  "az": "https://w3id.org/people/az/",
  "lgdm": "http://linkedgeodata.org/meta/",
  "ruto": "http://rdfunit.aksw.org/ns/core#",
  "door": "http://kannel.open.ac.uk/ontology#",
  "mds": "http://doc.metalex.eu/id/",
  "cwl": "https://w3id.org/cwl/cwl#",
  "bblfish": "http://bblfish.net/people/henry/card#",
  "cwork": "http://www.bbc.co.uk/ontologies/creativework/",
  "navm": "https://w3id.org/navigation_menu#",
  "csdbp": "http://cs.dbpedia.org/",
  "aprov": "http://purl.org/a-proc#",
  "amt": "http://academic-meta-tool.xyz/vocab#",
  "radar": "http://www.radar-projekt.org/display/",
  "vstoi": "http://hadatac.org/ont/vstoi#",
  "ndnp": "http://chroniclingamerica.loc.gov/terms#",
  "ctrl": "https://w3id.org/ibp/CTRLont#",
  "soch": "http://kulturarvsdata.se/ksamsok#",
  "sdshare": "http://www.sdshare.org/2012/extension/",
  "whisky": "http://vocab.org/whisky/terms/",
  "audit": "http://fedora.info/definitions/v4/audit#",
  "rofem": "http://rdaregistry.info/termList/rofem/",
  "faostat": "http://reference.eionet.europa.eu/faostat/schema/",
  "lslife": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl#",
  "olca": "http://www.lingvoj.org/olca#",
  "jerm": "http://jermontology.org/ontology/JERMOntology#",
  "oliasystem": "http://purl.org/olia/system.owl#",
  "wimpo": "http://rdfex.org/withImports?uri=",
  "rofid": "http://rdaregistry.info/termList/rofid/",
  "doacc": "http://purl.org/net/bel-epa/doacc#",
  "bob": "http://good.dad/meaning/bob#",
  "dcosample": "http://info.deepcarbon.net/sample/schema#",
  "one": "https://bioportal.bioontology.org/ontologies/ONE/",
  "dk": "http://www.data-knowledge.org/dk/schema/rdf/latest/",
  "markus": "http://www.markus.com/",
  "seeds": "http://deductions.github.io/seeds.owl.ttl#",
  "rdasco": "http://rdaregistry.info/termList/soundCont/",
  "bis": "http://bis.270a.info/dataset/",
  "efrbroo": "http://erlangen-crm.org/efrbroo/",
  "datex": "http://vocab.datex.org/terms#",
  "scho": "http://www.scholarlydata.org/ontology/conference-ontology.owl#",
  "mexalgo": "http://mex.aksw.org/mex-algo#",
  "bld": "http://biglinkeddata.com/",
  "hello": "https://www.youtube.com/user/SuperTellAFriend/featured/",
  "gnm": "http://www.geonames.org/ontology/mappings/",
  "mandaat": "http://data.vlaanderen.be/ns/mandaat#",
  "assoc": "https://w3id.org/associations/vocab#",
  "bdo": "http://purl.bdrc.io/ontology/core/",
  "maso": "http://securitytoolbox.appspot.com/MASO#",
  "ecore": "http://www.eclipse.org/emf/2002/Ecore#",
  "memento": "http://mementoweb.org/ns#",
  "lheo": "http://www.conjecto.com/ontology/2015/lheo#",
  "opllog": "http://www.openlinksw.com/ontology/logging#",
  "svcs": "http://rdfs.org/sioc/services#",
  "conll": "http://ufal.mff.cuni.cz/conll2009-st/task-description.html#",
  "osd": "http://a9.com/-/spec/opensearch/1.1/",
  "lg": "https://purl.org/lg/",
  "oplmkt": "http://www.openlinksw.com/ontology/market#",
  "timex": "http://data.wu.ac.at/ns/timex#",
  "oplres": "http://www.openlinksw.com/ontology/restrictions#",
  "bdr": "http://purl.bdrc.io/resource/",
  "rpath": "https://w3id.org/lodsight/rdf-path#",
  "rofrt": "http://rdaregistry.info/termList/rofrt/",
  "rdapmt": "http://rdaregistry.info/termList/prodTactile/",
  "spcm": "http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0#",
  "erce": "http://xxefe.de/",
  "fnom": "https://w3id.org/function/vocabulary/mapping#",
  "qkdv": "http://qudt.org/vocab/dimensionvector/",
  "hasneto": "http://hadatac.org/ont/hasneto#",
  "llont": "http://www.linklion.org/ontology#",
  "sgg": "http://www.springernature.com/scigraph/graphs/",
  "emergelm": "http://purl.org/emergel/modules#",
  "tix": "http://toptix.com/2010/esro/",
  "sdt": "http://statisticaldata.linkedwidgets.org/terms/",
  "frappe": "http://streamreasoning.org/ontologies/frappe#",
  "ver": "https://w3id.org/version/ontology#",
  "oplli": "http://www.openlinksw.com/schemas/linkedin#",
  "bbccore": "http://www.bbc.co.uk/ontologies/coreconcepts/",
  "physics": "http://www.astro.umd.edu/~eshaya/astro-onto/owl/physics.owl#",
  "escom": "http://vocab.linkeddata.es/datosabiertos/def/comercio/tejidoComercial#",
  "planet": "http://dbpedia.org/",
  "rdabf": "http://rdaregistry.info/termList/bookFormat/",
  "gbol": "http://gbol.life/0.1#",
  "lovc": "https://w3id.org/lovcube/ns/lovcube#",
  "biml": "http://schemas.varigence.com/biml.xsd#",
  "vogd": "http://ogd.ifs.tuwien.ac.at/vienna/geo/",
  "edr": "https://w3id.org/laas-iot/edr#",
  "rdaemm": "http://rdaregistry.info/termList/emulsionMicro/",
  "geod": "http://vocab.lenka.no/geo-deling#",
  "eame": "http://www.semanticweb.org/ontologia_EA#",
  "ofrd": "http://purl.org/opdm/refrigerator#",
  "lemonuby": "http://lemon-model.net/lexica/uby/",
  "traffic": "http://www.sensormeasurement.appspot.com/ont/transport/traffic#",
  "w3cgeo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "mwapi": "https://www.mediawiki.org/ontology#API/",
  "its": "http://www.w3.org/2005/11/its/rdf#",
  "rdacarx": "http://rdaregistry.info/termList/RDACarrierEU/",
  "yaco": "https://www.irit.fr/recherches/MELODI/ontologies/cinema#",
  "eol": "http://purl.org/biodiversity/eol/",
  "eccpubsub": "https://vocab.eccenca.com/pubsub/",
  "foaffff": "http://gogl.com/",
  "dbms": "http://www.openlinksw.com/ontology/dbms-app-ontology#",
  "travel": "http://www.co-ode.org/roberts/travel.owl#",
  "summa": "http://purl.org/voc/summa/",
  "gont": "https://gont.ch/",
  "voidex": "http://www.swi-prolog.org/rdf/library/",
  "fdbp": "http://fr.dbpedia.org/property/",
  "ntag": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "rdabs": "http://rdaregistry.info/termList/broadcastStand/",
  "otl": "https://w3id.org/opentrafficlights#",
  "swrc2": "https://www.cs.vu.nl/~mcaklein/onto/swrc_ext/2005/05#",
  "rdaz": "http://rdaregistry.info/Elements/z/",
  "r4ta": "http://ns.inria.fr/ratio4ta/v1#",
  "pmo": "http://premon.fbk.eu/ontology/core#",
  "oplwebsrv": "http://www.openlinksw.com/ontology/webservices#",
  "oplweb": "http://www.openlinksw.com/schemas/oplweb#",
  "oplstocks": "http://www.openlinksw.com/ontology/stocks#",
  "url": "http://schema.org/",
  "rofin": "http://rdaregistry.info/termList/rofin/",
  "sgfn": "http://w3id.org/sparql-generate/fn/",
  "uta": "http://uptheasset.org/ontology#",
  "semiot": "http://w3id.org/semiot/ontologies/semiot#",
  "besluit": "http://data.vlaanderen.be/ns/besluit#",
  "iter": "http://w3id.org/sparql-generate/iter/",
  "ecoll": "http://purl.org/ceu/eco/1.0#",
  "espresup": "http://vocab.linkeddata.es/datosabiertos/def/hacienda/presupuestos#",
  "minim": "http://purl.org/minim/minim#",
  "frgeo": "http://rdf.insee.fr/geo/",
  "nno": "https://w3id.org/nno/ontology#",
  "system": "http://www.univalle.edu.co/ontologies/System#",
  "lmu": "https://w3id.org/laas-iot/lmu#",
  "rdapm": "http://rdaregistry.info/termList/RDAproductionMethod/",
  "cubeont": "http://ontology.cube.global/",
  "dbug": "http://ontologi.es/doap-bugs#",
  "oplacl": "http://www.openlinksw.com/ontology/acl#",
  "mem": "http://mementoweb.org/ns#",
  "oplbenefit": "http://www.openlinksw.com/ontology/benefits#",
  "cue": "http://www.clarin.eu/cmdi/cues/display/1.0#",
  "ims": "http://www.imsglobal.org/xsd/imsmd_v1p2/",
  "persee": "http://data.persee.fr/ontology/persee_ontology/",
  "ensembl": "http://rdf.ebi.ac.uk/resource/ensembl/",
  "ipsv": "http://id.esd.org.uk/list/",
  "vcard2006": "http://www.w3.org/2006/vcard/ns#",
  "spvqa": "https://bmake.th-brandenburg.de/spv#",
  "vidont": "http://vidont.org/",
  "lfov": "https://w3id.org/legal_form#",
  "nkos": "http://w3id.org/nkos#",
  "aml": "https://w3id.org/i40/aml#",
  "dcap": "http://purl.org/ws-mmi-dc/terms/",
  "onisep": "http://rdf.onisep.fr/resource/",
  "h2o": "http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic#",
  "vehma": "http://deductions.github.io/vehicule-management.owl.ttl#",
  "oup": "http://purl.org/ontology-use-patterns#",
  "literature": "http://purl.org/net/cnyt-literature#",
  "duv": "http://www.w3.org/ns/duv#",
  "newsevents": "http://www.aifb.uni-karlsruhe.de/WBS/uhe/ontologies#",
  "s4syst": "https://saref.etsi.org/saref4syst/",
  "irsteaont": "http://ontology.irstea.fr/weather/ontology#",
  "km4c": "http://www.disit.org/km4city/schema#",
  "rdaar": "http://rdaregistry.info/termList/AspectRatio/",
  "cpov": "http://data.europa.eu/m8g/",
  "pcdm": "http://pcdm.org/models#",
  "eccdi": "https://vocab.eccenca.com/di/",
  "meshv": "http://id.nlm.nih.gov/mesh/vocab#",
  "religion": "http://rdf.muninn-project.org/ontologies/religion#",
  "vacseen1": "http://www.semanticweb.org/parthasb/ontologies/2014/6/vacseen1/",
  "odf": "http://docs.oasis-open.org/ns/office/1.2/meta/odf#",
  "rdfp": "https://w3id.org/rdfp/",
  "esapar": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/aparcamiento#",
  "nih": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  "gns": "http://sws.geonames.org/",
  "ca": "http://complyadvantage.com/",
  "dsw": "http://purl.org/dsw/",
  "rgml": "http://purl.org/puninj/2001/05/rgml-schema#",
  "pmhb": "http://pmhb.org/",
  "bsh": "https://brickschema.org/schema/1.1.0/BrickShape#",
  "physo": "http://merlin.phys.uni.lodz.pl/onto/physo/physo.owl#",
  "phy": "https://w3id.org/skgo/phy#",
  "cff": "http://purl.oclc.org/NET/ssnx/cf/cf-feature#",
  "sorg": "http://schema.org/",
  "lmf": "http://www.lexinfo.net/lmf#",
  "dwciri": "http://rs.tdwg.org/dwc/iri/",
  "uby": "http://purl.org/olia/ubyCat.owl#",
  "tx": "http://swtmp.gitlab.io/vocabulary/templates.owl#",
  "esadm": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/territorio#",
  "geovoid": "http://purl.org/geovocamp/ontology/geovoid/",
  "tgm": "http://id.loc.gov/vocabulary/graphicMaterials/",
  "ido": "http://purl.obolibrary.org/obo/ido.owl#",
  "id": "http://identifiers.org/",
  "sfn": "http://semweb.datasciencelab.be/ns/sfn#",
  "rdag1": "http://rdvocab.info/Elements/",
  "fluidops": "http://www.fluidops.com/",
  "mexcore": "http://mex.aksw.org/mex-core#",
  "beer": "http://beer.com/",
  "literal": "http://www.essepuntato.it/2010/06/literalreification/",
  "vplan": "http://www.ifs.tuwien.ac.at/~miksa/ontologies/VPlan.owl#",
  "uneskos": "http://purl.org/voc/uneskos#",
  "cpi": "http://www.ebusiness-unibw.org/ontologies/cpi/ns#",
  "rofit": "http://rdaregistry.info/termList/rofit/",
  "pcit": "http://public-contracts.nexacenter.org/id/propertiesRole/",
  "esservicio": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/servicio#",
  "ilap": "http://data.posccaesar.org/ilap/",
  "swcomp": "https://github.com/ali1k/ld-reactor/blob/master/vocabulary/index.ttl#",
  "glycan": "http://purl.jp/bio/12/glyco/glycan#",
  "iiif": "http://iiif.io/api/image/2#",
  "rdafnv": "http://rdaregistry.info/termList/noteForm/",
  "escjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
  "rdacdt": "http://rdaregistry.info/termList/RDACartoDT/",
  "mmm": "http://www.mico-project.eu/ns/mmm/2.0/schema#",
  "provinsi": "http://provinsi.com/",
  "nature": "http://deductions.github.io/nature_observation.owl.ttl#",
  "odapps": "http://semweb.mmlab.be/ns/odapps#",
  "s4ee": "https://w3id.org/saref4ee#",
  "spv": "http://completeness.inf.unibz.it/sp-vocab#",
  "ioto": "http://www.irit.fr/recherches/MELODI/ontologies/IoT-O#",
  "wsdl": "http://www.w3.org/ns/wsdl-rdf#",
  "brk": "http://brk.basisregistraties.overheid.nl/def/brk#",
  "hdo": "http://www.samos.gr/ontologies/helpdeskOnto.owl#",
  "naval": "http://rdf.muninn-project.org/ontologies/naval#",
  "beo": "https://w3id.org/beo#",
  "rm": "http://jazz.net/ns/rm#",
  "dicera": "http://semweb.mmlab.be/ns/dicera#",
  "vocnet": "http://schema.vocnet.org/",
  "dbfo": "http://dbpedia.org/facts/ontology#",
  "aksw": "http://aksw.org/",
  "cog": "http://purl.org/ontology/cco/core#",
  "veo": "http://linkeddata.finki.ukim.mk/lod/ontology/veo#",
  "fp3": "http://vocab.fusepool.info/fp3#",
  "modsci": "https://w3id.org/skgo/modsci#",
  "da": "https://www.wowman.org/index.php?id=1&type=get#",
  "vam": "http://www.metmuseum.org/",
  "bkb": "https://budayakb.cs.ui.ac.id/ns#",
  "devuan": "https://devuan.net.br/",
  "itcat": "http://th-brandenburg.de/ns/itcat#",
  "alice": "http://example.org/",
  "rdare": "http://rdaregistry.info/termList/RDARegionalEncoding/",
  "gg": "http://www.gemeentegeschiedenis.nl/gg-schema#",
  "dby": "http://dbpedia.org/class/yago/",
  "tarql": "http://tarql.github.io/tarql#",
  "ogdl4m": "https://github.com/martynui/OGDL4M/",
  "sdmxm": "http://purl.org/linked-data/sdmx/2009/measure#",
  "rdacpc": "http://rdaregistry.info/termList/configPlayback/",
  "ontoneo": "http://purl.obolibrary.org/obo/ontoneo/",
  "nobel": "http://data.nobelprize.org/terms/",
  "rofsm": "http://rdaregistry.info/termList/rofsm/",
  "xslopm": "http://purl.org/net/opmv/types/xslt#",
  "tosh": "http://topbraid.org/tosh#",
  "crmeh": "http://purl.org/crmeh#",
  "dead": "http://utpl.edu.ec/sbc/data/",
  "ifcowl": "http://www.buildingsmart-tech.org/ifcOWL/IFC4_ADD2#",
  "qbe": "http://citydata.wu.ac.at/qb-equations#",
  "vocals": "http://w3id.org/rsp/vocals#",
  "apb": "http://www.analysispartners.org/businessmodel/",
  "ldq": "http://www.linkeddata.es/ontology/ldq#",
  "ncicp": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  "number": "http://km.aifb.kit.edu/projects/numbers/number#",
  "wde": "http://www.wikidata.org/entity/",
  "atlasterms": "http://rdf.ebi.ac.uk/terms/atlas/",
  "ppr": "http://purl.org/datanode/ppr/ns/",
  "input": "http://volt-name.space/vocab/input#",
  "ethc": "http://ethoinformatics.org/ethocore/",
  "ttla": "https://w3id.org/ttla/",
  "legal": "http://www.w3.org/ns/legal#",
  "roc": "https://w3id.org/ro/curate#",
  "or": "http://openresearch.org/vocab/",
  "oop": "http://w3id.org/oop#",
  "mobivoc": "http://schema.mobivoc.org/",
  "ldn": "https://www.w3.org/TR/ldn/#",
  "mydb": "http://mydb.org/",
  "l2sp": "http://www.linked2safety-project.eu/properties/",
  "lgdt": "http://linkedgeodata.org/triplify/",
  "geor": "http://www.opengis.net/def/rule/geosparql/",
  "mus": "http://data.doremus.org/ontology#",
  "rdag3": "http://rdvocab.info/ElementsGr3/",
  "ul": "http://underlay.mit.edu/ns/",
  "rofrm": "http://rdaregistry.info/termList/rofrm/",
  "rofim": "http://rdaregistry.info/termList/rofim/",
  "swa": "http://topbraid.org/swa#",
  "halyard": "http://merck.github.io/Halyard/ns#",
  "edg": "http://edg.topbraid.solutions/model/",
  "rdaspc": "http://rdaregistry.info/termList/specPlayback/",
  "imjv": "https://data.imjv.omgeving.vlaanderen.be/ns/imjv#",
  "semsur": "http://purl.org/SemSur/",
  "huto": "http://ns.inria.fr/huto/",
  "sciprov": "http://sweetontology.net/reprSciProvenance/",
  "yso": "http://www.yso.fi/onto/yso/",
  "ucum": "http://purl.oclc.org/NET/muo/ucum/",
  "sgiter": "http://w3id.org/sparql-generate/iter/",
  "nosql": "http://purl.org/db/nosql#",
  "lgt": "http://linkedgadget.com/wiki/Property:",
  "gobierno": "http://www.gobierno.es/gobierno/",
  "decprov": "http://promsns.org/def/decprov#",
  "gvoith": "http://assemblee-virtuelle.github.io/grands-voisins-v2/thesaurus.ttl#",
  "mbgd": "http://mbgd.genome.ad.jp/owl/mbgd.owl#",
  "srx": "http://www.w3.org/2005/sparql-results#",
  "rdaft": "http://rdaregistry.info/termList/fileType/",
  "iotlite": "http://purl.oclc.org/NET/UNIS/fiware/iot-lite#",
  "tadirah": "http://tadirah.dariah.eu/vocab/",
  "ocds": "http://purl.org/onto-ocds/ocds#",
  "dnbt": "http://d-nb.info/standards/elementset/dnb#",
  "dcodt": "http://info.deepcarbon.net/datatype/schema#",
  "dataid": "http://dataid.dbpedia.org/ns/core#",
  "isbdu": "http://iflastandards.info/ns/isbd/unc/elements/",
  "neotecbib": "http://neotec.rc.unesp.br/resource/NeotectonicsBibliography/",
  "aozora": "http://purl.org/net/aozora/",
  "ontop": "https://w3id.org/ontop/",
  "scholl": "http://menemeneml.com/school#",
  "sdterms": "http://statisticaldata.linkedwidgets.org/terms/",
  "alethio": "http://aleth.io/",
  "um": "http://intelleo.eu/ontologies/user-model/ns/",
  "occ": "http://w3id.org/occ#",
  "idot": "http://identifiers.org/idot/",
  "loted": "http://loted.eu/ontology#",
  "pmonb": "http://premon.fbk.eu/ontology/nb#",
  "rdapf": "http://rdaregistry.info/termList/presFormat/",
  "cska": "http://pfclitex.com/",
  "ldqm": "http://linkeddata.es/resource/ldqm/",
  "rvl": "http://purl.org/rvl/",
  "geo7": "https://www.geo7.ch/",
  "it": "http://www.influencetracker.com/ontology#",
  "imind": "http://schema.intellimind.ns/symbology#",
  "docker": "http://www.w3.org/ns/bde/docker/",
  "tissue": "http://www.univalle.edu.co/ontologies/Tissue#",
  "rdax": "http://rdaregistry.info/Elements/x/",
  "sdmxc": "http://purl.org/linked-data/sdmx/2009/concept#",
  "edgarcik": "http://edgarwrap.ontologycentral.com/cik/",
  "esair": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/calidad-aire#",
  "uri4uri": "http://uri4uri.net/vocab#",
  "neotec": "http://neotec.rc.unesp.br/resource/Neotectonics/",
  "pbody": "http://reference.data.gov.uk/def/public-body/",
  "nas": "https://data.nasa.gov/ontologies/atmonto/NAS#",
  "crminf": "http://www.cidoc-crm.org/cidoc-crm/CRMinf/",
  "rofhf": "http://rdaregistry.info/termList/rofhf/",
  "elod": "http://linkedeconomy.org/ontology#",
  "ods": "http://lod.xdams.org/ontologies/ods/",
  "koly": "http://www.ensias.ma/",
  "undata": "http://citydata.wu.ac.at/Linked-UNData/data/",
  "piero": "http://reactionontology.org/piero/",
  "ondc": "http://www.semanticweb.org/ontologies/2012/1/Ontology1329913965202.owl#",
  "alg": "http://drakon.su/ADF#",
  "geofabric": "http://linked.data.gov.au/def/geofabric#",
  "b3kat": "http://lod.b3kat.de/title/",
  "smxm": "http://smxm.ga/",
  "iso37120": "http://ontology.eil.utoronto.ca/ISO37120.owl#",
  "sorepsf": "http://sweetontology.net/reprSciFunction/",
  "juso": "http://rdfs.co/juso/",
  "sohukd": "http://sweetontology.net/humanKnowledgeDomain/",
  "edac": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl#",
  "xbrll": "https://w3id.org/vocab/xbrll#",
  "lsq": "http://lsq.aksw.org/vocab#",
  "datacron": "http://www.datacron-project.eu/datAcron#",
  "geoloc": "http://deductions.github.io/geoloc.owl.ttl#",
  "seo": "http://sda.tech/SEOontology/SEO/",
  "ns2": "http://ogp.me/ns#video:",
  "eproc": "http://10.0.3.120/download/eproc_FORN_v02.owl#",
  "dto": "http://www.datatourisme.fr/ontology/core/1.0#",
  "rfd": "http://com.intrinsec//ontology#",
  "amsl": "http://vocab.ub.uni-leipzig.de/amsl/",
  "pand": "http://bag.basisregistraties.overheid.nl/bag/id/pand/",
  "maeco": "http://edg.topbraid.solutions/maeco/",
  "wab": "http://wab.uib.no/cost-a32_philospace/wittgenstein.owl#",
  "globalcube": "http://kalmar32.fzi.de/triples/global-cube.ttl#",
  "remetca": "http://www.purl.org/net/remetca#",
  "dcodata": "http://info.deepcarbon.net/data/schema#",
  "connard": "https://mail.google.com/mail/u/1/#",
  "ii": "http://sparql.cwrc.ca/ontologies/ii#",
  "kmgeo": "http://km.aifb.kit.edu/services/geo/ontology#",
  "tsnchange": "http://purl.org/net/tsnchange#",
  "wail": "http://www.eyrie.org/~zednenem/2002/wail/",
  "olac11": "http://www.language-archives.org/OLAC/1.1/",
  "rico": "https://www.ica.org/standards/RiC/ontology#",
  "pmofn": "http://premon.fbk.eu/ontology/fn#",
  "loci": "http://linked.data.gov.au/def/loci#",
  "rdfdata": "http://rdf.data-vocabulary.org/rdf.xml#",
  "pop": "http://wiki.dbpedia.org/",
  "efd": "http://data.foodanddrinkeurope.eu/ontology#",
  "metadata": "http://purl.oreilly.com/ns/meta/",
  "iab": "https://www.iab.com/guidelines/taxonomy/",
  "imas": "https://sparql.crssnky.xyz/imasrdf/URIs/imas-schema.ttl#",
  "d3s": "http://vocbench.solidaridad.cloud/taxonomies#",
  "brt": "http://brt.basisregistraties.overheid.nl/def/top10nl#",
  "dm2e": "http://onto.dm2e.eu/schemas/dm2e/",
  "m3lite": "http://purl.org/iot/vocab/m3-lite#",
  "ncbigene": "http://identifiers.org/ncbigene/",
  "llr": "http://lodlaundromat.org/resource/",
  "soma": "http://sweetontology.net/matr/",
  "sophatmow": "http://sweetontology.net/phenAtmoWind/",
  "s4bldg": "https://w3id.org/def/saref4bldg#",
  "sopropsdis": "http://sweetontology.net/propSpaceDistance/",
  "pmovn": "http://premon.fbk.eu/ontology/vn#",
  "m3": "http://sensormeasurement.appspot.com/m3#",
  "gdprtext": "https://w3id.org/GDPRtEXT#",
  "unspsc": "http://ontoview.org/schema/unspsc/1#",
  "soprocsc": "http://sweetontology.net/procStateChange/",
  "scra": "http://purl.org/net/schemarama#",
  "sorepmo": "http://sweetontology.net/reprMathOperation/",
  "soproptg": "http://sweetontology.net/propTemperatureGradient/",
  "gdprov": "https://w3id.org/GDPRov#",
  "esproc": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/procedimientos#",
  "manto": "http://com.vortic3.MANTO/",
  "tikag": "https://www.tikag.com/",
  "marcrole": "http://id.loc.gov/vocabulary/relators/",
  "valueflows": "https://w3id.org/valueflows/",
  "estatwrap": "http://ontologycentral.com/2009/01/eurostat/ns#",
  "eustd": "http://eurostat.linked-statistics.org/data#",
  "vsearch": "http://vocab.sti2.at/vsearch#",
  "rdaill": "http://rdaregistry.info/termList/IllusContent/",
  "bci": "https://w3id.org/BCI-ontology#",
  "s3n": "http://w3id.org/s3n/",
  "fnml": "http://semweb.mmlab.be/ns/fnml#",
  "rofsf": "http://rdaregistry.info/termList/rofsf/",
  "rami": "http://iais.fraunhofer.de/vocabs/rami#",
  "biolink": "https://w3id.org/biolink/vocab/",
  "clapit": "http://dati.gov.it/onto/clapit/",
  "bibrm": "http://vocab.ub.uni-leipzig.de/bibrm/",
  "isidore": "http://www.rechercheisidore.fr/class/",
  "pm": "http://premon.fbk.eu/resource/",
  "sophatmowm": "https://sweetontology.net/phenAtmoWindMesoscale/",
  "bioentity": "http://bioentity.io/vocab/",
  "ispra": "http://dati.isprambiente.it/ontology/core#",
  "sorepsrs": "http://sweetontology.net/reprSpaceReferenceSystem/",
  "soproptf": "http://sweetontology.net/propTimeFrequency/",
  "master1": "http://idl.u-grenoble3.fr/",
  "rdavf": "http://rdaregistry.info/termList/videoFormat/",
  "rimmf": "http://rimmf.com/vocab/",
  "hosp": "http://health.data.gov/def/hospital/",
  "llalg": "http://www.linklion.org/algorithm/",
  "wn30": "http://purl.org/vocabularies/princeton/wn30/",
  "irstea": "http://ontology.irstea.fr/",
  "dgfr": "http://colin.maudry.com/ontologies/dgfr#",
  "gdpr": "https://vocab.eccenca.com/gdpr/",
  "sopropp": "http://sweetontology.net/propPressure/",
  "tavprov": "http://ns.taverna.org.uk/2012/tavernaprov/",
  "vss": "http://automotive.eurecom.fr/vsso#",
  "sopropsl": "http://sweetontology.net/propSpaceLocation/",
  "smartapi": "http://smart-api.io/ontology/1.0/smartapi#",
  "pq": "http://www.wikidata.org/prop/qualifier/",
  "refexo": "http://purl.jp/bio/01/refexo#",
  "rsctx": "http://softeng.polito.it/rsctx#",
  "cbb": "https://data.cbb.omgeving.vlaanderen.be/ns/cbb#",
  "asawoo": "http://liris.cnrs.fr/asawoo/",
  "osys": "http://purl.org/olia/system.owl#",
  "psv": "http://www.wikidata.org/prop/statement/value/",
  "chemsci": "https://w3id.org/skgo/chemsci#",
  "qk": "http://qudt.org/vocab/quantitykind/",
  "changeset": "http://purl.org/vocab/changeset/schema#",
  "emergel": "http://purl.org/emergel/core#",
  "linkrel": "https://www.w3.org/ns/iana/link-relations/relation#",
  "ksam": "http://kulturarvsdata.se/ksamsok#",
  "ctxdesc": "http://www.demcare.eu/ontologies/contextdescriptor.owl#",
  "eqp": "https://data.nasa.gov/ontologies/atmonto/equipment#",
  "pham": "https://w3id.org/skgo/pham#",
  "dsfv": "http://sws.ifi.uio.no/vocab/dsf/henriwi/dsf#",
  "rdagen": "http://rdaregistry.info/termList/RDAGeneration/",
  "stencila": "http://schema.stenci.la/",
  "dpla": "http://dp.la/info/developers/map/",
  "fel": "http://w3id.org/vcb/fel#",
  "sostc": "http://sweetontology.net/stateChemical/",
  "goaf": "http://goaf.fr/goaf#",
  "oplp": "http://www.openlinksw.com/ontology/purchases#",
  "ermrk": "http://www.essepuntato.it/2008/12/earmark#",
  "sohuecons": "http://sweetontology.net/humanEnvirConservation/",
  "oplangel": "http://www.openlinksw.com/schemas/angel#",
  "sopropcat": "http://sweetontology.net/propCategorical/",
  "maet": "http://edg.topbraid.solutions/taxonomy/macroeconomics/",
  "noise": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/contaminacion-acustica#",
  "omnlc": "http://open-multinet.info/ontology/omn-lifecycle#",
  "pplan": "http://purl.org/net/p-plan#",
  "rdaad": "http://rdaregistry.info/Elements/a/datatype/",
  "prohow": "https://w3id.org/prohow#",
  "sopropsh": "http://sweetontology.net/propSpaceHeight/",
  "bitl": "http://lib.bit.edu.cn/ontology/1.0/",
  "sorepmso": "http://sweetontology.net/reprMathSolution/",
  "wild": "http://purl.org/wild/vocab#",
  "gnaf": "http://linked.data.gov.au/def/gnaf#",
  "soproc": "http://sweetontology.net/proc/",
  "isoadr": "http://reference.data.gov.au/def/ont/iso19160-1-address#",
  "ordo": "http://www.orpha.net/ORDO/",
  "dmp": "http://www.sysresearch.org/rda-common-dmp#",
  "aseonto": "http://requirement.ase.ru/requirements_ontology#",
  "somaoc": "http://sweetontology.net/matrOrganicCompound/",
  "terms": "http://purl.org/dc/terms/",
  "gcon": "https://w3id.org/GConsent#",
  "soprocp": "http://sweetontology.net/procPhysical/",
  "dm": "http://datamusee.givingsense.eu/onto/",
  "capes": "http://vocab.capes.gov.br/def/vcav#",
  "sorepmfo": "http://sweetontology.net/reprMathFunctionOrthogonal/",
  "snac": "http://socialarchive.iath.virginia.edu/",
  "sorepsu": "http://sweetontology.net/reprSciUnits/",
  "country": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
  "provoc": "http://ns.inria.fr/provoc/",
  "sostv": "http://sweetontology.net/stateVisibility/",
  "skosthes": "http://purl.org/iso25964/skos-thes#",
  "mdont": "http://ont.matchdeck.com/",
  "cwlgit": "https://w3id.org/cwl/view/git/",
  "extech": "https://w3id.org/executionTechnique/ontology/",
  "sopropsp": "http://sweetontology.net/propSpeed/",
  "sophatmofo": "http://sweetontology.net/phenAtmoFog/",
  "lesa": "http://hadatac.org/ont/lesa#",
  "jsonschema": "https://www.w3.org/2019/wot/json-schema#",
  "sosttf": "http://sweetontology.net/stateTimeFrequency/",
  "losp": "http://sparql.sstu.ru:3030/speciality/",
  "sorepsc": "http://sweetontology.net/reprSciComponent/",
  "sorepscd": "http://sweetontology.net/reprSpaceCoordinate/",
  "eproc2": "http://10.0.3.120/download/eproc_FORN_v04.owl#",
  "soreaofl": "http://sweetontology.net/realmOceanFloor/",
  "pmopb": "http://premon.fbk.eu/ontology/pb#",
  "sohut": "http://sweetontology.net/humanTransportation/",
  "sorepdsa": "http://sweetontology.net/reprDataServiceAnalysis/",
  "powla": "http://purl.org/powla/powla.owl#",
  "rofet": "http://rdaregistry.info/termList/rofet/",
  "daap": "http://daap.dsi.universite-paris-saclay.fr/wiki/",
  "sophec": "http://sweetontology.net/phenEcology/",
  "sopropef": "http://sweetontology.net/propEnergyFlux/",
  "sorepdf": "http://sweetontology.net/reprDataFormat/",
  "sopropsdir": "http://sweetontology.net/propSpaceDirection/",
  "sorepmst": "http://sweetontology.net/reprMathStatistics/",
  "wdv": "http://www.wikidata.org/value/",
  "sophatmopc": "http://sweetontology.net/phenAtmoPrecipitation/",
  "sophoc": "http://sweetontology.net/phenOceanCoastal/",
  "esagen": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
  "theme": "http://voc.odw.tw/theme/",
  "lcsh": "http://id.loc.gov/authorities/subjects/",
  "sorelm": "http://sweetontology.net/relaMath/",
  "cwmo": "http://purl.org/cwmo/#",
  "r4r": "http://guava.iis.sinica.edu.tw/r4r/",
  "constant": "http://qudt.org/vocab/constant/",
  "dqc": "http://semwebquality.org/ontologies/dq-constraints#",
  "dcatnl": "http://standaarden.overheid.nl/dcatnl/terms/",
  "dentsci": "https://w3id.org/skgo/dentsci#",
  "earth": "http://linked.earth/ontology#",
  "soprops": "http://sweetontology.net/propSpace/",
  "sorepsme": "http://sweetontology.net/reprSciMethodology/",
  "atts": "https://data.nasa.gov/ontologies/atmonto/general#",
  "hctl": "https://www.w3.org/2019/wot/hypermedia#",
  "sopropti": "http://sweetontology.net/propTime/",
  "esgs": "https://w3id.org/edwin/ontology/",
  "epplan": "https://w3id.org/ep-plan#",
  "sorept": "http://sweetontology.net/reprTime/",
  "soreaa": "http://sweetontology.net/realmAtmo/",
  "sorepdsv": "http://sweetontology.net/reprDataServiceValidation/",
  "obws": "http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl#",
  "wikimedia": "http://upload.wikimedia.org/wikipedia/commons/f/f6/",
  "gmo": "http://purl.jp/bio/10/gmo/",
  "sweet": "http://sweetontology.net/",
  "shema": "http://schema.org/",
  "sophso": "http://sweetontology.net/phenSolid/",
  "nrv": "http://ns.inria.fr/nrv#",
  "sophsy": "http://sweetontology.net/phenSystem/",
  "bs": "https://w3id.org/bs#",
  "sorepdp": "http://sweetontology.net/reprDataProduct/",
  "sorepdsr": "http://sweetontology.net/reprDataServiceReduction/",
  "medred": "http://w3id.org/medred/medred#",
  "sostb": "http://sweetontology.net/stateBiological/",
  "orgesv2": "http://datos.gob.es/sites/default/files/OntologiaDIR3/orges.owl#",
  "isaterms": "http://purl.org/isaterms/",
  "eppl": "https://w3id.org/ep-plan#",
  "sopropcha": "http://sweetontology.net/propCharge/",
  "sorepmf": "http://sweetontology.net/reprMathFunction/",
  "sopropsm": "http://sweetontology.net/propSpaceMultidimensional/",
  "sopropmf": "http://sweetontology.net/propMassFlux/",
  "sorepsl": "http://sweetontology.net/reprSciLaw/",
  "sopropcap": "http://sweetontology.net/propCapacity/",
  "sorelpr": "http://sweetontology.net/relaProvenance/",
  "voidwh": "http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl#",
  "fssp": "http://linkeddata.fssprus.ru/resource/",
  "stx": "http://purl.org/cyber/stix#",
  "iospress": "http://ld.iospress.nl/rdf/ontology/",
  "sopropdifu": "http://sweetontology.net/propDiffusivity/",
  "lblodlg": "http://data.lblod.info/vocabularies/leidinggevenden/",
  "sostrr": "http://sweetontology.net/stateRoleRepresentative/",
  "sopropq": "http://sweetontology.net/propQuantity/",
  "gvoi": "http://assemblee-virtuelle.github.io/grands-voisins-v2/gv.owl.ttl#",
  "sorepsp": "http://sweetontology.net/reprSciProvenance/",
  "jup": "http://w3id.org/charta77/jup/",
  "mexperf": "http://mex.aksw.org/mex-perf#",
  "dprov": "http://promsns.org/def/do#",
  "sostri": "http://sweetontology.net/stateRoleImpact/",
  "sopropcou": "http://sweetontology.net/propCount/",
  "inchikey": "https://identifiers.org/inchikey:",
  "pineapple": "http://hexananas.com/pineapple#",
  "somanr": "http://sweetontology.net/matrNaturalResource/",
  "sorealc": "http://sweetontology.net/realmLandCoastal/",
  "vehman": "http://deductions.github.io/vehicule-management.owl.ttl#",
  "skoslex": "https://bp4mc2.org/def/skos-lex#",
  "estatgph": "http://estatwrap.ontologycentral.com/id/nama_aux_gph#",
  "sophatmoc": "http://sweetontology.net/phenAtmoCloud/",
  "sopropb": "http://sweetontology.net/propBinary/",
  "soreahb": "http://sweetontology.net/realmHydroBody/",
  "sopropdr": "http://sweetontology.net/propDimensionlessRatio/",
  "sorepts": "http://sweetontology.net/reprTimeSeason/",
  "sophfd": "http://sweetontology.net/phenFluidDynamics/",
  "estrf": "http://vocab.linkeddata.es/datosabiertos/def/transporte/trafico#",
  "ingredient": "http://www.owl-ontologies.com/test.owl/ingredient/",
  "iaph": "http://www.juntadeandalucia.es/datosabiertos/portal/iaph/dataset/dataset/6c199ca2-8d2e-4c12-833c-f28",
  "soprope": "http://sweetontology.net/propEnergy/",
  "ldc": "https://tac.nist.gov/tracks/SM-KBP/2018/ontologies/SeedlingOntology#",
  "sostth": "http://sweetontology.net/stateThermodynamic/",
  "somamin": "http://sweetontology.net/matrMineral/",
  "odw": "http://odw.tw/",
  "sorelcl": "http://sweetontology.net/relaClimate/",
  "esdbpr": "http://es.dbpedia.org/resource/",
  "wotsec": "https://www.w3.org/2019/wot/security#",
  "sopropm": "http://sweetontology.net/propMass/",
  "sorepmg": "http://sweetontology.net/reprMathGraph/",
  "sorelh": "http://sweetontology.net/relaHuman/",
  "sopropcon": "http://sweetontology.net/propConductivity/",
  "sorep": "http://sweetontology.net/repr/",
  "soreps": "http://sweetontology.net/reprSpace/",
  "soreao": "http://sweetontology.net/realmOcean/",
  "soreacz": "http://sweetontology.net/realmClimateZone/",
  "sosto": "http://sweetontology.net/stateOrdinal/",
  "sosttg": "http://sweetontology.net/stateTimeGeologic/",
  "ideotalex": "http://www.ideotalex.eu/datos/recurso/",
  "sopropo": "http://sweetontology.net/propOrdinal/",
  "sfl": "http://data.finlex.fi/schema/sfl/",
  "vort": "http://rockets.topbraid.solutions/vort/",
  "yandex": "http://yandex.ru/",
  "sophatmofr": "http://sweetontology.net/phenAtmoFront/",
  "w3id": "https://w3id.org/",
  "foio": "https://w3id.org/seas/FeatureOfInterestOntology/",
  "sorealo": "http://sweetontology.net/realmLandOrographic/",
  "dave": "http://theme-e.adaptcentre.ie/dave#",
  "sopropche": "http://sweetontology.net/propChemical/",
  "sopropr": "http://sweetontology.net/propRotation/",
  "ddb": "http://www.deutsche-digitale-bibliothek.de/edm/",
  "soreaas": "http://sweetontology.net/realmAstroStar/",
  "sorepsd": "http://sweetontology.net/reprSpaceDirection/",
  "loupe": "http://ont-loupe.linkeddata.es/def/core/",
  "sohutr": "http://sweetontology.net/humanTechReadiness/",
  "sopropi": "http://sweetontology.net/propIndex/",
  "somains": "http://sweetontology.net/matrInstrument/",
  "sophcr": "http://sweetontology.net/phenCryo/",
  "sophpc": "http://sweetontology.net/phenPlanetClimate/",
  "sopropfr": "http://sweetontology.net/propFraction/",
  "cci": "http://cookingbigdata.com/linkeddata/ccinstances#",
  "sophatmops": "http://sweetontology.net/phenAtmoPressure/",
  "sophatmos": "http://sweetontology.net/phenAtmoSky/",
  "lprov": "http://id.learning-provider.data.ac.uk/terms#",
  "sophatmol": "http://sweetontology.net/phenAtmoLightning/",
  "d2s": "https://w3id.org/d2s/",
  "sohuj": "http://sweetontology.net/humanJurisdiction/",
  "somac": "http://sweetontology.net/matrCompound/",
  "sorepm": "http://sweetontology.net/reprMath/",
  "somaae": "http://sweetontology.net/matrAerosol/",
  "frbroo": "http://iflastandards.info/ns/fr/frbr/frbroo/",
  "sophst": "http://sweetontology.net/phenStar/",
  "sostrg": "http://sweetontology.net/stateRoleGeographic/",
  "proton": "http://www.ontotext.com/proton/",
  "sopropdife": "http://sweetontology.net/propDifference/",
  "sorear": "http://sweetontology.net/realmRegion/",
  "osmm": "https://www.openstreetmap.org/meta/",
  "ecowlim": "http://ecowlim.tfri.gov.tw/lode/resource/",
  "cfrl": "http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#",
  "sopropfu": "http://sweetontology.net/propFunction/",
  "sorelsc": "http://sweetontology.net/relaSci/",
  "trek": "https://w3id.org/trek/",
  "sophwn": "http://sweetontology.net/phenWaveNoise/",
  "esagm": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
  "sorelph": "http://sweetontology.net/relaPhysical/",
  "soreas": "http://sweetontology.net/realmSoil/",
  "sohues": "http://sweetontology.net/humanEnvirStandards/",
  "sohur": "http://sweetontology.net/humanResearch/",
  "somapl": "http://sweetontology.net/matrPlant/",
  "sophatmo": "http://sweetontology.net/phenAtmo/",
  "sostso": "http://sweetontology.net/stateSolid/",
  "soprocw": "http://sweetontology.net/procWave/",
  "somaf": "http://sweetontology.net/matrFacility/",
  "somab": "http://sweetontology.net/matrBiomass/",
  "sophm": "http://sweetontology.net/phenMixing/",
  "taxref": "http://taxref.mnhn.fr/lod/taxon/",
  "sostrt": "http://sweetontology.net/stateRoleTrust/",
  "sost": "http://sweetontology.net/state/",
  "sorealp": "http://sweetontology.net/realmLandProtected/",
  "sorepdm": "http://sweetontology.net/reprDataModel/",
  "sorepdsg": "http://sweetontology.net/reprDataServiceGeospatial/",
  "eccf": "http://data.europa.eu/54i/",
  "sorepsg3": "http://sweetontology.net/reprSpaceGeometry3D/",
  "hdgi": "https://w3id.org/hdgi#",
  "sophcm": "http://sweetontology.net/phenCycleMaterial/",
  "biogrid": "http://thebiogrid.org/",
  "bldont": "http://ont.biglinkeddata.com/",
  "soreaer": "http://sweetontology.net/realmEarthReference/",
  "sosttc": "http://sweetontology.net/stateTimeCycle/",
  "sophel": "http://sweetontology.net/phenElecMag/",
  "pcdmuse": "http://pcdm.org/use#",
  "sostrc": "http://sweetontology.net/stateRoleChemical/",
  "somarock": "http://sweetontology.net/matrRock/",
  "sohu": "http://sweetontology.net/human/",
  "soreaabl": "http://sweetontology.net/realmAtmoBoundaryLayer/",
  "soreaaw": "http://sweetontology.net/realmAtmoWeather/",
  "asgs": "http://linked.data.gov.au/def/asgs#",
  "sorelt": "http://sweetontology.net/relaTime/",
  "donto": "http://reference.data.gov.au/def/ont/dataset#",
  "gx": "https://w3id.org/gaia-x/development#",
  "mbkeys": "https://pastebin.com/ThBfphb8#",
  "ggbn": "http://data.ggbn.org/schemas/ggbn/terms/",
  "sorel": "http://sweetontology.net/rela/",
  "somaind": "http://sweetontology.net/matrIndustrial/",
  "somaen": "http://sweetontology.net/matrEnergy/",
  "sophr": "http://sweetontology.net/phenReaction/",
  "somaem": "http://sweetontology.net/matrElementalMolecule/",
  "pnv": "https://w3id.org/pnv#",
  "sopropst": "http://sweetontology.net/propSpaceThickness/",
  "probont": "http://www.probonto.org/ontology#",
  "somarocki": "http://sweetontology.net/matrRockIgneous/",
  "soreac": "http://sweetontology.net/realmCryo/",
  "sostdp": "http://sweetontology.net/stateDataProcessing/",
  "phto": "http://rhizomik.net/ontologies/PlantHealthThreats.owl.ttl#",
  "soreaah": "http://sweetontology.net/realmAstroHelio/",
  "sostsy": "http://sweetontology.net/stateSystem/",
  "sophatmot": "http://sweetontology.net/phenAtmoTransport/",
  "soph": "http://sweetontology.net/phen/",
  "misp": "http://purl.org/cyber/misp#",
  "sostsp": "http://sweetontology.net/stateSpace/",
  "soreal": "http://sweetontology.net/realmLandform/",
  "sophft": "http://sweetontology.net/phenFluidTransport/",
  "somais": "http://sweetontology.net/matrIsotope/",
  "sophcy": "http://sweetontology.net/phenCycle/",
  "soall": "http://sweetontology.net/sweetAll/",
  "soreptd": "http://sweetontology.net/reprTimeDay/",
  "dbm": "http://purl.org/net/dbm/ontology#",
  "osmt": "https://wiki.openstreetmap.org/wiki/Key:",
  "mmms": "http://ldf.fi/schema/mmm/",
  "she": "http://shacleditor.org/",
  "sorelch": "http://sweetontology.net/relaChemical/",
  "soprocc": "http://sweetontology.net/procChemical/",
  "sorepds": "http://sweetontology.net/reprDataService/",
  "omop": "http://api.ohdsi.org/WebAPI/vocabulary/concept/",
  "sorepsmo": "http://sweetontology.net/reprSciModel/",
  "sophsyc": "http://sweetontology.net/phenSystemComplexity/",
  "sohuc": "http://sweetontology.net/humanCommerce/",
  "sopropt": "http://sweetontology.net/propTemperature/",
  "lv2": "http://lv2plug.in/ns/lv2core/",
  "soreaofe": "http://sweetontology.net/realmOceanFeature/",
  "sorelsp": "http://sweetontology.net/relaSpace/",
  "cto": "https://w3id.org/cto#",
  "mccv": "http://purl.jp/bio/10/mccv#",
  "sostrb": "http://sweetontology.net/stateRoleBiological/",
  "somas": "http://sweetontology.net/matrSediment/",
  "somaw": "http://sweetontology.net/matrWater/",
  "sophb": "http://sweetontology.net/phenBiol/",
  "snomedct": "http://purl.bioontology.org/ontology/SNOMEDCT/",
  "idsc": "https://w3id.org/idsa/code/",
  "sophei": "http://sweetontology.net/phenEnvirImpact/",
  "say": "https://say.data.gift/ns/",
  "sophod": "http://sweetontology.net/phenOceanDynamics/",
  "somaeq": "http://sweetontology.net/matrEquipment/",
  "trak": "https://purl.org/trak/metamodel/vocab#",
  "twitter": "http://stocktwits.com/",
  "soreabb": "http://sweetontology.net/realmBiolBiome/",
  "sostsb": "http://sweetontology.net/stateSpectralBand/",
  "sohueccont": "http://sweetontology.net/humanEnvirControl/",
  "sophhy": "http://sweetontology.net/phenHydro/",
  "compub": "https://sireneld.io/vocab/compub#",
  "sohuea": "http://sweetontology.net/humanEnvirAssessment/",
  "place": "http://purl.org/ontology/places/",
  "sostro": "http://sweetontology.net/stateRole/",
  "soprop": "http://sweetontology.net/prop/",
  "s4city": "https://saref.etsi.org/saref4city/",
  "sorealt": "http://sweetontology.net/realmLandTectonic/",
  "ccomid": "http://www.ontologyrepository.com/CommonCoreOntologies/Mid/",
  "somaio": "http://sweetontology.net/matrIon/",
  "rank": "http://www.ontotext.com/owlim/RDFRank#",
  "wds": "http://www.wikidata.org/entity/statement/",
  "oco": "https://w3id.org/oc/ontology/",
  "omim": "http://purl.bioontology.org/ontology/OMIM/",
  "sophen": "http://sweetontology.net/phenEnergy/",
  "sostef": "http://sweetontology.net/stateEnergyFlux/",
  "esbici": "http://vocab.ciudadesabiertas.es/def/transporte/bicicleta-publica#",
  "edupro": "http://ns.inria.fr/semed/eduprogression#",
  "sophgt": "http://sweetontology.net/phenGeolTectonic/",
  "ocsw": "http://data.diekb.org/def/ocsw#",
  "schoi": "https://w3id.org/scholarlydata/ontology/indicators-ontology.owl#",
  "sophw": "http://sweetontology.net/phenWave/",
  "dfc": "http://datafoodconsortium.org/ontologies/DFC_FullModel.owl#",
  "oplsoft": "http://www.openlinksw.com/ontology/software#",
  "cbs": "http://betalinkeddata.cbs.nl/def/cbs#",
  "atd": "https://data.nasa.gov/ontologies/atmonto/data#",
  "sorealf": "http://sweetontology.net/realmLandFluvial/",
  "sostp": "http://sweetontology.net/statePhysical/",
  "brot": "https://w3id.org/brot#",
  "ldes": "https://w3id.org/ldes#",
  "sophgs": "http://sweetontology.net/phenGeolSeismicity/",
  "osmrel": "https://www.openstreetmap.org/relation/",
  "sostf": "http://sweetontology.net/stateFluid/",
  "taxrefprop": "http://taxref.mnhn.fr/lod/property/",
  "sorealg": "http://sweetontology.net/realmLandGlacial/",
  "ciao": "http://ciao.it/",
  "sostre": "http://sweetontology.net/stateRealm/",
  "gleio": "http://lei.info/gleio/",
  "somael": "http://sweetontology.net/matrElement/",
  "sophgg": "http://sweetontology.net/phenGeolGeomorphology/",
  "gas": "http://www.bigdata.com/rdf/gas#",
  "sostti": "http://sweetontology.net/stateTime/",
  "soman": "http://sweetontology.net/matrAnimal/",
  "eupont": "http://elite.polito.it/ontologies/eupont.owl#",
  "dd": "http://example.org/dummydata/",
  "birthdate": "http://schema.org/birthDate/",
  "atm": "https://data.nasa.gov/ontologies/atmonto/ATM#",
  "sostss": "http://sweetontology.net/stateSpaceScale/",
  "asio": "http://purl.org/hercules/asio/core#",
  "sophfi": "http://sweetontology.net/phenFluidInstability/",
  "soreala": "http://sweetontology.net/realmLandAeolian/",
  "sostsc": "http://sweetontology.net/stateSpaceConfiguration/",
  "s4agri": "https://saref.etsi.org/saref4agri/",
  "sophhe": "http://sweetontology.net/phenHelio/",
  "persoon": "http://data.vlaanderen.be/ns/persoon#",
  "istex": "https://data.istex.fr/ontology/istex#",
  "matvoc": "http://stream-ontology.com/matvoc/",
  "somamic": "http://sweetontology.net/matrMicrobiota/",
  "wasa": "http://vocab.sti2.at/wasa/",
  "soreaab": "http://sweetontology.net/realmAstroBody/",
  "io": "https://iaco.me/",
  "sohud": "http://sweetontology.net/humanDecision/",
  "ci": "https://privatealpha.com/ontology/content-inventory/1#",
  "somapa": "http://sweetontology.net/matrParticle/",
  "malaka": "http://george.gr/",
  "sopho": "http://sweetontology.net/phenOcean/",
  "fibo": "https://spec.edmcouncil.org/fibo/ontology/master/latest/",
  "mobiliteit": "https://data.vlaanderen.be/ns/mobiliteit#",
  "osmnode": "https://www.openstreetmap.org/node/",
  "docam": "https://www.docam.ca/glossaurus/",
  "ogura": "https://sparql.crssnky.xyz/Ogura_Hyakunin_Isshu_LinkedRDF/URIs/Ogura_Hyakunin_Isshu_schema.ttl#",
  "iaco": "https://iaco.me/",
  "sostsl": "http://sweetontology.net/stateSpectralLine/",
  "waa": "http://purl.oclc.org/NET/WebApiAuthentication#",
  "ccsla": "http://cookingbigdata.com/linkeddata/ccsla#",
  "ccr": "http://cookingbigdata.com/linkeddata/ccregions#",
  "sophg": "http://sweetontology.net/phenGeol/",
  "sophgv": "http://sweetontology.net/phenGeolVolcano/",
  "sostst": "http://sweetontology.net/stateStorm/",
  "toaru": "https://metadata.moe/toaru-sparql/elements/",
  "s4ener": "https://saref.etsi.org/saref4ener/",
  "rl": "http://rl.com/resources/",
  "eppo": "https://gd.eppo.int/taxon/",
  "sohua": "http://sweetontology.net/humanAgriculture/",
  "dbonto": "http://dbepedia.org/ontology/",
  "knows": "http://semantic.komc/usu/2020/knows#",
  "sorealv": "http://sweetontology.net/realmLandVolcanic/",
  "oplfeat": "http://www.openlinksw.com/ontology/features#",
  "osmway": "https://www.openstreetmap.org/way/",
  "dfcb": "http://datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl#",
  "sophgf": "http://sweetontology.net/phenGeolFault/",
  "fx": "http://sparql.xyz/facade-x/ns/",
  "kko": "http://kbpedia.org/kko/rc/",
  "uimo": "http://vocab.sti2.at/uimo/",
  "arp": "http://www.arpenteur.org/ontology/Arpenteur.owl#",
  "bperson": "http://data.vlaanderen.be/ns/persoon#",
  "cts": "http://rdf.cdisc.org/ct/schema#",
  "fernanda": "http://fernanda.nl/",
  "lexicog": "http://www.w3.org/ns/lemon/lexicog#",
  "jur": "http://sweet.jpl.nasa.gov/2.3/humanJurisdiction.owl#",
  "rdasource": "http://rdaregistry.info/termList/RDARecordingSources/",
  "mr": "http://marineregions.org/ns/ontology#",
  "movieo": "http://movie.com/ontology/",
  "karstlink": "https://ontology.uis-speleo.org/ontology/#",
  "wotc": "http://purl.org/wot-catalogue#",
  "ei2a": "http://opendata.aragon.es/def/ei2a#",
  "vlueprint": "https://vlueprint.org/schema/",
  "sorea": "http://sweetontology.net/realm/",
  "prismdb": "https://prismdb.takanakahiko.me/prism-schema.ttl#",
  "ebg": "http://data.businessgraph.io/ontology#",
  "rdapol": "http://rdaregistry.info/termList/RDAPolarity/",
  "bao": "http://www.bioassayontology.org/bao#",
  "saref4envi": "https://saref.etsi.org/saref4envi/",
  "ld": "http://linkeddata.ru/",
  "epcis": "https://ns.gs1.org/epcis/",
  "gco": "http://purl.jp/bio/12/glyco/conjugate#",
  "mgv": "http://mangaview.fr/mgv#",
  "ams": "http://data.amadeus.com/",
  "srv": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
  "gom": "https://w3id.org/gom#",
  "ble": "http://vocab.rapidthings.eu/ns/ble.ttl#",
  "xyz": "http://sparql.xyz/facade-x/data/",
  "hpont": "https://w3id.org/hpont#",
  "textgrid": "https://textgridrep.org/",
  "i18n": "https://www.w3.org/ns/i18n#",
  "ibeacon": "http://vocab.rapidthings.eu/ns/apple/ibeacon.ttl#",
  "marcgt": "https://id.loc.gov/vocabulary/marcgt/",
  "mpg123": "https://devuan.net.br/wiki/mpg123/",
  "freq": "http://purl.org/cld/freq/",
  "contry": "http://dbpedia.org/resource/Lyon#",
  "bop": "https://w3id.org/bop#",
  "univ": "http://univ.io/",
  "mag": "https://makg.org/property/",
  "rofchrda": "http://rdaregistry.info/termList/rofchrda/",
  "oeso": "http://www.opensilex.org/vocabularies/oeso#",
  "cso": "http://cso.kmi.open.ac.uk/schema/cso/",
  "bcom": "https://w3id.org/bcom#",
  "quran": "http://khalidaloufi.sa/quran#",
  "tso": "https://w3id.org/tso#",
  "rdat": "http://rdaregistry.info/Elements/t/",
  "maroc": "http://fr.dbpedia.org/page/Maroc/",
  "estraf": "http://vocab.ciudadesabiertas.es/def/transporte/trafico#",
  "motogp": "http://www.motogp.com/",
  "accid": "http://pid.accurids.com/",
  "mltd": "https://mltd.pikopikopla.net/mltd-schema#",
  "srr": "https://w3id.org/srr#",
  "la": "https://linked.art/ns/terms/",
  "vr": "https://www.w3.org/2018/credentials/v1/",
  "w3geo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "hola": "https://moodle.insa-lyon.fr/course/view.php?id=",
  "rdaut": "http://rdaregistry.info/termList/RDAUnitOfTime/",
  "cbv": "https://ns.gs1.org/cbv/",
  "hops": "https://rdf.ag/o/hops#",
  "vph": "http://purl.org/ozo/vph.owl#",
  "contax": "https://w3id.org/con-tax#",
  "bdg": "http://data.bigdatagrapes.eu/resource/ontology/",
  "seasd": "https://w3id.org/seas/",
  "bleadapter": "http://vocab.rapidthings.eu/ns/ble/adapter.ttl#",
  "dom": "https://html.spec.whatwg.org/#",
  "samian": "http://lod.archaeology.link/data/samian/",
  "smithy": "https://awslabs.github.io/smithy/rdf-1.0#",
  "mesh2021": "http://id.nlm.nih.gov/mesh/2021/",
  "esconv": "http://vocab.ciudadesabiertas.es/def/sector-publico/convenio#",
  "pgxo": "http://ns.inria.fr/pgxo/",
  "mdcs": "https://mdcs.monumentenkennis.nl/damageatlas/ontology#",
  "rdaep": "http://rdaregistry.info/termList/RDAExtensionPlan/",
  "kpd": "http://purl.org/kpd/",
  "check": "http://pornhub.com/",
  "geodcat": "http://data.europa.eu/930/",
  "aspect": "http://purl.org/aspect/",
  "rdano": "http://rdaregistry.info/Elements/n/object/",
  "nsg": "https://neuroshapes.org/",
  "ssnx": "http://purl.oclc.org/NET/ssnx/ssn#",
  "rpg": "http://rpg.data.is4.site/",
  "mnx": "https://rdf.metanetx.org/schema/",
  "rdamd": "http://rdaregistry.info/Elements/m/datatype/",
  "faas": "http://semantic-faas.com/ontology#",
  "sty": "http://purl.bioontology.org/ontology/STY/",
  "rdaao": "http://rdaregistry.info/Elements/a/object/",
  "slm": "http://urn.fi/URN:NBN:fi:au:slm:",
  "melding": "http://lblod.data.gift/vocabularies/automatische-melding/",
  "rdaxd": "http://rdaregistry.info/Elements/x/datatype/",
  "rdaio": "http://rdaregistry.info/Elements/i/object/",
  "rdato": "http://rdaregistry.info/Elements/t/object/",
  "signify": "http://purl.org/signify/ns#",
  "lado": "http://archaeology.link/ontology#",
  "esautob": "http://vocab.ciudadesabiertas.es/def/transporte/autobus#",
  "roffgrda": "http://rdaregistry.info/termList/roffgrda/",
  "datagc": "https://data.grottocenter.org/ldp/",
  "rdatb": "http://rdaregistry.info/termList/RDATypeOfBinding/",
  "spec": "http://www.w3.org/ns/spec#",
  "rdaid": "http://rdaregistry.info/Elements/i/datatype/",
  "comp": "http://semweb.mmlab.be/ns/rml-compression#",
  "sou": "http://qudt.org/vocab/sou/",
  "folio": "http://IBCNServices.github.io/Folio-Ontology/Folio.owl#",
  "idpo": "https://w3id.org/idpo#",
  "itops": "https://vocab.eccenca.com/itops/",
  "stax": "https://w3id.org/stax/ontology#",
  "cinema": "http://www.semanticweb.org/julien/morgann/cinema#",
  "citedcat": "https://w3id.org/citedcat-ap/",
  "cerealstoo": "http://rdf.ag/o/cerealstoo#",
  "rdan": "http://rdaregistry.info/Elements/n/",
  "oidc": "http://www.w3.org/ns/solid/oidc#",
  "rdatask": "http://rdaregistry.info/termList/RDATasks/",
  "ofn": "http://www.ontotext.com/sparql/functions/",
  "arena": "https://solid.ti.rw.fau.de/public/ns/arena#",
  "rdatd": "http://rdaregistry.info/Elements/t/datatype/",
  "mrk": "http://www.mydomain.org/Mrk-ns#",
  "esempleo": "http://vocab.ciudadesabiertas.es/def/sector-publico/empleo#",
  "rdaed": "http://rdaregistry.info/Elements/e/datatype/",
  "oghamonto": "http://ontology.ogham.link/",
  "react": "https://w3id.org/react#",
  "tci": "https://w3id.org/lbs/tci#",
  "rdamo": "http://rdaregistry.info/Elements/m/object/",
  "hqdmontol": "http://www.semanticweb.org/magma-core/ontologies/hqdm#",
  "rofitrda": "http://rdaregistry.info/termList/rofitrda/",
  "nanopub": "http://www.nanopub.org/nschema#",
  "rofsfrda": "http://rdaregistry.info/termList/rofsfrda/",
  "oeo": "https://openenergyplatform.org/ontology/oeo/",
  "magmauser": "http://www.semanticweb.org/magma-core/user#",
  "luigiusai": "https://www.luigiusai.it/wp#",
  "matrycs": "http://matrycs.com/",
  "rdamat": "http://rdaregistry.info/termList/RDAMaterial/",
  "rdapd": "http://rdaregistry.info/Elements/p/datatype/",
  "cpc": "https://data.epo.org/linked-data/def/cpc/",
  "rdawo": "http://rdaregistry.info/Elements/w/object/",
  "memorix": "http://memorix.io/ontology#",
  "xmlns": "http://www.w3.org/2021/XMLSchema#",
  "rdaim": "http://rdaregistry.info/termList/RDAInteractivityMode/",
  "rdaxo": "http://rdaregistry.info/Elements/x/object/",
  "m8g": "http://data.europa.eu/m8g/",
  "encargado": "http://semRAT.edu/",
  "mrt": "http://marineregions.org/ns/placetypes#",
  "ogham": "http://lod.ogham.link/data/",
  "rdasca": "http://rdaregistry.info/termList/scale/",
  "ch": "https://schema.ld.admin.ch/",
  "meat": "http://example.com/",
  "feed": "https://www.feedipedia.org/",
  "m4i": "http://w3id.org/nfdi4ing/metadata4ing#",
  "rdap": "http://rdaregistry.info/Elements/p/",
  "nbo": "http://data.bioontology.org/ontologies/NBO/",
  "paf": "https://paf.link/",
  "rdand": "http://rdaregistry.info/Elements/n/datatype/",
  "edu": "https://schema.edu.ee/",
  "bcfowl": "http://lbd.arch.rwth-aachen.de/bcfOWL#",
  "eep": "https://w3id.org/eep#",
  "cpg": "http://modellingdh.github.io/ont/odp/pgc/",
  "poke": "https://pokemonkg.org/ontology#",
  "biocrm": "http://ldf.fi/schema/bioc/",
  "interop": "http://www.w3.org/ns/solid/interop#",
  "ewg": "http://ethoinformatics.org/",
  "aff": "https://w3id.org/affectedBy#",
  "cgo": "https://www.tno.nl/agrifood/ontology/common-greenhouse-ontology#",
  "s223": "http://data.ashrae.org/standard223#",
  "eurio": "http://data.europa.eu/s66#",
  "gax": "http://w3id.org/gaia-x/core#",
  "nsd": "https://w3id.org/nsd#",
  "djo": "http://purl.org/datajourneys/",
  "esc": "https://solid.ti.rw.fau.de/public/ns/event-sourcing-containers#",
  "rc": "https://w3id.org/rc#",
  "srmo": "https://w3id.org/srmo#",
  "rdapath": "http://rdaregistry.info/termList/RDARecordingMethods/",
  "lds": "https://solid.ti.rw.fau.de/public/ns/linked-data-structures#",
  "rdawd": "http://rdaregistry.info/Elements/w/datatype/",
  "olias": "http://purl.org/olia/system.owl#",
  "srt": "http://w3id.org/srt#",
  "uberon": "http://purl.obolibrary.org/obo/UBERON_",
  "dsd": "https://w3id.org/dsd#",
  "bau": "https://terminology.fraunhofer.de/voc/bau#",
  "sds": "https://w3id.org/sds#",
  "asf": "https://www.stm-assoc.org/asf/",
  "tro": "https://w3id.org/TRO/",
  "caso": "http://www.w3id.org/def/caso#",
  "quid": "https://w3id.org/quid/",
  "godaddy": "https://sso.godaddy.com/",
  "eb": "https://w3id.org/eb#",
  "srtun": "https://www.inf.bi.rub.de/srtun#",
  "ea": "http://eaontology.protect.linkeddata.es/def/",
  "bdsubj": "https://purl.org/fidbaudigital/subjects#",
  "lbds": "https://w3id.org/lbdserver#",
  "chameo": "https://w3id.org/emmo/domain/characterisation-methodology/chameo#",
  "ghga": "http://w3id.org/ghga/",
  "kdsf": "https://kerndatensatz-forschung.de/version1/technisches_datenmodell/owl/kdsf.owl#",
  "ldpsc": "https://solid.ti.rw.fau.de/public/ns/stream-containers#",
  "rsx": "http://rdf4j.org/shacl-extensions#",
  "walmart": "https://www.amazon.de/",
  "wfont": "https://w3id.org/wfont#",
  "ofo": "https://w3id.org/ofo#",
  "archivo": "https://archivo.dbpedia.org/onto#",
  "ontobras": "http://www.semanticweb.org/fefar/ontologies/ontobras#",
  "magmardl": "http://www.semanticweb.org/magma-core/rdl#",
  "lbdserver": "https://w3id.org/lbdserver#",
  "stix": "http://purl.org/cyber/stix#",
  "ppeer": "http://parliament.uk/ontologies/peerage/",
  "hqdm": "http://www.semanticweb.org/hqdm#",
  "conllu": "https://universaldependencies.org/format.html#",
  "rto": "https://w3id.org/rail/topo#",
  "wdno": "http://www.wikidata.org/prop/novalue/",
  "stirdata": "https://w3id.org/stirdata/vocabulary/",
  "osdu": "https://w3id.org/OSDU#",
  "generiek": "https://data.vlaanderen.be/ns/generiek#",
  "experts": "http://emmo.info/emmo/application/maeo/experts#",
  "bag2": "http://bag.basisregistraties.overheid.nl/def/bag#",
  "fpr": "http://www.filmstandards.org/schemas/filmportal_relations#",
  "rmlt": "http://semweb.mmlab.be/ns/rml-target#",
  "opltw": "http://www.openlinksw.com/schemas/twitter#",
  "nprl": "http://data.nobelprize.org/resource/laureate/",
  "dmo": "https://w3id.org/dmo#",
  "fso": "https://w3id.org/fso#",
  "linkml": "https://w3id.org/linkml/",
  "diso": "https://purls.helmholtz-metadaten.de/diso#",
  "nomo": "https://nomenclature.info/nom/ontology/",
  "express": "https://w3id.org/express#",
  "setl": "http://purl.org/twc/vocab/setl/",
  "marc": "http://www.loc.gov/MARC21/slim/",
  "covido": "https://w3id.org/CovidO#",
  "tern": "http://w3id.org/tern/ontologies/tern/",
  "rsp": "http://www.researchspace.org/resource/",
  "crmsci": "http://www.cidoc-crm.org/extensions/crmsci/",
  "paam": "https://lod.mediathek-tanz-theater.de/schema/paam/",
  "rdaeo": "http://rdaregistry.info/Elements/e/object/",
  "itcrdf": "http://www.w3.org/2005/11/its/rdf#",
  "rro": "http://semanticweb.org/patricia/ontologies/rro#",
  "lsqr": "http://lsq.aksw.org/",
  "jsonld": "http://www.w3.org/ns/json-ld#",
  "hni": "https://collectiedata.hetnieuweinstituut.nl/",
  "roh": "http://w3id.org/roh#",
  "raum": "https://terminology.fraunhofer.de/voc/raum#",
  "rism": "http://rism.online/",
  "ultragaz": "https://ultragaz24horas.com/",
  "chemrof": "https://w3id.org/chemrof/",
  "weki": "https://en.wikipedia.org/wiki/",
  "kgi": "http://ns.inria.fr/kg/index#",
  "rnce": "https://data.cultureelerfgoed.nl/id/rnce#",
  "pgo": "http://ii.uwb.edu.pl/pgo#",
  "respond": "https://w3id.org/respond#",
  "linkedart": "https://linked.art/ns/terms/",
  "chess": "http://purl.org/NET/rdfchess/ontology/",
  "besluitvor": "https://data.vlaanderen.be/ns/besluitvorming#",
  "tempo": "http://purl.org/tempo/",
  "iddo": "https://w3id.org/iddo#",
  "lrcommon": "http://landregistry.data.gov.uk/def/common/",
  "consolid": "https://w3id.org/consolid#",
  "vl": "https://version.link/",
  "cido": "http://purl.obolibrary.org/obo/cido.owl/",
  "nom": "https://nomenclature.info/nom/",
  "gufo": "http://purl.org/nemo/gufo#",
  "dsi": "https://data.dsi.omgeving.vlaanderen.be/ns/dsi#",
  "value": "http://gfgfd.vs/",
  "osmo": "https://purl.org/vimmp/osmo#",
  "vntourism": "http://www.semanticweb.org/minhn/ontologies/2021/0/vntourism#",
  "icon": "https://w3id.org/icon/ontology/",
  "grscicoll": "https://www.gbif.org/grscicoll/collection/",
  "bp3": "http://www.biopax.org/release/biopax-level3.owl#",
  "gql": "http://www.openlinksw.com/schemas/graphql#",
  "film": "http://semantics.id/ns/example/film/",
  "rtedurp": "http://purl.org/eduo/rtedurp/",
  "peco": "https://w3id.org/peco#",
  "ttrpg": "https://w3id.org/TTRpg#",
  "rcgs": "https://collection.rcgs.jp/terms/",
  "robotarm": "https://solid.ti.rw.fau.de/public/ns/robotArm#",
  "veelana": "http://onlyfans.com/veelana/",
  "mondo": "http://purl.obolibrary.org/obo/MONDO_",
  "spatialf": "http://jena.apache.org/function/spatial#",
  "dbd": "http://dbpedia.org/datatype/",
  "cvb": "http://rdfs.org/resume-rdf/base.rdfs#",
  "perscido": "https://perscido.univ-grenoble-alpes.fr/",
  "pubchem": "https://pubchem.ncbi.nlm.nih.gov/",
  "relation": "http://www.iana.org/assignments/relation/",
  "apods": "http://activitypods.org/ns/core#",
  "dqvno": "https://data.norge.no/vocabulary/dqvno#",
  "aec3po": "https://w3id.org/lbd/aec3po/",
  "raad": "https://raadzaam.nl/schema/",
  "fdp": "https://w3id.org/fdp/fdp-o#",
  "nen2660": "https://w3id.org/nen2660/def#",
  "yanice": "http://yanice-boady.webflow.io/",
  "kokot": "http://www.koko.t/",
  "vhbieo": "https://w3id.org/vhbieo#",
  "version": "https://version.link/",
  "iottta": "https://w3id.org/iot-tta#",
  "nalt": "https://lod.nal.usda.gov/nalt/",
  "era": "http://data.europa.eu/949/",
  "dcb": "http://dbpedia.org/resource/Category:",
  "bmp": "http://w3id.org/bmp#",
  "lis": "http://rds.posccaesar.org/ontology/lis14/rdl/",
  "coy": "https://schema.coypu.org/global#",
  "skosm": "http://www.w3.org/2004/02/skos/mapping#",
  "ufo": "http://ufo.com/#",
  "lol": "https://sbalot.github.io/lol/",
  "bto": "http://w3id.org/emmo-bto/bto#",
  "docbook": "http://docbook.org/ns/docbook/",
  "epo": "http://data.europa.eu/a4g/ontology#",
  "plant": "http://example.org/plant/",
  "bcgo": "http://purl.obolibrary.org/obo/ZP_",
  "hmas": "https://purl.org/hmas/",
  "fdof": "https://w3id.org/fdof/ontology#",
  "thub": "http://vocabularis.crai.ub.edu/thub/",
  "ecfo": "https://w3id.org/ecfo#",
  "nutscode": "http://data.europa.eu/nuts/code/",
  "emmo": "https://w3id.org/emmo#",
  "dcatap": "http://data.europa.eu/r5r/",
  "mi": "http://www.marineinfo.org/ns/ontology#",
  "fs": "https://www.compliancequest.com/training-management-software-system-solutions/",
  "dcatno": "https://data.norge.no/vocabulary/dcatno#",
  "wrroc": "https://w3id.org/ro/terms/workflow-run#",
  "dick": "http://pornhub.com/",
  "vcs": "https://data.vlaanderen.be/ns/chemische_stof#",
  "ammo": "http://ldf.fi/schema/ammo/",
  "ontouml": "https://w3id.org/ontouml#",
  "asb": "https://w3id.org/asbingowl/core#",
  "ags": "https://id.agschemas.org/",
  "hyr": "https://w3id.org/simulation/data/",
  "dbpg": "http://dbpedia.org/page/",
  "to": "http://purl.obolibrary.org/obo/TO_",
  "threat": "https://cve.mitre.org/",
  "atcc": "https://www.atcc.org/products/",
  "acp": "http://www.w3.org/ns/solid/acp#",
  "goavoc": "http://bio2rdf.org/goa_vocabulary:",
  "coreo": "http://purl.org/coreo#",
  "cur": "http://qudt.org/2.1/vocab/currency/",
  "risk": "https://www.w3id.org/risk#",
  "ntp": "https://schema.finto.fi/ntp#",
  "iop": "https://w3id.org/iadopt/ont/",
  "egdo": "http://example.org/",
  "lcnaf": "http://id.loc.gov/authorities/names/",
  "coos": "http://id.unece.org/def/coos#",
  "imbor": "https://data.crow.nl/imbor/def/",
  "baf": "https://w3id.org/baf#",
  "pico": "https://personsincontext.org/model#",
  "matmine": "http://materialsmine.org/ns/",
  "tsso": "https://scch.org/technical_standards#",
  "databus": "https://dataid.dbpedia.org/databus#",
  "sense": "https://w3id.org/sense#",
  "ksamsok": "http://kulturarvsdata.se/ksamsok#",
  "mibc": "http://marineinfo.org/ns/library/bibcodes#",
  "bacnet": "http://data.ashrae.org/bacnet/2020#",
  "p2po": "https://purl.org/p2p-o#",
  "uio": "https://www.mitre.org/mparmelee/ontologies/2023/6/UserIntentOntology/",
  "ceox": "https://linkeddata.cultureelerfgoed.nl/def/ceox#",
  "coda": "http://art.uniroma2.it/coda/contracts/",
  "mindat": "https://www.mindat.org/",
  "rb": "https://w3id.org/riverbench/schema/metadata#",
  "keyon": "http://keyelements.ltd/ontologies/keyon/#",
  "hu": "https://mail.google.com/",
  "quest": "https://rb.gy/ntg7l/",
  "ind": "https://w3id.org/inesdata#",
  "notify": "http://www.w3.org/ns/solid/notifications#",
  "ocmv": "https://w3id.org/ontouml-models/vocabulary#",
  "rbdoc": "https://w3id.org/riverbench/schema/documentation#",
  "pit": "http://data.elsevier.com/vocabulary/ElsevierPubItemTypes/",
  "bsdd": "http://bsdd.buildingsmart.org/def#",
  "ogcf": "http://www.opengis.net/def/function/geosparql/",
  "koko": "https://seznam.cz/",
  "fisa": "https://ifitkau.github.io/fisa/",
  "mibt": "https://marineinfo.org/ns/library/bibtypes#",
  "bioschemas": "https://bioschemas.org/",
  "into": "https://app.korfin.de/ontology/into/",
  "sssom": "https://w3id.org/sssom/",
  "ncbi": "https://www.ncbi.nlm.nih.gov/",
  "cpsvno": "http://data.norge.no/vocabulary/cpsvno#",
  "doce": "http://purl.org/nemo/doce#",
  "hy": "https://api.hyprdia.com/",
  "cercabib": "https://cercabib.ub.edu/",
  "exekg": "https://raw.githubusercontent.com/nsai-uio/ExeKGOntology/main/ds_exeKGOntology.ttl#",
  "semapv": "https://w3id.org/semapv/vocab/",
  "w3": "http://www.w3.org/",
  "cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties/",
  "dde": "https://www.ddeworld.org/",
  "mifesto": "https://w3id.org/mifesto#",
  "doam": "http://emmo.info/doam#",
  "plasma": "https://w3id.org/plasma#",
  "mpio": "http://purl.obolibrary.org/obo/ZP_",
  "lpwcc": "https://linkedpaperswithcode.com/class/",
  "ontologia": "http://ub.edu/dades/ontologia/Cinema#Cinemes#",
  "pbac": "https://w3id.org/pbac#",
  "coswot": "https://w3id.org/coswot/",
  "quit": "http://quit.aksw.org/vocab/",
  "pdumdv": "http://purl.obolibrary.org/obo/PdumDv_",
  "ioc": "http://w3id.org/ioc#",
  "skosno": "http://data.norge.no/skosno#",
  "ontohgis": "https://onto.kul.pl/ontohgis/",
  "hsapdv": "http://purl.obolibrary.org/obo/HsapDv_",
  "sri": "https://w3id.org/sri#",
  "top": "http://w3id.org/topologicpy#",
  "ohd": "http://purl.obolibrary.org/obo/ZP_",
  "oplben": "http://www.openlinksw.com/ontology/benefits#",
  "pcp": "https://pcp-on-web.de/ontology/0.2/index-en.html#",
  "mfo": "http://purl.obolibrary.org/obo/ZP_",
  "battery": "https://w3id.org/emmo/domain/battery/battery#",
  "sure": "http://ns.inria.fr/sure#",
  "interpro": "https://www.ebi.ac.uk/interpro/entry/InterPro/",
  "batmanont": "http://emmo.info/emmo/application/bmo#",
  "isoprops": "https://w3id.org/isoprops#",
  "nmr": "https://www.ebi.ac.uk/ols4/ontologies/nmrcv/terms?short_form=NMR:",
  "chpaf": "https://ch.paf.link/",
  "mir": "http://marineinfo.org/ns/person/roles#",
  "lpwc": "https://linkedpaperswithcode.com/property/",
  "gramene": "http://www.gramene.org/db/ontology/search?id=GRO:",
  "oav": "http://lod.openaire.eu/vocab/",
  "ies": "http://ies.data.gov.uk/ontology/ies4#",
  "ies4": "http://ies.data.gov.uk/ontology/ies4#",
  "htn": "http://purl.obolibrary.org/obo/ZP_",
  "eurovoc": "http://eurovoc.europa.eu/",
  "loggerhead": "http://purl.obolibrary.org/obo/LOGGERHEAD_",
  "upheno": "http://purl.obolibrary.org/obo/UPHENO_",
  "hom": "http://purl.obolibrary.org/obo/HOM_",
  "maeo": "http://w3id.org/emmo-maeo/maeo#",
  "ornaseq": "http://purl.obolibrary.org/obo/ORNASEQ_",
  "ddpheno": "http://purl.obolibrary.org/obo/DDPHENO_",
  "clyh": "http://purl.obolibrary.org/obo/ZP_",
  "sopharm": "http://purl.obolibrary.org/obo/SOPHARM_",
  "apollosv": "http://purl.obolibrary.org/obo/APOLLO_SV_",
  "proco": "http://purl.obolibrary.org/obo/PROCO_",
  "openwemi": "https://ns.dublincore.org/openwemi/",
  "cergy": "https://dbpedia.org/page/Cergy/",
  "cred": "https://www.w3.org/2018/credentials#",
  "fro": "https://foundry.ai.mil/ontology/nas/fro/",
  "przecieki": "http://onlyfans.com/emiliaszymanska/",
  "sep": "http://purl.obolibrary.org/obo/ZP_",
  "nyon": "https://w3id.org/def/nyon#",
  "kbmarc": "https://id.kb.se/marc/",
  "sbo": "https://paul.ti.rw.fau.de/~jo00defe/ble/sbo#",
  "iig": "https://w3id.org/iicongraph/data/",
  "imdb": "http://m.imdb.com/",
  "fovt": "http://purl.obolibrary.org/obo/FOVT_",
  "wbls": "http://purl.obolibrary.org/obo/WBls_",
  "msl": "https://w3id.org/msl#",
  "cob": "http://purl.obolibrary.org/obo/COB_",
  "vt": "http://purl.obolibrary.org/obo/VT_",
  "olis": "http://olis.dev/",
  "htv": "http://www.w3.org/2011/http#",
  "soa": "https://semopenalex.org/ontology/",
  "mro": "http://purl.obolibrary.org/obo/MRO_",
  "iptc4xmpc": "http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/",
  "jps": "https://jpsearch.go.jp/term/property#",
  "tdm": "http://www.w3.org/ns/tdmrep#",
  "gallont": "http://purl.obolibrary.org/obo/GALLONT_",
  "capdata": "https://ontologie.capdataculture.fr/v1/owl/#",
  "mee": "http://www.w3.org/ns/pim/meeting#",
  "shsh": "http://www.w3.org/ns/shacl-shacl#",
  "lpto": "http://w3id.org/lpto#",
  "credit": "https://credit.niso.org/",
  "iceo": "http://purl.obolibrary.org/obo/ICEO_",
  "mao": "https://domestic-beethoven.eu/ontology/1.0/music-annotation-ontology.ttl#",
  "oplmarket": "http://www.openlinksw.com/ontology/market#",
  "dgaterms": "https://w3id.org/dgaterms#",
  "doid": "http://purl.obolibrary.org/obo/DOID_",
  "osh": "https://w3id.org/oseg/ont/osh#",
  "dcid": "https://datacommons.org/browser/",
  "taxrank": "http://purl.obolibrary.org/obo/TAXRANK_",
  "planp": "http://purl.obolibrary.org/obo/PLANP_",
  "loinc": "https://loinc.org/",
  "gecko": "http://purl.obolibrary.org/obo/ZP_",
  "vhog": "http://purl.obolibrary.org/obo/VHOG_",
  "aao": "http://purl.obolibrary.org/obo/AAO_",
  "deonta": "https://deonta.linkedmodel.org/deonta/",
  "lrm": "https://iflastandards.info/ns/lrm/lrmoo/",
  "occupation": "http://nikunj.org/ontology/occupatioin#",
  "echem": "https://w3id.org/emmo/domain/electrochemistry#",
  "mop": "http://purl.obolibrary.org/obo/MOP_",
  "propreo": "http://purl.obolibrary.org/obo/PROPREO_",
  "fbdv": "http://purl.obolibrary.org/obo/FBdv_",
  "hao": "http://purl.obolibrary.org/obo/HAO_",
  "mco": "http://purl.obolibrary.org/obo/MCO_",
  "emap": "http://purl.obolibrary.org/obo/EMAP_",
  "cmf": "http://purl.obolibrary.org/obo/CMF_",
  "liph": "https://gallosiciliani.unict.it/ns/lpont#",
  "obi": "http://purl.obolibrary.org/obo/OBI_",
  "apmwg": "http://apmwg.ovh/",
  "okh": "https://w3id.org/oseg/ont/okh#",
  "spd": "http://purl.obolibrary.org/obo/SPD_",
  "fbbt": "http://purl.obolibrary.org/obo/FBbt_",
  "fbcv": "http://purl.obolibrary.org/obo/FBcv_",
  "chems": "https://w3id.org/emmo/domain/chemical-substance#",
  "foaa": "https://kibanshoe.com/",
  "geolink": "http://schema.geolink.org/1.0/base/main#",
  "hpo": "http://w3id.org/emmo-hpo/hpo#",
  "oio": "http://www.geneontology.org/formats/oboInOwl#",
  "firebim": "http://w3id.org/firebim#",
  "clao": "http://purl.obolibrary.org/obo/CLAO_",
  "sibo": "http://purl.obolibrary.org/obo/ZP_",
  "spo": "https://w3id.org/steel/ProcessOntology/",
  "mbl": "https://w3id.org/mbl#",
  "ons": "http://purl.obolibrary.org/obo/ONS_",
  "idomal": "http://purl.obolibrary.org/obo/IDOMAL_",
  "crmgeo": "http://www.ics.forth.gr/isl/CRMgeo/",
  "omo": "http://purl.obolibrary.org/obo/OMO_",
  "sepio": "http://purl.obolibrary.org/obo/SEPIO_",
  "ogsf": "http://purl.obolibrary.org/obo/OGSF_",
  "dpo": "http://purl.obolibrary.org/obo/FBcv_",
  "uo": "http://purl.obolibrary.org/obo/UO_",
  "foodon": "http://purl.obolibrary.org/obo/FOODON_",
  "ecocore": "http://purl.obolibrary.org/obo/ECOCORE_",
  "aimaix": "https://w3id.org/aimaix#",
  "tsdcreq": "https://w3id.org/oseg/ont/tsdc/req#",
  "fiaf": "https://ontology.fiafcore.org/",
  "pao": "http://purl.obolibrary.org/obo/PAO_",
  "schemas": "https://schema.org/",
  "ontoavida": "http://purl.obolibrary.org/obo/ONTOAVIDA_",
  "tops": "http://www.topbraid.org/tops#",
  "imr": "http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IMR&id=",
  "qualityze": "https://www.qualityze.com/document-management/",
  "clo": "http://purl.obolibrary.org/obo/ZP_",
  "meas": "https://graph.interoptx.org/meas/",
  "cvdo": "http://purl.obolibrary.org/obo/CVDO_",
  "ecp": "http://www.ebu.ch/metadata/ontologies/ebucoreplus#",
  "rxno": "http://purl.obolibrary.org/obo/ZP_",
  "cwo": "http://kcoyle.net/cwo/",
  "uiot": "http://www.w3id.org/urban-iot/core#",
  "ovae": "http://purl.obolibrary.org/obo/OVAE_",
  "tto": "http://purl.obolibrary.org/obo/TTO_",
  "mfoem": "http://purl.obolibrary.org/obo/MFOEM_",
  "cacax": "http://cacax.fun/",
  "bcnres": "http://datos.bcn.cl/ontologies/bcn-resources#",
  "maid": "https://mutual-aid.app/ns/core#",
  "miprog": "https://marineinfo.org/ns/progress#",
  "guez": "http://guez.fr/",
  "pgdso": "http://purl.obolibrary.org/obo/PGDSO_",
  "duo": "http://purl.obolibrary.org/obo/DUO_",
  "stroke": "https://mre.zcu.cz/ontology/stroke.owl#",
  "gtm": "https://www.goudatijdmachine.nl/def#",
  "crcr": "https://credit.niso.org/contributor-roles/",
  "mat": "http://purl.obolibrary.org/obo/MAT_",
  "bootstrep": "http://purl.obolibrary.org/obo/BOOTSTREP_",
  "multionto": "http://purl.org/net/multionto/",
  "bspo": "http://purl.obolibrary.org/obo/BSPO_",
  "edtf": "http://id.loc.gov/datatypes/EDTFScheme/",
  "obom": "https://w3id.org/open-bom/ont/open-bom#",
  "dictionary": "https://standards.buildingsmart.org/DataDictionary/",
  "qcy": "https://qaecy.com/dev/ont#",
  "libeas": "https://w3id.org/libeas#",
  "tsdc": "https://w3id.org/oseg/ont/tsdc/core#",
  "hht": "https://w3id.org/HHT#",
  "ncro": "http://purl.obolibrary.org/obo/NCRO_",
  "vair": "https://w3id.org/vair#",
  "geogeo": "http://purl.obolibrary.org/obo/GEO_",
  "eupath": "http://purl.obolibrary.org/obo/EUPATH_",
  "symp": "http://purl.obolibrary.org/obo/SYMP_",
  "mfomd": "http://purl.obolibrary.org/obo/MFOMD_",
  "xao": "http://purl.obolibrary.org/obo/XAO_",
  "xco": "http://purl.obolibrary.org/obo/XCO_",
  "mpath": "http://purl.obolibrary.org/obo/MPATH_",
  "ohpi": "http://purl.obolibrary.org/obo/OHPI_",
  "mmusdv": "http://purl.obolibrary.org/obo/MmusDv_",
  "joe": "http://example.org/joe/",
  "tgma": "http://purl.obolibrary.org/obo/TGMA_",
  "duodrl": "https://w3id.org/duodrl#",
  "after": "http://rds.posccaesar.org/ontology/plm/ds/",
  "oba": "http://purl.obolibrary.org/obo/OBA_",
  "amv": "https://w3id.org/amv/",
  "pwkso": "http://ns.inria.fr/pwkso/",
  "emobon": "http://www.embrc.eu/emobon/EmoBonOntology#",
  "cams": "https://graph.interoptx.org/cams/schema/",
  "zea": "http://purl.obolibrary.org/obo/ZEA_",
  "otrl": "https://w3id.org/oseg/ont/otrl#",
  "moont": "https://w3id.org/moont/",
  "pa": "http://vtw.elsevier.com/data/ns/properties/PromotionalAccess-1/",
  "apo": "http://purl.obolibrary.org/obo/APO_",
  "ypc": "http://www.semanticweb.org/sunsr/ontologies/2024/ypc#",
  "nihss": "https://mre.zcu.cz/ontology/nihss.owl#",
  "labo": "http://purl.obolibrary.org/obo/LABO_",
  "ckg": "http://example.org/ckg#",
  "pdro": "http://purl.obolibrary.org/obo/PDRO_",
  "ehdaa": "http://purl.obolibrary.org/obo/EHDAA_",
  "opmi": "http://purl.obolibrary.org/obo/OPMI_",
  "lipro": "http://purl.obolibrary.org/obo/LIPRO_",
  "edo": "http://semanticweb.org/edo#",
  "cteno": "http://purl.obolibrary.org/obo/CTENO_",
  "flopo": "http://purl.obolibrary.org/obo/FLOPO_",
  "hancestro": "http://purl.obolibrary.org/obo/HANCESTRO_",
  "ogms": "http://purl.obolibrary.org/obo/OGMS_",
  "amphx": "http://purl.obolibrary.org/obo/AMPHX_",
  "dideo": "http://purl.obolibrary.org/obo/DIDEO_",
  "termdat": "https://register.ld.admin.ch/termdat/",
  "luffy": "http://google.com/",
  "spa": "https://paul.ti.rw.fau.de/~jo00defe/voc/spa#",
  "gsso": "http://purl.obolibrary.org/obo/GSSO_",
  "chiro": "http://purl.obolibrary.org/obo/CHIRO_",
  "biomodels": "http://purl.obolibrary.org/obo/KISAO_",
  "txpo": "http://purl.obolibrary.org/obo/ZP_",
  "chmo": "http://purl.obolibrary.org/obo/CHMO_",
  "pcl": "http://purl.obolibrary.org/obo/PCL_",
  "pw": "http://purl.obolibrary.org/obo/PW_",
  "ceph": "http://purl.obolibrary.org/obo/CEPH_",
  "dop": "https://w3id.org/dob/voc/prop#",
  "ehdaa2": "http://purl.obolibrary.org/obo/EHDAA2_",
  "slso": "http://purl.obolibrary.org/obo/SLSO_",
  "dprod": "https://ekgf.github.io/dprod/",
  "disdriv": "http://purl.obolibrary.org/obo/DISDRIV_",
  "did": "https://w3id.org/dob/id/",
  "occo": "http://purl.obolibrary.org/obo/OCCO_",
  "nomen": "http://purl.obolibrary.org/obo/NOMEN_",
  "vbo": "http://purl.obolibrary.org/obo/VBO_",
  "adw": "https://animaldiversity.org/accounts/",
  "pes": "https://semanticweb.inesctec.pt/ontologies/pes/",
  "omrse": "http://purl.obolibrary.org/obo/OMRSE_",
  "aio": "https://paul.ti.rw.fau.de/~jo00defe/SemWoT/aio#",
  "norse": "https://w3id.org/aksw/norse#",
  "vario": "http://purl.obolibrary.org/obo/VariO_",
  "oplmark": "http://www.openlinksw.com/ontology/market#",
  "psdo": "http://purl.obolibrary.org/obo/PSDO_",
  "whyis": "http://vocab.rpi.edu/whyis/",
  "tahe": "http://purl.obolibrary.org/obo/TAHE_",
  "flu": "http://purl.obolibrary.org/obo/FLU_",
  "oplgit": "http://www.openlinksw.com/schemas/github#",
  "cr": "http://mlcommons.org/croissant/",
  "ico": "http://purl.obolibrary.org/obo/ICO_",
  "ogg": "http://purl.obolibrary.org/obo/OGG_",
  "fix": "http://purl.obolibrary.org/obo/FIX_",
  "bila": "http://4dx.embl.de/4DXpress/reg/all/cview/gene.do?geneID=",
  "omit": "http://purl.obolibrary.org/obo/OMIT_",
  "fbbi": "http://purl.obolibrary.org/obo/FBbi_",
  "oarcs": "http://purl.obolibrary.org/obo/OARCS_",
  "oplog": "http://www.openlinksw.com/schemas/opengraph#",
  "rdfl": "https://w3id.org/rdf-lens/ontology#",
  "crdt": "https://vocab.noeldemartin.com/crdt/",
  "aix": "https://w3id.org/aix#",
  "loin": "http://w3id.org/loin#",
  "lepao": "http://purl.obolibrary.org/obo/LEPAO_",
  "cmso": "http://purls.helmholtz-metadaten.de/cmso/",
  "psn": "https://purl.org/psn/vocab#",
  "oostt": "http://purl.obolibrary.org/obo/OOSTT_",
  "ypo": "http://purl.obolibrary.org/obo/YPO_",
  "makeup": "http://example.org/makeup#",
  "mcro": "https://www.ebi.ac.uk/ols4/ontologies/mcro/classes?obo_id=MCRO:",
  "airo": "https://w3id.org/airo#",
  "tahh": "http://purl.obolibrary.org/obo/TAHH_",
  "nyanneko": "https://nyanneko.com/",
  "ado": "http://purl.obolibrary.org/obo/ADO_",
  "musi": "http://i-na-reg.musikinstrumentenbau.eu/ns/musi/",
  "lrmer": "http://iflastandards.info/ns/lrm/lrmer/",
  "envo": "http://purl.obolibrary.org/obo/ZP_",
  "ceosp": "https://linkeddata.cultureelerfgoed.nl/def/ceosp/",
  "cdno": "http://purl.obolibrary.org/obo/CDNO_",
  "upa": "http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=",
  "dob": "https://w3id.org/dob/voc#",
  "wbbt": "http://purl.obolibrary.org/obo/WBbt_",
  "tads": "http://purl.obolibrary.org/obo/TADS_",
  "vsao": "http://purl.obolibrary.org/obo/VSAO_",
  "ohmi": "http://purl.obolibrary.org/obo/OHMI_",
  "eo": "http://purl.obolibrary.org/obo/EO_",
  "dinto": "http://purl.obolibrary.org/obo/ZP_",
  "ogi": "http://purl.obolibrary.org/obo/OGI_",
  "fobi": "http://purl.obolibrary.org/obo/FOBI_",
  "afpo": "http://purl.obolibrary.org/obo/AfPO_",
  "rmle": "https://w3id.org/imec/rml/ns/extensions#",
  "zfa": "http://purl.obolibrary.org/obo/ZFA_",
  "plana": "http://purl.obolibrary.org/obo/PLANA_",
  "t4fs": "http://purl.obolibrary.org/obo/T4FS_",
  "olatdv": "http://purl.obolibrary.org/obo/OlatDv_",
  "epio": "http://purl.obolibrary.org/obo/EPIO_",
  "ehda": "http://purl.obolibrary.org/obo/EHDA_",
  "dblpdocu": "https://dblp.org/rdf/docu/#",
  "cio": "http://purl.obolibrary.org/obo/CIO_",
  "geno": "http://purl.obolibrary.org/obo/GENO_",
  "reloc": "https://w3id.org/reloc#",
  "fbsp": "http://purl.obolibrary.org/obo/FBSP_",
  "ror": "https://ror.org/",
  "scdo": "http://purl.obolibrary.org/obo/SCDO_",
  "omiabis": "http://purl.obolibrary.org/obo/OMIABIS_",
  "colao": "http://purl.obolibrary.org/obo/COLAO_",
  "zeco": "http://purl.obolibrary.org/obo/ZECO_",
  "vo": "http://purl.obolibrary.org/obo/VO_",
  "vto": "http://purl.obolibrary.org/obo/VTO_",
  "graphql": "https://graphql.org/",
  "npc": "https://purl.org/npc#",
  "genepio": "http://purl.obolibrary.org/obo/GENEPIO_",
  "cfg": "http://server.topbraidlive.org/web/2009/config#",
  "hso": "http://purl.obolibrary.org/obo/HSO_",
  "fypo": "http://purl.obolibrary.org/obo/FYPO_",
  "zp": "http://purl.obolibrary.org/obo/ZP_",
  "psm": "https://paul.ti.rw.fau.de/~jo00defe/ont/psm#",
  "vwlid": "https://vwgroup.leanix.net/Volkswagen/external/leanixId/",
  "oplic": "http://www.openlinksw.com/ontology/licenses#",
  "mfmo": "http://purl.obolibrary.org/obo/MFMO_",
  "maxo": "http://purl.obolibrary.org/obo/MAXO_",
  "miapa": "http://purl.obolibrary.org/obo/MIAPA_",
  "womo": "https://w3id.org/womo#",
  "ato": "http://purl.obolibrary.org/obo/ATO_",
  "volipi": "http://data.sparna.fr/ontologies/volipi#",
  "gno": "http://purl.obolibrary.org/obo/GNO_",
  "xpo": "http://purl.obolibrary.org/obo/XPO_",
  "geosrs": "https://w3id.org/geosrs#",
  "dtkt": "https://data.wikitrek.org/prop/direct/",
  "obcs": "http://purl.obolibrary.org/obo/OBCS_",
  "kvasir": "https://kvasir.discover.ilabt.imec.be/vocab#",
  "dron": "http://purl.obolibrary.org/obo/DRON_",
  "miron": "https://stgermain.ebsi.umontreal.ca/miron/",
  "jabel54303": "https://softwarehorsepower.com/product/brand24/",
  "oip": "http://www.exemple.org/ontologia/",
  "iev": "http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IEV&id=",
  "freespins": "https://bohoaff.com/a34fd6fba/",
  "oplgp": "http://www.openlinksw.com/schemas/googleplus#",
  "aschema": "https://schema.ld.admin.ch/",
  "mpbv": "http://meta-pfarrerbuch.evangelische-archive.de/vocabulary#",
  "aero": "http://purl.obolibrary.org/obo/AERO_",
  "hhtchange": "https://w3id.org/HHT/Change#",
  "rex": "http://purl.obolibrary.org/obo/REX_",
  "ssv": "https://w3id.org/ssv/",
  "zfs": "http://purl.obolibrary.org/obo/ZFS_",
  "resid": "https://proteininformationresource.org/cgi-bin/resid?id=",
  "trans": "http://purl.obolibrary.org/obo/TRANS_",
  "gaz": "http://purl.obolibrary.org/obo/GAZ_",
  "poro": "http://purl.obolibrary.org/obo/PORO_",
  "micro": "http://purl.obolibrary.org/obo/MICRO_",
  "emapa": "http://purl.obolibrary.org/obo/EMAPA_",
  "aism": "http://purl.obolibrary.org/obo/AISM_",
  "ftr": "https://w3id.org/ftr#",
  "tsdcr": "http://w3id.org/oseg/ont/tsdc/requirements#",
  "fair4ml": "https://w3id.org/fair4ml#",
  "zo": "https://linkeddata.cultureelerfgoed.nl/def/zo/",
  "rnao": "http://purl.obolibrary.org/obo/RNAO_",
  "ino": "http://purl.obolibrary.org/obo/INO_",
  "creon": "http://purl.org/creon/",
  "myv": "http://www.example.com/myvData/",
  "phipo": "http://purl.obolibrary.org/obo/PHIPO_",
  "oix": "http://www.exemple.org/ontologia/",
  "jav": "https://www.niso.org/schemas/jav/1.0/",
  "caro": "http://purl.obolibrary.org/obo/CARO_",
  "cdi": "http://ddialliance.org/Specification/DDI-CDI/1.0/RDF/",
  "xlmod": "http://purl.obolibrary.org/obo/XLMOD_",
  "ecao": "http://purl.obolibrary.org/obo/ECAO_",
  "miro": "http://purl.obolibrary.org/obo/MIRO_",
  "ddanat": "http://purl.obolibrary.org/obo/DDANAT_",
  "aicat": "http://w3id.org/aicat#",
  "stato": "http://purl.obolibrary.org/obo/STATO_",
  "codemeta": "https://codemeta.github.io/terms/",
  "checks": "https://data.digichecks.eu/def/",
  "obib": "http://purl.obolibrary.org/obo/OBIB_",
  "fideo": "http://purl.obolibrary.org/obo/FIDEO_",
  "gsn": "https://w3id.org/OntoGSN/ontology#",
  "ngbo": "http://purl.obolibrary.org/obo/NGBO_",
  "aiup": "http://w3id.org/aiup#",
  "onlyfans": "https://cutt.ly/3ry8LMcK/",
  "mirnao": "http://purl.obolibrary.org/obo/MIRNAO_",
  "ceon": "http://w3id.org/CEON/",
  "ce": "https://purl.org/cityexplorer#",
  "sn": "https://purl.org/supply-network/onto#",
  "ecto": "http://purl.obolibrary.org/obo/ECTO_",
  "frac": "http://www.w3.org/ns/lemon/frac#",
  "dtk": "https://data.wikitrek.org/entity/",
  "bng": "https://w3id.org/dob/voc/epsg-27700#",
  "nace2": "http://data.europa.eu/ux2/nace2/",
  "vwlpr": "https://vwgroup.leanix.net/Volkswagen/factsheet/Process/",
  "aro": "http://purl.obolibrary.org/obo/ARO_",
  "podio": "http://w3id.org/podio#",
  "azo": "https://linkeddata.cultureelerfgoed.nl/def/azo/",
  "aeo": "http://purl.obolibrary.org/obo/AEO_",
  "encom": "https://semanticweb.inesctec.pt/ontologies/encom/",
  "fugas": "https://onlyfans.com/sammuwuu/",
  "northwind": "http://demo.openlinksw.com/schemas/Northwind/",
  "nsprov": "http://www.w3.org/ns/prov#",
  "passport": "https://nepalpassport.gov.np/",
  "tgc": "http://www.hds.utc.fr/tg#",
  "vrti": "https://www.w3id.org/virtual-treasury/ontology#",
  "regcomp": "https://regulacomp.unige.ch/ns/regcomp#",
  "fti": "http://franz.com/ns/allegrograph/2.2/textindex/",
  "bambara": "http://example.org/bambara#",
  "unesco": "http://vocabularies.unesco.org/thesaurus/",
  "bam": "http://vtw.elsevier.com/data/voc/ns/bam-vtw-1/",
  "ishi": "https://w3id.org/ishikawa-diagram-ontology#",
  "pur": "http://prismstandard.org/namespaces/prismusagerights/2.1/",
  "vwlap": "https://vwgroup.leanix.net/Volkswagen/factsheet/Application/",
  "drammar": "http://www.purl.org/drammar#",
  "tgfm": "http://purl.org/terminology-guide-for-move/testvocab/",
  "och": "http://w3id.org/def/och/",
  "jats": "http://jats.nlm.nih.gov/",
  "arco": "https://w3id.org/arco/ontology/arco/",
  "spot": "https://w3id.org/spot#",
  "scdt": "http://w3id.org/awslabs/neptune/SPARQL-CDTs/",
  "lindas": "https://ld.admin.ch/",
  "itandrec": "http://www.semanticweb.org/pedri/ontologies/2025/3/IntelligentTourismAndRecommendations#",
  "npo": "https://w3id.org/NPO/ontology/",
  "libro": "https://www.librorum.fr/ontology/",
  "oqs": "http://purl.org/nsoluti/oqs#",
  "picom": "https://personsincontext.org/model#",
  "rdb": "http://www.dbs.cs.uni-duesseldorf.de/RDF/relational#",
  "ppm": "https://mestergruppen.no/ontologies/projectproductionmanagement/",
  "turism": "http://turism.com/",
  "icd": "http://purl.bioontology.org/ontology/ICD9CM/",
  "vwgw": "https://group-wiki.wob.vw.vwg/wikis/pages/viewpage.action?pageId=",
  "debias": "http://data.europa.eu/c4p/data/",
  "ris": "http://research-info-systems.com/schema/ris/",
  "fwo": "https://w3id.org/foodwaste/ontology#",
  "sip": "https://purl.semanticip.org/linked-data/",
  "know": "https://know.dev/",
  "rbo": "http://purl.obolibrary.org/obo/RBO_",
  "dsio": "https://ptb.de/si#",
  "ncl": "https://w3id.org/NCL/ontology/",
  "elsst": "https://elsst.cessda.eu/id/",
  "dbpde": "http://de.dbpedia.org/property/",
  "datmm": "http://id.nlm.nih.gov/datmm/",
  "sis": "https://ptb.de/sis/",
  "eliasempre": "https://eliasempresas.com/",
  "iirds": "http://iirds.tekom.de/iirds#",
  "riskman": "https://w3id.org/riskman/ontology#",
  "reno": "https://w3id.org/reno#",
  "sulo": "https://w3id.org/sulo/",
  "vm": "http://visual-meaning.com/rdf/",
  "vwdms": "https://vwdmsweb.wob.vw.vwg/groupdms/?docbase=vwdms&locateId=",
  "muno": "https://purl.org/muno/onto/",
  "whu": "http://bdi.whu.edu.cn/",
  "genex": "http://purl.org/genex#",
  "golem": "https://w3id.org/golem/ontology#",
  "bu": "http://borhan-onto.ir/ontology/upper#",
  "ubbont": "http://data.ub.uib.no/ontology/",
  "coso": "http://w3id.org/coso/v1/contaminoso#",
  "semts": "https://w3id.org/semts/ontology#",
  "dqa": "https://w3id.org/DQA#",
  "pmw": "http://ponymusic.wiki/ns#",
  "akco": "https://purl.archive.org/akco#",
  "coar": "http://purl.org/coar/resource_type/",
  "tribont": "https://w3id.org/tribont/core#",
  "evorao": "http://w3id.org/evorao/",
  "gro": "http://www.bootstrep.eu/ontology/GRO#",
  "piveau": "https://piveau.eu/ns/voc#",
  "exmo": "http://purl.obolibrary.org/obo/EXMO_",
  "csro": "https://w3id.org/csro/ontology#",
  "elm": "http://data.europa.eu/snb/model/elm/",
  "rdfc": "https://w3id.org/rdf-connect#",
  "csr": "http://purl.org/org/iode/po/voc/cruise-summary-reports#",
  "dtool": "https://devtoolkit.space/ontology#",
  "dcatde": "http://dcat-ap.de/def/dcatde/",
  "a11y": "http://idpf.org/epub/vocab/package/a11y/#",
  "sz": "https://github.com/senzing-garage/sz-semantics/wiki/ns#",
  "bmont": "http://purl.obolibrary.org/obo/BMONT_",
  "lib": "http://purl.org/library/",
  "bodi": "http://w3id.org/bodi#",
  "sdn": "https://ontology.seadatanet.org/#",
  "homoit": "https://homosaurus.org/v4/",
  "pghdprovo": "https://w3id.org/pghdprovo#",
  "modsrdf": "http://www.loc.gov/mods/rdf/v1#",
  "bno": "https://data.banenor.no/ontology/",
  "tfn": "https://w3id.org/time-fn#",
  "mdcat": "https://w3id.org/mobilitydcat-ap#",
  "bnd": "https://data.banenor.no/data/",
  "tbs": "http://topbraid.org/tbs#",
  "rtm": "http://ontology.railml.org/railtopomodel#",
  "tensor": "https://w3id.org/rdf-tensor/vocab#",
  "railml3": "http://ontology.railml.org/railml3#",
  "ard": "https://www.stratcom.mil/ontologies/electromagnetic-spectrum/adversary-radar-detection-ontology/",
  "dccs": "https://ptb.de/dccs/",
  "omekas": "http://omeka.org/s/vocabs/o#",
  "rdm": "https://terms.codata.org/rdmt/",
  "afy": "https://w3id.org/afy#",
  "dpp": "https://ns.verisav.fr/dpp#",
  "lubm": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
  "geodcatap": "http://data.europa.eu/930/",
  "aaao": "https://ontology.swissartresearch.net/aaao/",
  "submit": "https://ns.verisav.fr/dpp#",
  "dpvpd": "https://w3id.org/dpv/pd#",
  "let": "http://uispin.org/let#",
  "vlaanderen": "https://data.vlaanderen.be/ns/",
  "osmkey": "https://www.openstreetmap.org/wiki/Key:",
  "iut": "https://cours.iut-orsay.fr/",
  "idtype": "https://data.elsevier.com/e/identifier/",
  "med": "http://data.esante.gouv.fr/ansm/medicament/",
  "mdo": "http://w3id.org/mdo/",
  "plato": "https://w3id.org/plato#",
  "whg": "https://w3id.org/whg/id/",
  "mdr": "https://w3id.org/mdr#",
  "mlca": "https://w3id.org/mlca/",
  "animl": "http://www.w3id.org/animl/ontology/",
  "coord": "http://qudt.org/vocab/coordinate/",
  "tf": "https://takumifujimoto.com/schema/",
  "dbn": "https://www.darrinbaines.org/ns/identity#",
  "gid": "https://inspirewrap.ontologycentral.com/adv/gid/7.1#",
  "i40fd": "http://w3id.org/iaam/i40fd#",
  "riepr": "https://data.riepr.omgeving.vlaanderen.be/ns/riepr#",
  "lth": "https://vocab.lifetidy.com/",
  "puv": "http://data.elsevier.com/publishing/schema/puv/",
  "lack": "https://purl.net/climatesense/lack/ns#",
  "gwn": "https://globalwordnet.github.io/schemas/wn#",
  "mqto": "https://w3id.org/mqto#",
  "statdcatap": "http://data.europa.eu/s1n/",
  "norma": "https://w3id.org/def/norma-o#",
  "spectra": "https://w3id.org/spectra#",
  "bcore": "https://w3id.org/bcore/",
  "multi": "https://semanticweb.tools/ont/multi#",
  "lbco": "https://w3id.org/batcat#",
  "aic": "https://w3id.org/aic#",
  "vwcds": "https://devstack.vwgroup.com/confluence/rest/api/content/",
  "vwag": "https://devstack.vwgroup.com/",
  "tal": "http://xml.zope.org/namespaces/tal/",
  "tfo": "http://opendata.inrae.fr/PO2/Ontology/TransformON/",
  "odic": "http://tecnolettra.uji.es/ontodic#",
  "ontodic": "http://tecnolettra.uji.es/ontodic#",
  "fract": "https://w3id.org/refract#",
  "aeovis": "https://prismdiscovery.ai/ontology/aeo#",
  "faptica": "https://faptica.com/",
  "fairo": "https://w3id.org/fair-o#",
  "uogto": "https://w3id.org/uogto/core#",
  "uogtox": "https://w3id.org/uogto/extensions#",
  "copi": "https://www.inf.ufrgs.br/ontologies/copi/",
  "idsa": "https://w3id.org/idsa/core/",
  "mim": "http://modellen.mim-standaard.nl/def/mim#",
  "hon": "https://honoria.co.uk/id/honours#"
}
